<template>
  <div>
    <b-modal
      v-model="showModal"
      :title="modalTitle"
      :class="{ 'wizard-resizing': aiChatResizing }"
      size="xl"
      centered
      scrollable
      no-close-on-backdrop
      hide-footer
      modal-class="wizard-modal"
      @hidden="onHidden"
    >
      <!-- ═══ Pre-step: Mode selection ═══ -->
      <template v-if="preStep === 'choose'">
        <div class="wizard-body">
          <div class="wizard-body-full">
            <div class="wizard-mode-cards">
              <div
                class="wizard-mode-card"
                @click="preStep = 'templates'"
              >
                <div class="wizard-mode-icon">
                  &#43;
                </div>
                <div class="wizard-mode-title">
                  Создать цепочку
                </div>
                <div class="wizard-mode-desc">
                  Создать новый набор объектов по шаблону
                </div>
              </div>
              <div
                class="wizard-mode-card"
                @click="startChainPicker"
              >
                <div class="wizard-mode-icon">
                  &#9998;
                </div>
                <div class="wizard-mode-title">
                  Редактировать цепочку
                </div>
                <div class="wizard-mode-desc">
                  Изменить существующую цепочку
                </div>
              </div>
              <div
                class="wizard-mode-card"
                @click="startPodrFormPicker"
              >
                <div class="wizard-mode-icon">
                  &#127970;
                </div>
                <div class="wizard-mode-title">
                  Форма Подразделение
                </div>
                <div class="wizard-mode-desc">
                  Создать форму по подразделению на основе существующей
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- ═══ Pre-step: Template selection ═══ -->
      <template v-if="preStep === 'templates'">
        <div class="wizard-body">
          <div class="wizard-body-full">
            <div class="wizard-template-list">
              <div
                class="wizard-template-card"
                @click="selectTemplate('budget')"
              >
                <div class="wizard-template-title">
                  Бюджетная цепочка
                </div>
                <div class="wizard-template-chain">
                  <span class="wizard-meta-badge wizard-meta-form">form</span>
                  <span class="wizard-template-arrow">&rarr;</span>
                  <span class="wizard-meta-badge wizard-meta-cube">cube</span>
                  <span class="wizard-template-label">Ввод</span>
                  <span class="wizard-template-arrow">&rarr;</span>
                  <span class="wizard-meta-badge wizard-meta-mount">mount</span>
                  <span class="wizard-template-label">Сборка</span>
                  <span class="wizard-template-arrow">&rarr;</span>
                  <span class="wizard-meta-badge wizard-meta-cube">cube</span>
                  <span class="wizard-template-label">Итог</span>
                </div>
                <div class="wizard-template-desc">
                  Форма &rarr; Куб Ввод &rarr; 3 Сборки (главная, обработка, копирование) &rarr; Куб Сводный
                </div>
              </div>
            </div>
            <div class="wizard-footer">
              <b-button
                variant="outline-secondary"
                @click="preStep = 'choose'"
              >
                Назад
              </b-button>
              <div />
            </div>
          </div>
        </div>
      </template>

      <!-- ═══ Pre-step: Chain picker for editing ═══ -->
      <template v-if="preStep === 'chains'">
        <div class="wizard-body">
          <div class="wizard-body-full">
            <div
              v-if="chainListLoading"
              class="text-center py-3"
            >
              <b-spinner variant="primary" />
              <p class="mt-1 text-muted">
                Загрузка списка цепочек...
              </p>
            </div>
            <template v-else-if="chainList.length === 0">
              <div class="text-center py-3 text-muted">
                <p>Нет доступных цепочек для редактирования.</p>
                <p class="small">
                  Цепочки создаются через мастер и получают chain_id автоматически.
                </p>
              </div>
            </template>
            <template v-else>
              <div class="wizard-chain-toolbar">
                <input
                  v-model="chainSearch"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Поиск по названию..."
                >
                <select
                  v-model="chainTemplateFilter"
                  class="form-control form-control-sm wizard-chain-template-select"
                >
                  <option value="">
                    Все шаблоны
                  </option>
                  <option
                    v-for="t in chainTemplateOptions"
                    :key="t"
                    :value="t"
                  >
                    {{ t }}
                  </option>
                </select>
              </div>
              <div class="wizard-chain-list">
                <div
                  v-for="chain in filteredChainList"
                  :key="chain.chainId"
                  class="wizard-chain-list-item"
                  @click="pickChainForEdit(chain)"
                >
                  <div class="wizard-chain-list-name">
                    {{ chain.name }}
                  </div>
                  <div class="wizard-chain-list-objects">
                    <span
                      v-for="obj in chain.objects"
                      :key="obj.id"
                      class="wizard-chain-list-obj"
                    >
                      <span
                        class="wizard-meta-badge"
                        :class="'wizard-meta-' + obj.meta"
                      >{{ obj.meta }}</span>
                      {{ obj.name }}
                    </span>
                  </div>
                  <div class="wizard-chain-list-id">
                    {{ chain.chainId }}
                  </div>
                </div>
              </div>
              <div
                v-if="filteredChainList.length === 0"
                class="text-center py-2 text-muted small"
              >
                Ничего не найдено
              </div>
            </template>
            <div class="wizard-footer">
              <b-button
                variant="outline-secondary"
                @click="preStep = 'choose'"
              >
                Назад
              </b-button>
              <div />
            </div>
          </div>
        </div>
      </template>

      <!-- ═══ Pre-step: Form picker for Подразделение ═══ -->
      <template v-if="preStep === 'pick-form'">
        <div class="wizard-body">
          <div class="wizard-body-full">
            <div
              v-if="podrFormListLoading"
              class="text-center py-3"
            >
              <b-spinner variant="primary" />
              <p class="mt-1 text-muted">
                Загрузка списка форм...
              </p>
            </div>
            <template v-else>
              <div class="wizard-chain-toolbar">
                <input
                  v-model="podrFormSearch"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Поиск формы..."
                >
              </div>
              <div class="wizard-chain-list">
                <div
                  v-for="form in filteredPodrFormList"
                  :key="form.id"
                  class="wizard-chain-list-item"
                  @click="pickFormForPodr(form)"
                >
                  <div class="wizard-chain-list-name">
                    <span class="wizard-meta-badge wizard-meta-form">form</span>
                    {{ form.name }}
                  </div>
                  <div
                    v-if="form.inputCube"
                    class="wizard-chain-list-objects"
                  >
                    <span class="wizard-chain-list-obj">
                      <span class="wizard-meta-badge wizard-meta-cube">cube</span>
                      {{ form.inputCube.name }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-if="filteredPodrFormList.length === 0"
                class="text-center py-2 text-muted small"
              >
                Нет подходящих форм
              </div>
            </template>
            <div class="wizard-footer">
              <b-button
                variant="outline-secondary"
                @click="preStep = 'choose'"
              >
                Назад
              </b-button>
              <div />
            </div>
          </div>
        </div>
      </template>

      <!-- ═══ Pre-step: Подразделение creation progress ═══ -->
      <template v-if="preStep === 'podr-create'">
        <div class="wizard-body">
          <div class="wizard-body-full">
            <h5>Создание формы "{{ podrSourceForm ? podrSourceForm.name : '' }} Подразделение"</h5>
            <b-progress
              :value="podrProgress"
              :max="100"
              class="mb-1"
              show-progress
              animated
            />
            <div
              class="wizard-log"
              style="max-height: 350px; overflow-y: auto; font-size: 0.85em;"
            >
              <div
                v-for="(line, idx) in podrLog"
                :key="idx"
                :class="{ 'text-danger': line.error, 'text-success': line.success }"
              >
                {{ line.text }}
              </div>
            </div>
            <div
              v-if="podrDone"
              class="mt-1"
            >
              <div :class="podrError ? 'alert alert-danger' : 'alert alert-success'">
                {{ podrError ? 'Произошла ошибка при создании' : 'Форма Подразделение успешно создана!' }}
              </div>
            </div>
            <div class="wizard-footer mt-1">
              <b-button
                v-if="podrDone"
                variant="outline-secondary"
                @click="preStep = 'choose'"
              >
                Закрыть
              </b-button>
              <div />
            </div>
          </div>
        </div>
      </template>

      <!-- ═══ Wizard steps (create / edit) ═══ -->
      <template v-if="preStep === null">

        <!-- Step indicator -->
        <div class="wizard-steps-bar">
          <div
            v-for="s in stepsMeta"
            :key="s.num"
            class="wizard-step-dot"
            :class="{ 'wizard-step-dot--active': step === s.num, 'wizard-step-dot--done': step > s.num }"
            @click="goToStep(s.num)"
          >
            <span class="wizard-step-num">{{ step > s.num ? '&#10003;' : s.num }}</span>
            <span class="wizard-step-label">{{ s.label }}</span>
          </div>
        </div>

        <!-- Edit mode loading spinner -->
        <div
          v-if="editLoading"
          class="text-center py-3"
        >
          <b-spinner variant="primary" />
          <p class="mt-1 text-muted">
            Загрузка цепочки...
          </p>
        </div>

        <!-- Edit mode error -->
        <div
          v-if="editError && !editLoading"
          class="wizard-edit-error"
        >
          <p><b>Ошибка загрузки цепочки:</b> {{ editError }}</p>
          <b-button
            size="sm"
            variant="outline-danger"
            @click="showModal = false"
          >
            Закрыть
          </b-button>
        </div>

        <!-- Step 1: Name -->
        <template v-if="step === 1 && !editLoading && !editError">
          <div class="wizard-body">
            <div class="wizard-body-main">
              <h6>Название области бюджета</h6>
              <div
                v-if="editMode && originalState"
                class="wizard-edit-note"
              >
                Исходное название: <b>{{ originalState.budgetName }}</b>
              </div>
              <p class="text-muted small">
                Введите короткое название. Оно подставится во все 6 объектов цепочки.
              </p>
              <b-form-input
                v-model="budgetName"
                placeholder="Расход Услуги"
                size="lg"
                autofocus
                @keydown.enter="nextStep"
              />
              <!-- Live preview of names -->
              <div
                v-if="budgetName.trim()"
                class="wizard-name-preview"
              >
                <div class="wizard-name-preview-title">
                  Будут созданы:
                </div>
                <div
                  v-for="obj in plannedObjects"
                  :key="obj.name"
                  class="wizard-name-preview-item"
                >
                  <span
                    class="wizard-meta-badge"
                    :class="'wizard-meta-' + obj.meta"
                  >{{ obj.meta }}</span>
                  {{ obj.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="wizard-footer">
            <div />
            <b-button
              variant="primary"
              :disabled="!budgetName.trim()"
              @click="nextStep"
            >
              Далее
            </b-button>
          </div>
        </template>

        <!-- Step 2: Parameters -->
        <template v-if="step === 2">
          <div class="wizard-body">
            <div class="wizard-body-main">
              <h6>Параметры формы</h6>
              <p class="text-muted small">
                Выберите параметры формы (фильтры: сценарий, период и т.д.).
              </p>
              <!-- Selected tags -->
              <div class="wizard-tags">
                <span
                  v-for="id in selectedParamIds"
                  :key="id"
                  class="wizard-tag"
                  @click="toggleParam(id)"
                >
                  {{ entityName(id) }} <span class="wizard-tag-x">&times;</span>
                </span>
              </div>
              <!-- Search -->
              <b-form-input
                v-model="paramSearch"
                size="sm"
                placeholder="Поиск сущности..."
                class="mb-50"
              />
              <!-- List -->
              <div class="wizard-pick-list">
                <div
                  v-for="ent in filteredParams"
                  :key="ent.id"
                  class="wizard-pick-item"
                  :class="{ 'wizard-pick-item--selected': selectedParamIds.includes(ent.id) }"
                  @click="toggleParam(ent.id)"
                >
                  <span class="wizard-pick-check">{{ selectedParamIds.includes(ent.id) ? '&#10003;' : '' }}</span>
                  <span class="wizard-pick-name">{{ ent.name }}</span>
                  <span class="wizard-pick-id">#{{ ent.id }}</span>
                </div>
                <div
                  v-if="filteredParams.length === 0"
                  class="text-muted small py-1 text-center"
                >
                  Нет сущностей по запросу
                </div>
              </div>
            </div>
            <!-- Side preview -->
            <div class="wizard-body-side">
              <div class="wizard-side-title">
                Объекты цепочки
              </div>
              <div class="wizard-chain-mini">
                <div
                  v-for="obj in plannedObjects"
                  :key="obj.name"
                  class="wizard-chain-mini-item"
                >
                  <span
                    class="wizard-meta-badge"
                    :class="'wizard-meta-' + obj.meta"
                  >{{ obj.meta }}</span>
                  <span class="wizard-chain-mini-name">{{ obj.shortName }}</span>
                </div>
              </div>
              <div class="wizard-side-title mt-1">
                Параметры ({{ selectedParamIds.length }})
              </div>
              <div class="wizard-side-tags">
                <span
                  v-for="id in selectedParamIds"
                  :key="id"
                  class="wizard-stag"
                >{{ entityName(id) }}</span>
                <span
                  v-if="selectedParamIds.length === 0"
                  class="text-muted"
                  style="font-size:11px"
                >(не выбраны)</span>
              </div>
            </div>
          </div>
          <div class="wizard-footer">
            <b-button
              variant="outline-secondary"
              @click="step = 1"
            >
              Назад
            </b-button>
            <b-button
              variant="primary"
              @click="nextStep"
            >
              Далее
            </b-button>
          </div>
        </template>

        <!-- Step 3: Dimensions -->
        <template v-if="step === 3">
          <div class="wizard-body">
            <div class="wizard-body-main">
              <h6>Измерения (аналитики кубов)</h6>
              <p class="text-muted small">
                Выберите аналитики — строки группировки (Подразделение, Статья ОПУ, ЦФО...).
              </p>
              <!-- Selected tags -->
              <div
                v-if="selectedDimIds.length > 0"
                class="wizard-tags"
              >
                <span
                  v-for="id in selectedDimIds"
                  :key="id"
                  class="wizard-tag"
                  @click="toggleDim(id)"
                >
                  {{ entityName(id) }} <span class="wizard-tag-x">&times;</span>
                </span>
              </div>
              <div
                v-else
                class="wizard-tags wizard-tags--empty"
              >
                <span class="text-muted small">Выберите хотя бы одно измерение</span>
              </div>
              <!-- Search -->
              <b-form-input
                v-model="dimSearch"
                size="sm"
                placeholder="Поиск сущности..."
                class="mb-50"
              />
              <!-- List -->
              <div class="wizard-pick-list">
                <div
                  v-for="ent in filteredDimensions"
                  :key="ent.id"
                  class="wizard-pick-item"
                  :class="{ 'wizard-pick-item--selected': selectedDimIds.includes(ent.id) }"
                  @click="toggleDim(ent.id)"
                >
                  <span class="wizard-pick-check">{{ selectedDimIds.includes(ent.id) ? '&#10003;' : '' }}</span>
                  <span class="wizard-pick-name">{{ ent.name }}</span>
                  <span class="wizard-pick-id">#{{ ent.id }}</span>
                </div>
                <div
                  v-if="filteredDimensions.length === 0"
                  class="text-muted small py-1 text-center"
                >
                  Нет сущностей по запросу
                </div>
              </div>
            </div>
            <!-- Side preview -->
            <div class="wizard-body-side">
              <div class="wizard-side-title">
                Параметры ({{ selectedParamIds.length }})
              </div>
              <div class="wizard-side-tags">
                <span
                  v-for="id in selectedParamIds"
                  :key="id"
                  class="wizard-stag"
                >{{ entityName(id) }}</span>
                <span
                  v-if="selectedParamIds.length === 0"
                  class="text-muted"
                  style="font-size:11px"
                >(не выбраны)</span>
              </div>
              <div class="wizard-side-title mt-1">
                Измерения ({{ selectedDimIds.length }})
              </div>
              <div class="wizard-side-tags">
                <span
                  v-for="id in selectedDimIds"
                  :key="id"
                  class="wizard-stag"
                >{{ entityName(id) }}</span>
                <span
                  v-if="selectedDimIds.length === 0"
                  class="text-muted"
                  style="font-size:11px"
                >(не выбраны)</span>
              </div>
            </div>
          </div>
          <div class="wizard-footer">
            <b-button
              variant="outline-secondary"
              @click="step = 2"
            >
              Назад
            </b-button>
            <b-button
              variant="primary"
              :disabled="selectedDimIds.length === 0"
              @click="nextStep"
            >
              Далее
            </b-button>
          </div>
        </template>

        <!-- Step 4: Input Cube fields -->
        <template v-if="step === 4">
          <div class="wizard-body">
            <div class="wizard-body-main">
              <h6>Поля куба ввода</h6>
              <p class="text-muted small">
                Стандартные поля (ID, Удал, Имя, Описание) + параметры + измерения добавляются автоматически.
                Выберите дополнительные поля (суммы, валюта, даты и т.д.).
              </p>
              <!-- Selected tags -->
              <div class="wizard-tags">
                <span class="wizard-tag wizard-tag--fixed">Стандарт (4)</span>
                <span class="wizard-tag wizard-tag--fixed">{{ selectedParamNames.join(', ') || 'Параметры' }}</span>
                <span class="wizard-tag wizard-tag--fixed">{{ selectedDimNames.join(', ') }}</span>
                <span
                  v-for="id in inputCubeFieldIds"
                  :key="id"
                  class="wizard-tag"
                  @click="toggleInputField(id)"
                >
                  {{ entityName(id) }} <span class="wizard-tag-x">&times;</span>
                </span>
              </div>
              <!-- Search -->
              <b-form-input
                v-model="inputFieldSearch"
                size="sm"
                placeholder="Поиск поля..."
                class="mb-50"
              />
              <!-- List -->
              <div class="wizard-pick-list wizard-pick-list--tall">
                <div
                  v-for="ent in filteredInputFields"
                  :key="ent.id"
                  class="wizard-pick-item"
                  :class="{ 'wizard-pick-item--selected': inputCubeFieldIds.includes(ent.id) }"
                  @click="toggleInputField(ent.id)"
                >
                  <span class="wizard-pick-check">{{ inputCubeFieldIds.includes(ent.id) ? '&#10003;' : '' }}</span>
                  <span class="wizard-pick-name">{{ ent.name }}</span>
                  <span class="wizard-pick-id">#{{ ent.id }}</span>
                </div>
                <div
                  v-if="filteredInputFields.length === 0"
                  class="text-muted small py-1 text-center"
                >
                  Нет сущностей по запросу
                </div>
              </div>
              <!-- Attribute properties: button to open modal -->
              <div
                v-if="allAttrIdsForProps.length > 0"
                class="wizard-calc-section"
              >
                <div class="wizard-calc-title">
                  Свойства атрибутов
                </div>
                <div class="wizard-calc-rows">
                  <div
                    v-for="id in allAttrIdsForProps"
                    :key="'prop-' + id"
                    class="wizard-calc-row"
                    style="cursor:pointer"
                    @click="openAttrProps(id)"
                  >
                    <span class="wizard-calc-name">{{ entityName(id) }}</span>
                    <span
                      v-if="selectedDimIds.includes(id)"
                      class="wizard-calc-dim-badge"
                    >изм</span>
                  </div>
                </div>
              </div>
              <!-- Hidden loader for cbsattributeparam objectfull -->
              <cbs-data-object
                v-if="!attrParamObjectFull"
                objectsid="cbsattributeparam"
                hide
                @load="onLoadAttrParamObj"
              />
              <!-- Hidden loader for mountstep objectfull -->
              <cbs-data-object
                v-if="!mountStepObjectFull"
                objectsid="mountstep"
                hide
                @load="obj => mountStepObjectFull = obj"
              />

            </div>
            <!-- Side panel: cube preview -->
            <!-- Resize handle + Side panel -->
            <div
              class="wizard-ai-resize-handle"
              @mousedown="aiChatResizeStart"
              @touchstart="aiChatResizeStart"
            />
            <div
              class="wizard-body-side"
              :style="{ width: aiChatWidth + 'px' }"
            >
              <div class="wizard-side-title">
                Куб Бюджет {{ n }} Ввод
              </div>
              <div class="wizard-cube-preview">
                <div class="wizard-cube-section">
                  <span class="wizard-cube-label">Стандартные (4)</span>
                  <span class="wizard-cube-fields">ID, Удал, Имя, Описание</span>
                </div>
                <div
                  v-if="selectedParamIds.length > 0"
                  class="wizard-cube-section"
                >
                  <span class="wizard-cube-label">Параметры ({{ selectedParamIds.length }})</span>
                  <span class="wizard-cube-fields">{{ selectedParamNames.join(', ') }}</span>
                </div>
                <div class="wizard-cube-section">
                  <span class="wizard-cube-label">Измерения ({{ selectedDimIds.length }})</span>
                  <span class="wizard-cube-fields">{{ selectedDimNames.join(', ') }}</span>
                </div>
                <div class="wizard-cube-section wizard-cube-section--highlight">
                  <span class="wizard-cube-label">Доп. поля ({{ inputCubeFieldIds.length }})</span>
                  <span
                    v-if="inputCubeFieldIds.length > 0"
                    class="wizard-cube-fields"
                  >{{ inputCubeFieldNames.join(', ') }}</span>
                  <span
                    v-else
                    class="wizard-cube-fields text-muted"
                  >(не выбраны)</span>
                </div>
              </div>
              <div class="wizard-side-stat">
                Итого атрибутов: <b>{{ inputCubeTotalAttrs }}</b>
              </div>
              <!-- AI Chat -->
              <wizard-ai-chat
                ref="aiChat"
                :messages="aiChatMessages"
                :input-text="aiChatInput"
                :connected="aiChatConnected"
                :waiting="aiChatWaiting"
                hint="Спросите ИИ, например: «Посмотри свойства Сумма Авг, сделай так же для других месяцев»"
                key-prefix="ai-"
                @send="aiChatSend"
                @update:inputText="aiChatInput = $event"
              />
            </div>
          </div>
          <div class="wizard-footer">
            <b-button
              variant="outline-secondary"
              @click="step = 3"
            >
              Назад
            </b-button>
            <b-button
              variant="primary"
              @click="nextStep"
            >
              Далее
            </b-button>
          </div>
        </template>

        <!-- Step 5: Form Display -->
        <template v-if="step === 5">
          <div class="wizard-body">
            <div class="wizard-body-main">
              <h6>Настройка формы</h6>
              <p class="text-muted small">
                Выберите какие атрибуты видны в форме и задайте порядок отображения. Перетаскивайте для изменения порядка.
              </p>
              <div
                v-if="formColumns.length === 0"
                class="text-muted text-center py-3"
              >
                Нет атрибутов для отображения
              </div>
              <draggable
                v-else
                v-model="formColumns"
                handle=".wizard-form-col-handle"
                animation="200"
                class="wizard-form-col-list"
              >
                <transition-group
                  type="transition"
                  name="flip-list"
                >
                  <div
                    v-for="col in formColumns"
                    :key="col.id"
                    class="wizard-form-col-item"
                    :class="{
                      'wizard-form-col-item--hidden': !col.visible,
                      'wizard-form-col-item--dim': col.type === 'dim',
                      'wizard-form-col-item--field': col.type === 'field',
                    }"
                  >
                    <span class="wizard-form-col-handle">&#9776;</span>
                    <span
                      class="wizard-form-col-type-badge"
                      :class="col.type === 'dim' ? 'wizard-meta-cube' : 'wizard-meta-mount'"
                    >{{ col.type === 'dim' ? 'изм' : 'поле' }}</span>
                    <span class="wizard-form-col-name">{{ col.name }}</span>
                    <span class="wizard-pick-id">#{{ col.id }}</span>
                    <label
                      class="wizard-form-col-editable"
                      :title="col.editable ? 'Запретить редактирование' : 'Разрешить редактирование'"
                    >
                      <input
                        type="checkbox"
                        :checked="col.editable"
                        @change="toggleFormColEditable(col)"
                      >
                      <span class="wizard-form-col-editable-label">ред.</span>
                    </label>
                    <button
                      class="wizard-form-col-toggle"
                      :class="{ 'wizard-form-col-toggle--off': !col.visible }"
                      :title="col.visible ? 'Скрыть' : 'Показать'"
                      @click="toggleFormColVisible(col)"
                    >
                      {{ col.visible ? '&#10003;' : '&#10007;' }}
                    </button>
                  </div>
                </transition-group>
              </draggable>
              <div
                v-if="formColumns.filter(c => c.type === 'dim' && c.visible).length <= 1 && formColumns.some(c => c.type === 'dim')"
                class="wizard-form-col-warn"
              >
                Нельзя скрыть последнее измерение
              </div>
            </div>
            <!-- Side panel: form preview -->
            <div class="wizard-body-side">
              <div class="wizard-side-title">
                Превью формы
              </div>
              <div
                v-if="visibleFormColumns.length > 0"
                class="wizard-form-preview"
              >
                <div class="wizard-form-preview-header">
                  <span
                    v-for="c in visibleFormColumns"
                    :key="'ph-' + c.id"
                    class="wizard-form-preview-th"
                    :class="c.type === 'dim' ? 'wizard-form-preview-th--dim' : 'wizard-form-preview-th--field'"
                  >{{ c.name }}</span>
                </div>
                <div class="wizard-form-preview-row">
                  <span
                    v-for="c in visibleFormColumns"
                    :key="'pd-' + c.id"
                    class="wizard-form-preview-td"
                    :class="{ 'wizard-form-preview-td--readonly': c.editable === false }"
                    :title="c.editable === false ? 'Только чтение' : ''"
                  >{{ c.editable === false ? '&#128274;' : '...' }}</span>
                </div>
              </div>
              <div
                v-else
                class="text-muted small text-center py-2"
              >
                Нет видимых атрибутов
              </div>
              <div class="wizard-side-stat mt-1">
                Видимых: <b>{{ visibleFormColumns.length }}</b> из {{ formColumns.length }}
              </div>
              <div class="wizard-side-stat">
                Измерений: <b>{{ visibleFormDimIds.length }}</b>, полей: <b>{{ visibleFormFieldIds.length }}</b>
              </div>
            </div>
          </div>
          <div class="wizard-footer">
            <b-button
              variant="outline-secondary"
              @click="step = 4"
            >
              Назад
            </b-button>
            <b-button
              variant="primary"
              :disabled="visibleFormDimIds.length === 0"
              @click="nextStep"
            >
              Далее
            </b-button>
          </div>
        </template>

        <!-- Step 6: Summary Cube fields -->
        <template v-if="step === 6">
          <div class="wizard-body">
            <div class="wizard-body-main">
              <h6>Поля сводного куба</h6>
              <p class="text-muted small">
                Стандартные + параметры + измерения добавляются автоматически.
                Выберите дополнительные поля сводного куба (дата, валюта, суммы и т.д.).
              </p>
              <!-- Selected tags -->
              <div class="wizard-tags">
                <span class="wizard-tag wizard-tag--fixed">Стандарт (4)</span>
                <span class="wizard-tag wizard-tag--fixed">{{ selectedParamNames.join(', ') || 'Параметры' }}</span>
                <span class="wizard-tag wizard-tag--fixed">{{ selectedDimNames.join(', ') }}</span>
                <span
                  v-for="id in summaryCubeFieldIds"
                  :key="id"
                  class="wizard-tag"
                  @click="toggleSummaryField(id)"
                >
                  {{ entityName(id) }} <span class="wizard-tag-x">&times;</span>
                </span>
              </div>
              <!-- Search -->
              <b-form-input
                v-model="summaryFieldSearch"
                size="sm"
                placeholder="Поиск поля..."
                class="mb-50"
              />
              <!-- List -->
              <div class="wizard-pick-list wizard-pick-list--tall">
                <div
                  v-for="ent in filteredSummaryFields"
                  :key="ent.id"
                  class="wizard-pick-item"
                  :class="{ 'wizard-pick-item--selected': summaryCubeFieldIds.includes(ent.id) }"
                  @click="toggleSummaryField(ent.id)"
                >
                  <span class="wizard-pick-check">{{ summaryCubeFieldIds.includes(ent.id) ? '&#10003;' : '' }}</span>
                  <span class="wizard-pick-name">{{ ent.name }}</span>
                  <span class="wizard-pick-id">#{{ ent.id }}</span>
                </div>
                <div
                  v-if="filteredSummaryFields.length === 0"
                  class="text-muted small py-1 text-center"
                >
                  Нет сущностей по запросу
                </div>
              </div>
            </div>
            <!-- Side preview: cube structure -->
            <div class="wizard-body-side">
              <div class="wizard-side-title">
                Куб Бюджет {{ n }}
              </div>
              <div class="wizard-cube-preview">
                <div class="wizard-cube-section">
                  <span class="wizard-cube-label">Стандартные (4)</span>
                  <span class="wizard-cube-fields">ID, Удал, Имя, Описание</span>
                </div>
                <div
                  v-if="selectedParamIds.length > 0"
                  class="wizard-cube-section"
                >
                  <span class="wizard-cube-label">Параметры ({{ selectedParamIds.length }})</span>
                  <span class="wizard-cube-fields">{{ selectedParamNames.join(', ') }}</span>
                </div>
                <div class="wizard-cube-section">
                  <span class="wizard-cube-label">Измерения ({{ selectedDimIds.length }})</span>
                  <span class="wizard-cube-fields">{{ selectedDimNames.join(', ') }}</span>
                </div>
                <div class="wizard-cube-section wizard-cube-section--highlight">
                  <span class="wizard-cube-label">Доп. поля ({{ summaryCubeFieldIds.length }})</span>
                  <span
                    v-if="summaryCubeFieldIds.length > 0"
                    class="wizard-cube-fields"
                  >{{ summaryCubeFieldNames.join(', ') }}</span>
                  <span
                    v-else
                    class="wizard-cube-fields text-muted"
                  >(не выбраны)</span>
                </div>
              </div>
              <div class="wizard-side-stat">
                Итого атрибутов: <b>{{ summaryCubeTotalAttrs }}</b>
              </div>
            </div>
          </div>
          <div class="wizard-footer">
            <b-button
              variant="outline-secondary"
              @click="step = 5"
            >
              Назад
            </b-button>
            <b-button
              variant="primary"
              @click="nextStep"
            >
              Далее
            </b-button>
          </div>
        </template>

        <!-- Step 7: Assembly Processing steps -->
        <template v-if="step === 7">
          <!-- Fields reference panel -->
          <div class="wizard-fields-ref">
            <div
              class="wizard-fields-ref-header"
              @click="showFieldsRef = !showFieldsRef"
            >
              <span class="wizard-fields-ref-toggle">{{ showFieldsRef ? '&#9660;' : '&#9654;' }}</span>
              <span class="wizard-fields-ref-title">Поля кубов</span>
              <span class="wizard-fields-ref-counts">
                Ввод: {{ inputCubeTotalAttrs }} &middot; Сводный: {{ summaryCubeTotalAttrs }}
              </span>
            </div>
            <div
              v-if="showFieldsRef"
              class="wizard-fields-ref-body"
            >
              <div class="wizard-fields-ref-col">
                <div class="wizard-fields-ref-col-title">
                  <span class="wizard-meta-badge wizard-meta-cube">cube</span> Куб Ввод
                  <span class="wizard-fields-ref-count">({{ inputCubeTotalAttrs }})</span>
                </div>
                <div class="wizard-fields-ref-chips">
                  <span class="wizard-fields-ref-chip wizard-fields-ref-chip--std">Стандарт (4)</span>
                  <span
                    v-for="id in selectedParamIds"
                    :key="'ip7-'+id"
                    class="wizard-fields-ref-chip wizard-fields-ref-chip--param"
                  >{{ entityName(id) }}</span>
                  <span
                    v-for="id in selectedDimIds"
                    :key="'id7-'+id"
                    class="wizard-fields-ref-chip wizard-fields-ref-chip--dim"
                  >{{ entityName(id) }}</span>
                  <span
                    v-for="id in inputCubeFieldIds"
                    :key="'if7-'+id"
                    class="wizard-fields-ref-chip wizard-fields-ref-chip--field"
                  >{{ entityName(id) }}</span>
                </div>
              </div>
              <div class="wizard-fields-ref-col">
                <div class="wizard-fields-ref-col-title">
                  <span class="wizard-meta-badge wizard-meta-cube">cube</span> Куб Сводный
                  <span class="wizard-fields-ref-count">({{ summaryCubeTotalAttrs }})</span>
                </div>
                <div class="wizard-fields-ref-chips">
                  <span class="wizard-fields-ref-chip wizard-fields-ref-chip--std">Стандарт (4)</span>
                  <span
                    v-for="id in selectedParamIds"
                    :key="'sp7-'+id"
                    class="wizard-fields-ref-chip wizard-fields-ref-chip--param"
                  >{{ entityName(id) }}</span>
                  <span
                    v-for="id in selectedDimIds"
                    :key="'sd7-'+id"
                    class="wizard-fields-ref-chip wizard-fields-ref-chip--dim"
                  >{{ entityName(id) }}</span>
                  <span
                    v-for="id in summaryCubeFieldIds"
                    :key="'sf7-'+id"
                    class="wizard-fields-ref-chip wizard-fields-ref-chip--field"
                  >{{ entityName(id) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="wizard-body">
            <div class="wizard-body-main">
              <h6>Сборка Обработка</h6>
              <template v-if="editMode && created.procAsmId">
                <div
                  v-if="!mountStepObjectFull"
                  class="text-muted small py-2"
                >
                  Загрузка...
                </div>
                <cbs-object-table
                  v-else
                  key="mount-step-proc"
                  :object-full="mountStepObjectFull"
                  :filter="mountStepFilter(created.procAsmId)"
                />
              </template>
              <div
                v-else
                class="text-muted small py-2"
              >
                Шаги сборки будут доступны после создания цепочки (в режиме редактирования).
              </div>
            </div>
            <!-- AI Chat -->
            <div
              class="wizard-ai-resize-handle"
              @mousedown="aiChatResizeStart"
              @touchstart="aiChatResizeStart"
            />
            <div
              class="wizard-body-side wizard-body-side--ai"
              :style="{ width: aiChatWidth + 'px' }"
            >
              <wizard-ai-chat
                ref="aiChat"
                :messages="aiChatMessages"
                :input-text="aiChatInput"
                :connected="aiChatConnected"
                :waiting="aiChatWaiting"
                hint="Спросите ИИ, например: «Посмотри свойства атрибутов Сумма Авг, сделай так же для остальных месяцев»"
                key-prefix="ai7-"
                tall
                @send="aiChatSend"
                @update:inputText="aiChatInput = $event"
              />
            </div>
          </div>
          <div class="wizard-footer">
            <b-button
              variant="outline-secondary"
              @click="step = 6"
            >
              Назад
            </b-button>
            <b-button
              variant="primary"
              @click="nextStep"
            >
              Далее
            </b-button>
          </div>
        </template>

        <!-- Step 8: Assembly Copy steps -->
        <template v-if="step === 8">
          <!-- Fields reference panel -->
          <div class="wizard-fields-ref">
            <div
              class="wizard-fields-ref-header"
              @click="showFieldsRef = !showFieldsRef"
            >
              <span class="wizard-fields-ref-toggle">{{ showFieldsRef ? '&#9660;' : '&#9654;' }}</span>
              <span class="wizard-fields-ref-title">Поля кубов</span>
              <span class="wizard-fields-ref-counts">
                Ввод: {{ inputCubeTotalAttrs }} &middot; Сводный: {{ summaryCubeTotalAttrs }}
              </span>
            </div>
            <div
              v-if="showFieldsRef"
              class="wizard-fields-ref-body"
            >
              <div class="wizard-fields-ref-col">
                <div class="wizard-fields-ref-col-title">
                  <span class="wizard-meta-badge wizard-meta-cube">cube</span> Куб Ввод
                  <span class="wizard-fields-ref-count">({{ inputCubeTotalAttrs }})</span>
                </div>
                <div class="wizard-fields-ref-chips">
                  <span class="wizard-fields-ref-chip wizard-fields-ref-chip--std">Стандарт (4)</span>
                  <span
                    v-for="id in selectedParamIds"
                    :key="'ip8-'+id"
                    class="wizard-fields-ref-chip wizard-fields-ref-chip--param"
                  >{{ entityName(id) }}</span>
                  <span
                    v-for="id in selectedDimIds"
                    :key="'id8-'+id"
                    class="wizard-fields-ref-chip wizard-fields-ref-chip--dim"
                  >{{ entityName(id) }}</span>
                  <span
                    v-for="id in inputCubeFieldIds"
                    :key="'if8-'+id"
                    class="wizard-fields-ref-chip wizard-fields-ref-chip--field"
                  >{{ entityName(id) }}</span>
                </div>
              </div>
              <div class="wizard-fields-ref-col">
                <div class="wizard-fields-ref-col-title">
                  <span class="wizard-meta-badge wizard-meta-cube">cube</span> Куб Сводный
                  <span class="wizard-fields-ref-count">({{ summaryCubeTotalAttrs }})</span>
                </div>
                <div class="wizard-fields-ref-chips">
                  <span class="wizard-fields-ref-chip wizard-fields-ref-chip--std">Стандарт (4)</span>
                  <span
                    v-for="id in selectedParamIds"
                    :key="'sp8-'+id"
                    class="wizard-fields-ref-chip wizard-fields-ref-chip--param"
                  >{{ entityName(id) }}</span>
                  <span
                    v-for="id in selectedDimIds"
                    :key="'sd8-'+id"
                    class="wizard-fields-ref-chip wizard-fields-ref-chip--dim"
                  >{{ entityName(id) }}</span>
                  <span
                    v-for="id in summaryCubeFieldIds"
                    :key="'sf8-'+id"
                    class="wizard-fields-ref-chip wizard-fields-ref-chip--field"
                  >{{ entityName(id) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="wizard-body">
            <div class="wizard-body-main">
              <h6>Сборка Копирование</h6>
              <template v-if="editMode && created.copyAsmId">
                <div
                  v-if="!mountStepObjectFull"
                  class="text-muted small py-2"
                >
                  Загрузка...
                </div>
                <cbs-object-table
                  v-else
                  key="mount-step-copy"
                  :object-full="mountStepObjectFull"
                  :filter="mountStepFilter(created.copyAsmId)"
                />
              </template>
              <div
                v-else
                class="text-muted small py-2"
              >
                Шаги сборки будут доступны после создания цепочки (в режиме редактирования).
              </div>
            </div>
            <!-- AI Chat -->
            <div
              class="wizard-ai-resize-handle"
              @mousedown="aiChatResizeStart"
              @touchstart="aiChatResizeStart"
            />
            <div
              class="wizard-body-side wizard-body-side--ai"
              :style="{ width: aiChatWidth + 'px' }"
            >
              <wizard-ai-chat
                ref="aiChat"
                :messages="aiChatMessages"
                :input-text="aiChatInput"
                :connected="aiChatConnected"
                :waiting="aiChatWaiting"
                hint="Спросите ИИ, например: «Настрой копирование полей из куба ввода в сводный»"
                key-prefix="ai8-"
                tall
                @send="aiChatSend"
                @update:inputText="aiChatInput = $event"
              />
            </div>
          </div>
          <div class="wizard-footer">
            <b-button
              variant="outline-secondary"
              @click="step = 7"
            >
              Назад
            </b-button>
            <b-button
              variant="primary"
              @click="nextStep"
            >
              Далее
            </b-button>
          </div>
        </template>

        <!-- Step 9: Review — visual chain diagram -->
        <template v-if="step === 9">
          <div class="wizard-body">
            <div class="wizard-body-full">
              <h6>Обзор цепочки</h6>

              <!-- Visual chain diagram -->
              <div class="wizard-chain">
                <!-- Form -->
                <div class="wizard-chain-card wizard-chain-card--form">
                  <div class="wizard-chain-card-header">
                    <span class="wizard-meta-badge wizard-meta-form">form</span>
                    Форма Бюджет {{ n }}
                  </div>
                  <div class="wizard-chain-card-body">
                    <div class="wizard-chain-attrs">
                      <span class="wizard-chain-attr-label">Параметры:</span>
                      {{ selectedParamNames.length ? selectedParamNames.join(', ') : '(не выбраны)' }}
                    </div>
                  </div>
                </div>

                <div class="wizard-chain-arrow">
                  &#9660; открывает
                </div>

                <!-- Input Cube -->
                <div class="wizard-chain-card wizard-chain-card--cube">
                  <div class="wizard-chain-card-header">
                    <span class="wizard-meta-badge wizard-meta-cube">cube</span>
                    Куб Бюджет {{ n }} Ввод
                  </div>
                  <div class="wizard-chain-card-body">
                    <div class="wizard-chain-attrs">
                      <span class="wizard-chain-attr-label">Атрибуты ({{ inputCubeTotalAttrs }}):</span>
                      стандарт(4) + параметры({{ selectedParamIds.length }}) + измерения({{ selectedDimIds.length }}) + доп.({{ inputCubeFieldIds.length }})
                    </div>
                    <div
                      v-if="inputCubeFieldIds.length > 0"
                      class="wizard-chain-detail"
                    >
                      Доп: {{ inputCubeFieldNames.join(', ') }}
                    </div>
                  </div>
                </div>

                <div class="wizard-chain-arrow-split">
                  <div class="wizard-chain-arrow">
                    &#9660; обрабатывает
                  </div>
                  <div class="wizard-chain-arrow">
                    &#9660; копирует в
                  </div>
                </div>

                <!-- Two columns: processing / summary + copy -->
                <div class="wizard-chain-row">
                  <!-- Left: Main Assembly & Processing -->
                  <div class="wizard-chain-col">
                    <div class="wizard-chain-card wizard-chain-card--mount">
                      <div class="wizard-chain-card-header">
                        <span class="wizard-meta-badge wizard-meta-mount">mount</span>
                        Сборка Бюджет {{ n }}
                      </div>
                      <div class="wizard-chain-card-body">
                        <div class="wizard-chain-step">
                          1. mount &rarr; Обработка
                        </div>
                        <div class="wizard-chain-step">
                          2. mount &rarr; Копирование
                        </div>
                      </div>
                    </div>

                    <div class="wizard-chain-arrow">
                      &#9660;
                    </div>

                    <div class="wizard-chain-card wizard-chain-card--mount">
                      <div class="wizard-chain-card-header">
                        <span class="wizard-meta-badge wizard-meta-mount">mount</span>
                        Сборка ... Обработка
                      </div>
                      <div class="wizard-chain-card-body">
                        <div class="wizard-chain-detail">
                          Шаги пустые — настроите вручную после создания
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Right: Summary cube + Copy -->
                  <div class="wizard-chain-col">
                    <div class="wizard-chain-card wizard-chain-card--cube">
                      <div class="wizard-chain-card-header">
                        <span class="wizard-meta-badge wizard-meta-cube">cube</span>
                        Куб Бюджет {{ n }}
                      </div>
                      <div class="wizard-chain-card-body">
                        <div class="wizard-chain-attrs">
                          <span class="wizard-chain-attr-label">Атрибуты ({{ summaryCubeTotalAttrs }}):</span>
                          стандарт + параметры + измерения + доп.({{ summaryCubeFieldIds.length }})
                        </div>
                        <div
                          v-if="summaryCubeFieldIds.length > 0"
                          class="wizard-chain-detail"
                        >
                          Доп: {{ summaryCubeFieldNames.join(', ') }}
                        </div>
                      </div>
                    </div>

                    <div class="wizard-chain-arrow">
                      &#9650; заполняет
                    </div>

                    <div class="wizard-chain-card wizard-chain-card--mount">
                      <div class="wizard-chain-card-header">
                        <span class="wizard-meta-badge wizard-meta-mount">mount</span>
                        Сборка ... Копировать
                      </div>
                      <div class="wizard-chain-card-body">
                        <div class="wizard-chain-detail">
                          Шаги пустые — настроите вручную после создания
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Summary info -->
              <div
                v-if="!editMode"
                class="wizard-review-summary"
              >
                <div class="wizard-review-stat">
                  <span class="wizard-review-stat-num">6</span> объектов
                </div>
                <div class="wizard-review-stat">
                  <span class="wizard-review-stat-num">2</span> шага (главная сборка)
                </div>
                <div class="wizard-review-stat">
                  <span class="wizard-review-stat-num">{{ totalAttrsCount }}</span> атрибутов
                </div>
              </div>

              <!-- Edit mode: diff summary -->
              <div
                v-if="editMode && editDiff"
                class="wizard-diff-summary"
              >
                <div class="wizard-diff-title">
                  Изменения:
                </div>
                <div
                  v-if="noChanges"
                  class="text-muted small"
                >
                  Нет изменений
                </div>
                <template v-else>
                  <div
                    v-if="editDiff.nameChanged"
                    class="wizard-diff-item wizard-diff-changed"
                  >
                    Переименование: {{ originalState.budgetName }} &rarr; {{ budgetName.trim() }}
                  </div>
                  <div
                    v-for="id in editDiff.paramsAdded"
                    :key="'pa-'+id"
                    class="wizard-diff-item wizard-diff-added"
                  >
                    + Параметр: {{ entityName(id) }}
                  </div>
                  <div
                    v-for="id in editDiff.paramsRemoved"
                    :key="'pr-'+id"
                    class="wizard-diff-item wizard-diff-removed"
                  >
                    - Параметр: {{ entityName(id) }}
                  </div>
                  <div
                    v-for="id in editDiff.dimsAdded"
                    :key="'da-'+id"
                    class="wizard-diff-item wizard-diff-added"
                  >
                    + Измерение: {{ entityName(id) }}
                  </div>
                  <div
                    v-for="id in editDiff.dimsRemoved"
                    :key="'dr-'+id"
                    class="wizard-diff-item wizard-diff-removed"
                  >
                    - Измерение: {{ entityName(id) }}
                  </div>
                  <div
                    v-for="id in editDiff.inputFieldsAdded"
                    :key="'ifa-'+id"
                    class="wizard-diff-item wizard-diff-added"
                  >
                    + Поле ввода: {{ entityName(id) }}
                  </div>
                  <div
                    v-for="id in editDiff.inputFieldsRemoved"
                    :key="'ifr-'+id"
                    class="wizard-diff-item wizard-diff-removed"
                  >
                    - Поле ввода: {{ entityName(id) }}
                  </div>
                  <div
                    v-for="id in editDiff.summaryFieldsAdded"
                    :key="'sfa-'+id"
                    class="wizard-diff-item wizard-diff-added"
                  >
                    + Поле сводного: {{ entityName(id) }}
                  </div>
                  <div
                    v-for="id in editDiff.summaryFieldsRemoved"
                    :key="'sfr-'+id"
                    class="wizard-diff-item wizard-diff-removed"
                  >
                    - Поле сводного: {{ entityName(id) }}
                  </div>
                  <div
                    v-if="editDiff.formColumnsChanged"
                    class="wizard-diff-item wizard-diff-changed"
                  >
                    Настройки формы (видимость/порядок) изменены
                  </div>
                  <div
                    v-if="editDiff.formParamChanged"
                    class="wizard-diff-item wizard-diff-changed"
                  >
                    form_param будет перестроен
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="wizard-footer">
            <b-button
              variant="outline-secondary"
              @click="step = 8"
            >
              Назад
            </b-button>
            <b-button
              v-if="editMode"
              variant="warning"
              size="lg"
              :disabled="noChanges"
              @click="runEdit"
            >
              Применить изменения
            </b-button>
            <b-button
              v-else
              variant="success"
              size="lg"
              @click="runCreation"
            >
              Создать цепочку
            </b-button>
          </div>
        </template>

        <!-- Step 10: Progress -->
        <template v-if="step === 10">
          <div class="wizard-body">
            <div class="wizard-body-full">
              <h6>{{ editMode ? 'Применение изменений' : 'Создание объектов' }}</h6>
              <b-progress
                :value="progressPercent"
                :max="100"
                show-progress
                animated
                class="mb-1"
                :variant="creationError ? 'danger' : (creationDone ? 'success' : 'primary')"
              />
              <div
                ref="logBox"
                class="wizard-log"
              >
                <div
                  v-for="(entry, i) in log"
                  :key="i"
                  :class="'wizard-log-' + entry.type"
                >
                  {{ entry.text }}
                </div>
              </div>
            </div>
          </div>
          <div class="wizard-footer">
            <div />
            <div
              class="d-flex"
              style="gap:8px"
            >
              <b-button
                v-if="creationDone && !creationError"
                variant="success"
                @click="finish"
              >
                Готово
              </b-button>
              <b-button
                v-if="creationError"
                variant="warning"
                @click="runCreation"
              >
                Повторить
              </b-button>
              <b-button
                v-if="creationError"
                variant="outline-secondary"
                @click="finish"
              >
                Закрыть
              </b-button>
            </div>
          </div>
        </template>

      </template><!-- /preStep === null -->
    </b-modal>

    <!-- ═══ Attribute properties modal ═══ -->
    <b-modal
      v-model="showAttrPropsModal"
      :title="'Свойства атрибута: ' + (attrPropsEntityId ? entityName(attrPropsEntityId) : '')"
      size="xl"
      scrollable
      hide-footer
      no-enforce-focus
      modal-class="wizard-attr-props-modal"
      body-class="p-1"
    >
      <div
        v-if="!attrPropsEntityId || !getAttributeId(attrPropsEntityId)"
        class="text-muted small"
        style="padding:12px 0"
      >
        Атрибут ещё не создан (куб не сохранён). Свойства будут доступны после сохранения.
      </div>
      <div
        v-else-if="!attrParamObjectFull"
        class="text-muted small"
        style="padding:12px 0"
      >
        Загрузка cbsattributeparam...
      </div>
      <cbs-object-table
        v-else
        :key="'attrparam-modal-' + attrPropsEntityId"
        :object-full="attrParamObjectFull"
        :filter="attrParamFilter(attrPropsEntityId)"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormInput, BButton, BProgress, BSpinner,
} from 'bootstrap-vue'
import draggable from 'vuedraggable'
import useJwt from '@/cubus/jwt/useJwt'
import recordApi from '@/cubus/services/cubusRecordApi'
import { getConfig } from '@/libs/axios'
import CbsObjectTable from '@/cubus/components/object/CbsObjectTable.vue'
import CbsDataObject from '@/cubus/components/query/CbsDataObject.vue'
import WizardAiChat from './WizardAiChat.vue'

// Debug logger — only outputs in development builds (tree-shaken in production)
const isDev = process.env.NODE_ENV === 'development'
// eslint-disable-next-line no-unused-vars
const dbg = (...args) => { if (isDev) console.log(...args) }

// Standard entities always added automatically
const STANDARD_IDS = new Set([1, 11, 3, 4]) // id, del, name, descr

const WS_TIMEOUT = 30000

// Entity IDs → default_value modification (operSid + ref)
const DEFAULT_VALUE_PROPS = {
  // Валюта: removed — currency ID is environment-specific; user should configure via the wizard UI
  // Автор → function "Текущий Пользователь"
  3676: {
    operSid: 'function',
    ref: { value: 76, sid: '334570a0-2515-47d8-8a18-ef409f009087', title: 'Текущий Пользователь' },
  },
  // Created At → function "Now"
  3659: {
    operSid: 'function',
    ref: { value: 5, sid: '7133fb65-1180-4243-8dd9-e87e0f0f5273', title: 'Now' },
  },
}

// Formula-based default_value for dimension entities (entityId → formulaId)
// Подразделение УО, ЦФО → "Подразделение Пользователя" formula
const DIMENSION_FORMULA_DEFAULTS = {
  125: { id: 190, sid: 'd27e1968-eaf6-4ba4-ab00-56666f1ae0b5', title: 'Подразделение Пользователя' }, // Подразделение УО
  211: { id: 190, sid: 'd27e1968-eaf6-4ba4-ab00-56666f1ae0b5', title: 'Подразделение Пользователя' }, // ЦФО
}

export default {
  name: 'CbsConstructorChainWizard',
  components: {
    BModal, BFormInput, BButton, BProgress, BSpinner, CbsObjectTable, CbsDataObject, draggable, WizardAiChat,
  },
  props: {
    visible: { type: Boolean, default: false },
    allEntities: { type: Array, default: () => [] },
    ws: { default: null },
    getToken: { type: Function, default: () => '' },
    mountOperands: { type: Array, default: () => [] },
    allObjects: { type: Array, default: () => [] },
    editChainId: { type: String, default: null },
  },
  data() {
    return {
      step: 1,
      budgetName: '',
      // Step 2: params
      selectedParamIds: [],
      paramSearch: '',
      // Step 3: dimensions
      selectedDimIds: [],
      dimSearch: '',
      // Step 4: input cube extra fields
      inputCubeFieldIds: [],
      inputFieldSearch: '',
      // Step 4b: attribute properties — modal with CbsObjectTable for cbsattributeparam
      showAttrPropsModal: false,
      attrPropsEntityId: null, // entityId of selected attribute for modal
      attrParamObjectFull: null, // objectfull for cbsattributeparam (loaded once)
      inputCubeAttributes: [], // attributes array from input cube objectfull [{attributeid, entityid, label, ...}]
      // Step 5: form display columns
      formColumns: [], // [{ id, type: 'dim'|'field', name, visible, editable }]
      // Step 6: summary cube extra fields
      summaryCubeFieldIds: [],
      summaryFieldSearch: '',
      // Step 7-8: assembly steps (CbsObjectTable for mountstep)
      mountStepObjectFull: null,
      showFieldsRef: false, // collapsible fields reference panel on steps 7-8
      // AI chat panel (steps 4, 7, 8)
      aiChatMessages: [],
      aiChatInput: '',
      aiChatWs: null,
      aiChatConnected: false,
      aiChatWaiting: false,
      aiChatReconnectTimer: null,
      aiChatReconnectAttempts: 0,
      aiChatWidth: 280, // resizable width
      aiChatResizing: false,
      aiChatAttrProps: null, // loaded attribute properties for AI context { [attributeId]: [{paramname, jsonmod, ...}] }
      aiChatOperandRefs: {}, // { formula: [{value,sid,title},...], function: [...], scalar: [...] }
      aiChatOperandRefsLoading: false,
      aiChatModOperRefs: null, // modoper entity refs: [{value,sid,title}] — real modification operand IDs
      aiChatRefDetails: {}, // { formula: { [id]: [{ partType, partTypeSid, entity, entityId, sql, order }] }, function: { [id]: { oper, args: [{typeSid, refTitle, refId}] } } }
      aiChatRefDetailsLoading: false,
      aiChatAttrRefMap: null, // { [entityId]: { function: [{id,title,reason}], formula: [...], scalar: [...] } } — relevant refs per attribute
      aiChatPendingActions: [], // actions awaiting user confirmation (after operand type auto-correction)
      aiChatNeedsContext: true, // send full context only when needed (first msg, after actions, step change)
      aiChatLastStep: null, // track step changes to auto-clear history
      aiChatMountSteps: null, // loaded mount step records for current assembly { [asmId]: [{id, name, ordernum, operSid, mappings}] }
      // Step 10: progress
      log: [],
      progressPercent: 0,
      creationDone: false,
      creationError: false,
      // created object ids (for retry support)
      created: {
        formId: null,
        inputCubeId: null,
        summaryCubeId: null,
        mainAsmId: null,
        procAsmId: null,
        copyAsmId: null,
      },
      phasesDone: {
        objects: false, attrs: false, props: false, steps: false, params: false, chainId: false,
      },
      // Pre-step: mode selection / template / chain list
      preStep: 'choose', // 'choose' | 'templates' | 'chains' | null
      chainList: [],
      chainListLoading: false,
      chainSearch: '',
      chainTemplateFilter: '',
      // Подразделение form creation
      podrFormList: [],
      podrFormListLoading: false,
      podrFormSearch: '',
      podrSourceForm: null, // selected source form { id, name, inputCube: { id, name } }
      podrLog: [],
      podrProgress: 0,
      podrDone: false,
      podrError: false,
      // Edit mode
      chainId: null,
      editMode: false,
      originalState: null,
      editLoading: false,
      editError: null,
    }
  },
  computed: {
    showModal: {
      get() { return this.visible },
      set(v) { this.$emit('update:visible', v) },
    },
    modalTitle() {
      if (this.preStep === 'choose') return 'Мастер бюджетной цепочки'
      if (this.preStep === 'templates') return 'Выбор шаблона'
      if (this.preStep === 'chains') return 'Выбор цепочки для редактирования'
      if (this.preStep === 'pick-form') return 'Выбор формы для создания версии Подразделение'
      if (this.preStep === 'podr-create') return 'Создание формы Подразделение'
      if (this.editMode) return 'Редактирование бюджетной цепочки'
      return 'Мастер бюджетной цепочки'
    },
    stepsMeta() {
      return [
        { num: 1, label: 'Имя' },
        { num: 2, label: 'Параметры' },
        { num: 3, label: 'Измерения' },
        { num: 4, label: 'Куб Ввод' },
        { num: 5, label: 'Форма' },
        { num: 6, label: 'Куб Сводный' },
        { num: 7, label: 'Обработка' },
        { num: 8, label: 'Копирование' },
        { num: 9, label: 'Обзор' },
        { num: 10, label: this.editMode ? 'Изменения' : 'Создание' },
      ]
    },
    editDiff() {
      if (!this.editMode || !this.originalState) return null
      return this.computeDiff()
    },
    noChanges() {
      if (!this.editDiff) return true
      const d = this.editDiff
      return !d.nameChanged
        && d.paramsAdded.length === 0 && d.paramsRemoved.length === 0
        && d.dimsAdded.length === 0 && d.dimsRemoved.length === 0
        && d.inputFieldsAdded.length === 0 && d.inputFieldsRemoved.length === 0
        && d.summaryFieldsAdded.length === 0 && d.summaryFieldsRemoved.length === 0
        && !d.formParamChanged && !d.formColumnsChanged
    },
    filteredChainList() {
      let list = this.chainList
      if (this.chainTemplateFilter) {
        list = list.filter(c => c.template === this.chainTemplateFilter)
      }
      if (this.chainSearch.trim()) {
        const q = this.chainSearch.trim().toLowerCase()
        list = list.filter(c => c.name.toLowerCase().includes(q) || c.chainId.toLowerCase().includes(q))
      }
      return list
    },
    filteredPodrFormList() {
      let list = this.podrFormList
      if (this.podrFormSearch.trim()) {
        const q = this.podrFormSearch.trim().toLowerCase()
        list = list.filter(f => f.name.toLowerCase().includes(q))
      }
      return list
    },
    chainTemplateOptions() {
      const set = new Set(this.chainList.map(c => c.template).filter(Boolean))
      return Array.from(set).sort()
    },
    n() { return this.budgetName.trim() },
    plannedObjects() {
      const nm = this.n
      return [
        { meta: 'form', name: `Форма Бюджет ${nm}`, shortName: `Форма ...${nm}` },
        { meta: 'cube', name: `Куб Бюджет ${nm} Ввод`, shortName: 'Куб ...Ввод' },
        { meta: 'cube', name: `Куб Бюджет ${nm}`, shortName: `Куб ...${nm}` },
        { meta: 'mount', name: `Сборка Бюджет ${nm}`, shortName: 'Сборка (главная)' },
        { meta: 'mount', name: `Сборка Бюджет ${nm} Обработка`, shortName: 'Сборка ...Обработка' },
        { meta: 'mount', name: `Сборка Бюджет ${nm} Копировать`, shortName: 'Сборка ...Копировать' },
      ]
    },
    // Entities available for param/dim/field pickers (exclude standard)
    pickableEntities() {
      return this.allEntities.filter(e => !STANDARD_IDS.has(e.id))
    },
    // Step 2: params
    availableParams() {
      return this.pickableEntities
    },
    filteredParams() {
      let list = this.availableParams
      if (this.paramSearch.trim()) {
        list = list.filter(e => this.fuzzyMatch(e.name, this.paramSearch) || this.fuzzyMatch(String(e.id), this.paramSearch))
      }
      return list
    },
    selectedParamNames() {
      return this.selectedParamIds.map(id => this.entityName(id))
    },
    // Step 3: dimensions (exclude already selected params)
    filteredDimensions() {
      let list = this.pickableEntities.filter(e => !this.selectedParamIds.includes(e.id))
      if (this.dimSearch.trim()) {
        list = list.filter(e => this.fuzzyMatch(e.name, this.dimSearch) || this.fuzzyMatch(String(e.id), this.dimSearch))
      }
      return list
    },
    selectedDimNames() {
      return this.selectedDimIds.map(id => this.entityName(id))
    },
    // Step 4: input cube extra fields (exclude standard + params + dims)
    alreadyInInputCube() {
      return new Set([...STANDARD_IDS, ...this.selectedParamIds, ...this.selectedDimIds])
    },
    filteredInputFields() {
      let list = this.allEntities.filter(e => !this.alreadyInInputCube.has(e.id))
      if (this.inputFieldSearch.trim()) {
        list = list.filter(e => this.fuzzyMatch(e.name, this.inputFieldSearch) || this.fuzzyMatch(String(e.id), this.inputFieldSearch))
      }
      return list
    },
    inputCubeFieldNames() {
      return this.inputCubeFieldIds.map(id => this.entityName(id))
    },
    inputCubeTotalAttrs() {
      return 4 + this.selectedParamIds.length + this.selectedDimIds.length + this.inputCubeFieldIds.length
    },
    // All entity IDs that should show in "Свойства атрибутов" section (dims + extra fields)
    allAttrIdsForProps() {
      return [...this.selectedDimIds, ...this.inputCubeFieldIds]
    },
    // Step 5: form display columns
    visibleFormColumns() {
      return this.formColumns.filter(c => c.visible)
    },
    visibleFormDimIds() {
      return this.visibleFormColumns.filter(c => c.type === 'dim').map(c => c.id)
    },
    visibleFormFieldIds() {
      return this.visibleFormColumns.filter(c => c.type === 'field').map(c => c.id)
    },
    // Step 6: summary cube extra fields (exclude standard + params + dims)
    alreadyInSummaryCube() {
      return new Set([...STANDARD_IDS, ...this.selectedParamIds, ...this.selectedDimIds])
    },
    filteredSummaryFields() {
      let list = this.allEntities.filter(e => !this.alreadyInSummaryCube.has(e.id))
      if (this.summaryFieldSearch.trim()) {
        list = list.filter(e => this.fuzzyMatch(e.name, this.summaryFieldSearch) || this.fuzzyMatch(String(e.id), this.summaryFieldSearch))
      }
      return list
    },
    summaryCubeFieldNames() {
      return this.summaryCubeFieldIds.map(id => this.entityName(id))
    },
    summaryCubeTotalAttrs() {
      return 4 + this.selectedParamIds.length + this.selectedDimIds.length + this.summaryCubeFieldIds.length
    },
    allParamEntityIds() {
      return this.selectedParamIds
    },
    totalAttrsCount() {
      const formAttrs = this.allParamEntityIds.length
      const asmAttrs = this.allParamEntityIds.length * 3
      return formAttrs + this.inputCubeTotalAttrs + this.summaryCubeTotalAttrs + asmAttrs
    },
  },
  watch: {
    visible(val) {
      if (val && this.editChainId) {
        // Direct edit from /chain_edit command — skip preStep
        this.preStep = null
        this.enterEditMode(this.editChainId)
      } else if (val) {
        this.preStep = 'choose'
      }
      if (!val) this.aiChatDisconnect()
    },
    step() {
      this.aiChatEnsureConnected()
    },
    inputCubeAttributes(val) {
      if (val && val.length > 0 && [4, 7, 8].includes(this.step)) {
        this.aiChatAttrProps = null
        this.aiChatLoadAttrProps()
      }
    },
  },
  beforeDestroy() {
    this.aiChatDisconnect()
  },
  methods: {
    // ── UI helpers ──
    entityName(id) {
      const e = this.allEntities.find(x => x.id === id)
      return e ? e.name : `#${id}`
    },
    goToStep(num) {
      if (num < this.step && this.step < 10) this.step = num
    },
    toggleParam(id) {
      const idx = this.selectedParamIds.indexOf(id)
      if (idx >= 0) this.selectedParamIds.splice(idx, 1)
      else this.selectedParamIds.push(id)
    },
    toggleDim(id) {
      const idx = this.selectedDimIds.indexOf(id)
      if (idx >= 0) this.selectedDimIds.splice(idx, 1)
      else this.selectedDimIds.push(id)
    },
    toggleInputField(id) {
      const idx = this.inputCubeFieldIds.indexOf(id)
      if (idx >= 0) {
        this.inputCubeFieldIds.splice(idx, 1)
      } else {
        this.inputCubeFieldIds.push(id)
      }
    },
    // ── Attribute properties (CbsObjectTable for cbsattributeparam) ──
    onLoadAttrParamObj(obj) {
      this.attrParamObjectFull = obj
    },
    getAttributeId(entityId) {
      const attr = this.inputCubeAttributes.find(a => a.entityid === entityId)
      return attr ? attr.attributeid : null
    },
    openAttrProps(entityId) {
      this.attrPropsEntityId = entityId
      this.showAttrPropsModal = true
    },
    attrParamFilter(entityId) {
      const attributeid = this.getAttributeId(entityId)
      if (!attributeid) return {}
      return {
        isActive: true,
        node: {
          isactive: true,
          oper: { sid: 'and', name: 'And' },
          nodes: [],
          conds: [
            {
              isactive: true,
              oper: { sid: 'equal', name: '=' },
              args: [
                { type: { sid: 'entitysid', name: 'EntitySID' }, value: 'attribute' },
                { type: { sid: 'value', name: 'Value' }, value: `${attributeid}` },
              ],
            },
          ],
        },
      }
    },
    // ── Mount step filter (CbsObjectTable for mountstep) ──
    mountStepFilter(asmId) {
      if (!asmId) return {}
      return {
        isActive: true,
        node: {
          isactive: true,
          oper: { sid: 'and', name: 'And' },
          nodes: [],
          conds: [
            {
              isactive: true,
              oper: { sid: 'equal', name: '=' },
              args: [
                { type: { sid: 'entitysid', name: 'EntitySID' }, value: 'object' },
                { type: { sid: 'value', name: 'Value' }, value: `${asmId}` },
              ],
            },
          ],
        },
      }
    },
    // Multi-word fuzzy match: "сум вал" matches "Сумма В Валюте"
    fuzzyMatch(text, search) {
      if (!search || !search.trim()) return true
      const parts = search.trim().toLowerCase().split(/\s+/)
      const re = new RegExp(parts.map(p => p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('.*'))
      return re.test((text || '').toLowerCase())
    },
    toggleSummaryField(id) {
      const idx = this.summaryCubeFieldIds.indexOf(id)
      if (idx >= 0) this.summaryCubeFieldIds.splice(idx, 1)
      else this.summaryCubeFieldIds.push(id)
    },
    initFormColumns() {
      const existingIds = new Set(this.formColumns.map(c => c.id))
      const currentDimIds = new Set(this.selectedDimIds)
      const currentFieldIds = new Set(this.inputCubeFieldIds)
      const allCurrentIds = new Set([...currentDimIds, ...currentFieldIds])
      // Remove columns no longer in dims/fields, update type/name
      const kept = this.formColumns
        .filter(c => allCurrentIds.has(c.id))
        .map(c => ({
          ...c,
          type: currentDimIds.has(c.id) ? 'dim' : 'field',
          name: this.entityName(c.id),
        }))
      // Add new dims/fields not yet in formColumns
      const newCols = []
      this.selectedDimIds.forEach(id => {
        if (!existingIds.has(id)) {
          newCols.push({
            id, type: 'dim', name: this.entityName(id), visible: true, editable: true,
          })
        }
      })
      this.inputCubeFieldIds.forEach(id => {
        if (!existingIds.has(id)) {
          newCols.push({
            id, type: 'field', name: this.entityName(id), visible: true, editable: true,
          })
        }
      })
      this.formColumns = [...kept, ...newCols]
    },
    toggleFormColVisible(col) {
      if (col.visible && col.type === 'dim') {
        const visDims = this.formColumns.filter(c => c.type === 'dim' && c.visible)
        if (visDims.length <= 1) return
      }
      const idx = this.formColumns.findIndex(c => c.id === col.id)
      if (idx >= 0) this.$set(this.formColumns, idx, { ...col, visible: !col.visible })
    },
    toggleFormColEditable(col) {
      const idx = this.formColumns.findIndex(c => c.id === col.id)
      if (idx >= 0) this.$set(this.formColumns, idx, { ...col, editable: !col.editable })
    },
    nextStep() {
      if (this.step === 1 && !this.budgetName.trim()) return
      if (this.step === 3 && this.selectedDimIds.length === 0) return
      if (this.step === 4) this.initFormColumns()
      if (this.step === 5 && this.visibleFormDimIds.length === 0) return
      this.step += 1
    },
    // ── Pre-step methods ──
    selectTemplate(/* templateId */) {
      // Currently only 'budget' template exists — go straight to step 1
      this.editMode = false
      this.preStep = null
      this.step = 1
    },
    startChainPicker() {
      this.preStep = 'chains'
      this.chainSearch = ''
      this.chainTemplateFilter = ''
      this.loadChainList()
    },
    // ── Подразделение form methods ──
    startPodrFormPicker() {
      this.preStep = 'pick-form'
      this.podrFormSearch = ''
      this.podrSourceForm = null
      this.loadPodrFormList()
    },
    async loadPodrFormList() {
      this.podrFormListLoading = true
      this.podrFormList = []
      try {
        const forms = this.allObjects.filter(o => {
          const meta = (o.meta || '').toLowerCase()
          const name = (o.name || '').toLowerCase()
          return meta === 'form' && name.includes('бюджет') && !name.includes('подразделение')
        })
        // Find associated input cubes for each form
        const result = []
        for (const form of forms) {
          const nameBase = form.name.replace(/^Форма\s+/i, '').trim()
          const inputCube = this.allObjects.find(o => {
            const oMeta = (o.meta || '').toLowerCase()
            const oName = (o.name || '').toLowerCase()
            return oMeta === 'cube' && oName === `куб ${nameBase.toLowerCase()} ввод`
          })
          result.push({
            id: form.id,
            name: form.name,
            inputCube: inputCube ? { id: inputCube.id, name: inputCube.name } : null,
          })
        }
        this.podrFormList = result.sort((a, b) => a.name.localeCompare(b.name))
      } catch (e) {
        console.error('[ChainWizard] loadPodrFormList error:', e)
      } finally {
        this.podrFormListLoading = false
      }
    },
    async pickFormForPodr(form) {
      this.podrSourceForm = form
      this.preStep = 'podr-create'
      this.podrLog = []
      this.podrProgress = 0
      this.podrDone = false
      this.podrError = false
      await this.createPodrForm()
    },
    podrLogAdd(text, opts = {}) {
      this.podrLog.push({ text, error: !!opts.error, success: !!opts.success })
    },
    async createPodrForm() {
      const src = this.podrSourceForm
      if (!src) return
      try {
        // ── Pre-checks: validate everything BEFORE creating anything ──
        // Check 1: Input cube exists
        if (!src.inputCube) {
          throw new Error(`Куб ввода не найден для формы "${src.name}". Невозможно создать форму Подразделение без куба.`)
        }
        this.podrLogAdd(`Проверка куба ввода "${src.inputCube.name}"...`)
        this.podrProgress = 5

        // Check 2: Load input cube and find unitmr/business_unit field
        const cubeFull = await this.restQuery({
          method: 'objectfull', mode: 'sync', param: { objectid: src.inputCube.id },
        })
        const cubeObj = cubeFull.data.result && cubeFull.data.result.objectfull
        const unitSids = ['unitmr', 'business_unit', 'unit', 'refunitmr']
        const cubeAttrs = cubeObj ? (cubeObj.attributes || cubeObj.attrs || []) : []
        const unitmrAttr = cubeAttrs.find(a => unitSids.includes(a.entitysid))
        if (!unitmrAttr) {
          const availableFields = cubeAttrs.length > 0 ? cubeAttrs.map(a => a.entitysid).join(', ') : 'нет атрибутов'
          throw new Error(`Поле подразделения (unitmr/business_unit/unit) не найдено в кубе "${src.inputCube.name}". Доступные поля: ${availableFields}`)
        }
        this.podrLogAdd(`Поле подразделения найдено: ${unitmrAttr.entitysid} (entity=${unitmrAttr.entityid})`, { success: true })
        this.podrProgress = 10

        // Check 3: Load source form structure
        this.podrLogAdd('Загрузка исходной формы...')
        const srcFull = await this.restQuery({
          method: 'objectfull', mode: 'sync', param: { objectid: src.id },
        })
        const srcObj = srcFull.data.result && srcFull.data.result.objectfull
        this.podrProgress = 15

        // ── All checks passed — start creating ──

        // Phase 1: Ensure role "Бюджет Подразд" exists
        this.podrLogAdd('Проверка роли "Бюджет Подразд"...')
        const roleId = await this.findOrCreateRole('Бюджет Подразд')
        this.podrLogAdd(`Роль "Бюджет Подразд" id=${roleId}`, { success: true })
        this.podrProgress = 25

        // Phase 2: Find scalar "Подразделение Пользователя"
        this.podrLogAdd('Проверка скаляра "Подразделение Пользователя"...')
        const scalarId = await this.findOrCreatePodrScalar(unitmrAttr)
        if (!scalarId) {
          throw new Error('Скаляр "Подразделение Пользователя" не найден. Создайте его вручную перед использованием этой функции.')
        }
        this.podrLogAdd(`Скаляр id=${scalarId}`, { success: true })
        this.podrProgress = 35

        // Phase 3: Mark old Подразделение form as deleted (if exists)
        const podrName = `${src.name} Подразделение`
        const existingPodr = this.allObjects.find(o => (o.name || '') === podrName && (o.meta || '').toLowerCase() === 'form')
        let newFormId
        if (existingPodr) {
          // Reuse existing form
          this.podrLogAdd(`Форма "${podrName}" уже существует (id=${existingPodr.id}), обновляю...`)
          newFormId = existingPodr.id
        } else {
          // Create new form
          this.podrLogAdd(`Создание формы "${podrName}"...`)
          const formResp = await this.sendWsAndWait(`создай_объект form ${podrName}`)
          newFormId = formResp.context && formResp.context.objectId
          if (!newFormId) throw new Error('Не удалось создать форму: нет objectId в ответе')
        }
        this.podrLogAdd(`Форма создана, id=${newFormId}`, { success: true })
        this.podrProgress = 50

        // Phase 4: Copy attributes from source form (skip if reusing and already has attrs)
        this.podrLogAdd('Копирование атрибутов из исходной формы...')
        const srcAttrs = srcObj ? (srcObj.attributes || srcObj.attrs || []) : []
        const existingFull = existingPodr ? await this.restQuery({
          method: 'objectfull', mode: 'sync', param: { objectid: newFormId },
        }).then(r => r.data.result && r.data.result.objectfull).catch(() => null) : null
        const existingAttrs = existingFull ? (existingFull.attributes || []) : []
        if (srcAttrs.length > 0 && existingAttrs.length === 0) {
          for (const attr of srcAttrs) {
            // eslint-disable-next-line no-await-in-loop
            await this.sendWsAndWait(`/add_attr ${newFormId} ${attr.entityid}`)
          }
          this.podrLogAdd(`Скопировано ${srcAttrs.length} атрибутов`, { success: true })
        } else if (existingAttrs.length > 0) {
          this.podrLogAdd(`Атрибуты уже есть (${existingAttrs.length}), пропуск`)
        }
        // Set attrs as required
        await this.setAttrsRequired(newFormId)
        this.podrLogAdd('Атрибуты помечены как required', { success: true })
        this.podrProgress = 65

        // Phase 5: Copy form_param from source form (only if not already set)
        this.podrLogAdd('Копирование параметров формы...')
        const existingParams = existingFull && existingFull.params && existingFull.params.params
          ? existingFull.params.params : []
        if (srcObj && srcObj.params && srcObj.params.params && existingParams.length === 0) {
          for (const p of srcObj.params.params) {
            if (p.paramname === 'chain_id' || p.paramname === 'chain_wizard_state') continue
            const jsVal = p.jsonstring && typeof p.jsonstring === 'object' && Object.keys(p.jsonstring).length > 0
              ? p.jsonstring : null
            // eslint-disable-next-line no-await-in-loop
            await this.saveObjectParam(newFormId, p.paramname, p.strvalue || '', jsVal)
          }
          this.podrLogAdd('Параметры формы скопированы', { success: true })
        } else if (existingParams.length > 0) {
          this.podrLogAdd('Параметры уже есть, пропуск')
        }
        this.podrProgress = 75

        // Phase 6: Create cbsobjectrolefilter
        this.podrLogAdd('Создание фильтра для роли на кубе ввода...')
        await this.createObjectRoleFilter(src.inputCube.id, roleId, unitmrAttr, scalarId)
        this.podrLogAdd('Фильтр создан', { success: true })
        this.podrProgress = 90

        // Phase 7: Save description on new form
        this.podrLogAdd('Сохранение описания формы...')
        const descr = 'Форма предназначена для работы по подразделению, к которому принадлежит текущий пользователь'
        await this.restQuery({
          method: 'updateobject',
          mode: 'sync',
          param: { objectid: newFormId, descr },
        }).catch(() => null)
        this.podrProgress = 100
        this.podrLogAdd('Готово!', { success: true })
        this.podrDone = true
        this.$emit('refresh-objects')
      } catch (e) {
        console.error('[ChainWizard] createPodrForm error:', e)
        this.podrLogAdd(`Ошибка: ${e.message || e}`, { error: true })
        this.podrError = true
        this.podrDone = true
      }
    },
    async findOrCreateRole(roleName) {
      // Use recordApi.query which properly handles pagination and response parsing
      const records = await recordApi.query('role', { limit: 100 })
      for (const rec of records) {
        const r = rec.record || rec
        let nameVal = ''
        if (r.name && typeof r.name === 'object') nameVal = r.name.value || r.name.title || ''
        else if (typeof r.name === 'string') nameVal = r.name
        if (nameVal.toLowerCase() === roleName.toLowerCase()) {
          if (r.id && typeof r.id === 'object') return r.id.value
          if (typeof r.id === 'number') return r.id
        }
      }
      // Role not found — create it
      this.podrLogAdd('Роль не найдена, создаю...')
      const rec = await recordApi.newRecord('role')
      if (rec.name) { rec.name.value = roleName; rec.name.status = 'changed' }
      if (rec.sid) { rec.sid.value = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2); rec.sid.status = 'changed' }
      const saved = await recordApi.save('role', rec)
      const savedRec = saved ? (saved.record || saved) : rec
      return savedRec.id ? savedRec.id.value : (rec.id ? rec.id.value : null)
    },
    async findOrCreatePodrScalar(unitmrAttr) {
      // Try multiple query approaches to find existing scalar
      const scalarObj = this.allObjects.find(o => (o.sid || '').toLowerCase() === 'scalar')
      const queryAttempts = [
        { limit: 500 },
        scalarObj ? { limit: 500, objectid: scalarObj.id } : null,
      ].filter(Boolean)
      for (const opts of queryAttempts) {
        // eslint-disable-next-line no-await-in-loop
        const records = await recordApi.query('scalar', opts).catch(() => [])
        console.log('[findOrCreatePodrScalar] query records:', records.length, 'opts:', JSON.stringify(opts))
        for (const rec of records) {
          const r = rec.record || rec
          let nameVal = ''
          if (r.name && typeof r.name === 'object') nameVal = r.name.value || r.name.title || ''
          else if (typeof r.name === 'string') nameVal = r.name
          if (nameVal.includes('Подразделение') && nameVal.includes('Пользователя')) {
            if (r.id && typeof r.id === 'object') return r.id.value
            if (typeof r.id === 'number') return r.id
          }
        }
        if (records.length > 0) break // at least one attempt returned records
      }
      // Also try entref for scalar entity
      try {
        const scalarEntity = this.allEntities.find(e => e.sid === 'scalar' || (e.refobject && e.refobject === 'scalar'))
        if (scalarEntity) {
          const resp = await this.restQuery({ method: 'entref', mode: 'sync', param: { entityid: scalarEntity.id } })
          const data = resp.data.result || resp.data
          const refs = (data.entref || data).records || []
          for (const ref of refs) {
            if ((ref.title || '').includes('Подразделение') && (ref.title || '').includes('Пользователя')) {
              return ref.value || ref.id
            }
          }
        }
      } catch (e) { /* ignore */ }
      // Scalar not found — create it
      // Need: source object = employee (has usersid + business_unit/unitmr)
      // Find employee object (has both usersid and the unit field)
      const unitSid = unitmrAttr.entitysid // business_unit or unitmr
      const employeeObj = this.allObjects.find(o => {
        const s = (o.sid || '').toLowerCase()
        const n = (o.name || '').toLowerCase()
        return s === 'employee' || n === 'сотрудники' || n === 'сотрудник'
      })
      if (!employeeObj) {
        this.podrLogAdd('Объект "Сотрудники" не найден — скаляр не создан', { error: true })
        return null
      }
      this.podrLogAdd(`Создание скаляра "Подразделение Пользователя" (источник: ${employeeObj.name}, поле: ${unitSid})...`)
      // Load employee objectfull to find entityid + attributeid for usersid and unit field
      const empFull = await this.restQuery({
        method: 'objectfull', mode: 'sync', param: { objectid: employeeObj.id },
      })
      const empObj = empFull.data.result && empFull.data.result.objectfull
      const empAttrs = empObj ? (empObj.attributes || empObj.attrs || []) : []
      const usersidAttr = empAttrs.find(a => a.entitysid === 'usersid')
      const unitAttr = empAttrs.find(a => a.entitysid === unitSid)
      if (!usersidAttr || !unitAttr) {
        this.podrLogAdd(`Поля usersid или ${unitSid} не найдены в объекте Сотрудники`, { error: true })
        return null
      }
      // Create scalar record
      const rec = await recordApi.newRecord('scalar')
      if (rec.name) { rec.name.value = 'Подразделение Пользователя'; rec.name.status = 'changed' }
      if (rec.sid) { rec.sid.value = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2); rec.sid.status = 'changed' }
      if (rec.sourceobjectid) { rec.sourceobjectid.value = employeeObj.id; rec.sourceobjectid.status = 'changed' }
      if (rec.entityid) { rec.entityid.value = unitAttr.entityid; rec.entityid.status = 'changed' }
      // Build filter: del IS NOT TRUE AND currentuser(usersid)
      const scalarFilter = {
        node: {
          isactive: true,
          oper: { id: 1, sid: 'and', name: 'And' },
          nodes: [],
          conds: [
            {
              isactive: true,
              name: 'not deleted',
              oper: {
                id: 1, sid: 'equal', name: '=', args: 2,
              },
              args: [
                { type: { id: 1, sid: 'entity', name: 'Entity' }, value: { entitysid: 'del', attributeid: empAttrs.find(a => a.entitysid === 'del') ? empAttrs.find(a => a.entitysid === 'del').attributeid : 0 } },
                {
                  type: { id: 2, sid: 'value', name: 'Value' }, datatype: 'bit', value: null, entitysid: 'del',
                },
              ],
            },
            {
              isactive: true,
              name: 'current user',
              oper: {
                id: 23, sid: 'currentuser', name: 'Current User', args: 1,
              },
              args: [
                { type: { id: 1, sid: 'entity', name: 'Entity' }, value: { entitysid: 'usersid', attributeid: usersidAttr.attributeid } },
                {
                  type: { id: 2, sid: 'value', name: 'Value' }, datatype: 'ref', entitysid: 'user', value: null,
                },
              ],
            },
          ],
          isexpanded: true,
        },
      }
      if (rec.jsonfilter) { rec.jsonfilter.value = JSON.stringify(scalarFilter); rec.jsonfilter.status = 'changed' }
      try {
        const saved = await recordApi.save('scalar', rec)
        const savedRec = saved ? (saved.record || saved) : rec
        const newId = savedRec.id ? savedRec.id.value : (rec.id ? rec.id.value : null)
        this.podrLogAdd(`Скаляр создан, id=${newId}`, { success: true })
        return newId
      } catch (e) {
        if (e.message && (e.message.includes('not unique') || e.message.includes('уникальн'))) {
          // Scalar already exists — re-query to find it
          this.podrLogAdd('Скаляр уже существует, ищу id...')
          const records2 = await recordApi.query('scalar', { limit: 200 })
          for (const r2 of records2) {
            const rr = r2.record || r2
            let nv = ''
            if (rr.name && typeof rr.name === 'object') nv = rr.name.value || rr.name.title || ''
            else if (typeof rr.name === 'string') nv = rr.name
            if (nv.includes('Подразделение Пользователя')) {
              const sid = rr.id ? rr.id.value : null
              this.podrLogAdd(`Найден скаляр id=${sid}`, { success: true })
              return sid
            }
          }
          // recordApi.query also fails — get ID from newRecord template (same trick as role)
          const rec2 = await recordApi.newRecord('scalar')
          const templateId = rec2.id ? rec2.id.value : null
          if (templateId) {
            this.podrLogAdd(`Используем скаляр id=${templateId - 1}`, { success: true })
            return templateId - 1
          }
          throw new Error('Скаляр существует, но не удалось получить id')
        }
        throw e
      }
    },
    async createObjectRoleFilter(cubeId, roleId, unitmrAttr, scalarId) {
      if (!scalarId) {
        this.podrLogAdd('Скаляр не найден — фильтр создан без привязки к скаляру', { error: true })
        return
      }
      const jsonfilter = {
        node: {
          isactive: true,
          oper: { id: 1, sid: 'and', name: 'And' },
          nodes: [],
          conds: [{
            isactive: true,
            name: 'Фильтр по подразделению',
            oper: {
              id: 1, sid: 'equal', name: '=', args: 2,
            },
            args: [
              {
                type: { id: 1, sid: 'entity', name: 'Entity' },
                datatype: null,
                entityid: null,
                value: {
                  title: unitmrAttr.label || 'Подразделение',
                  value: unitmrAttr.entityid,
                  datatype: 'ref',
                  attributeid: unitmrAttr.attributeid,
                  entitysid: unitmrAttr.entitysid,
                  parententityid: 0,
                  refobjectid: unitmrAttr.refobjectid || 0,
                },
                entitysid: null,
                parententityid: null,
              },
              {
                type: { id: 10, sid: 'scalar', name: 'Скаляр' },
                datatype: 'ref',
                entityid: unitmrAttr.entityid,
                value: { value: scalarId, title: 'Подразделение Пользователя' },
                entitysid: unitmrAttr.entitysid,
                parententityid: 0,
              },
            ],
          }],
          isexpanded: true,
        },
      }
      // Create cbsobjectrolefilter record via recordApi
      const rec = await recordApi.newRecord('cbsobjectrolefilter')
      if (rec.object) { rec.object.value = cubeId; rec.object.status = 'changed' }
      if (rec.role) { rec.role.value = roleId; rec.role.status = 'changed' }
      if (rec.jsonfilter) { rec.jsonfilter.value = JSON.stringify(jsonfilter); rec.jsonfilter.status = 'changed' }
      await recordApi.save('cbsobjectrolefilter', rec)
    },
    async loadChainList() {
      this.chainListLoading = true
      this.chainList = []
      try {
        // Strategy: load objectfull for all form objects, extract chain_id from params
        const forms = this.allObjects.filter(o => (o.meta || '').toLowerCase() === 'form')
        const chains = {}

        // Load objectfull in parallel batches of 5
        for (let i = 0; i < forms.length; i += 5) {
          const batch = forms.slice(i, i + 5)
          // eslint-disable-next-line no-await-in-loop
          const results = await Promise.all(
            batch.map(f => this.restQuery({
              method: 'objectfull', mode: 'sync', param: { objectid: f.id },
            }).catch(() => null)),
          )
          results.forEach((resp, idx) => {
            if (!resp) return
            const full = resp.data.result && resp.data.result.objectfull
            if (!full || !full.params || !full.params.params) return
            const chainParam = full.params.params.find(p => p.paramname === 'chain_id')
            if (!chainParam) return
            const cid = chainParam.paramvalue || chainParam.strvalue || ''
            if (!cid) return
            const form = batch[idx]
            chains[cid] = {
              chainId: cid, objects: [{ id: form.id, name: form.name, meta: form.meta || 'form' }], name: '', template: '',
            }
            const m = form.name.match(/Форма\s+Бюджет\s+(.+)/i)
            chains[cid].name = m ? m[1].trim() : form.name
            chains[cid].template = m ? 'Бюджетная цепочка' : ''
          })
        }

        // For each chain, find related objects in allObjects by name pattern
        Object.values(chains).forEach(chain => {
          const nm = chain.name.toLowerCase()
          this.allObjects.forEach(obj => {
            if (chain.objects.some(o => o.id === obj.id)) return
            const oname = (obj.name || '').toLowerCase()
            const meta = (obj.meta || '').toLowerCase()
            if (
              (meta === 'cube' && (oname === `куб бюджет ${nm} ввод` || oname === `куб бюджет ${nm}`))
              || (meta === 'mount' && (oname === `сборка бюджет ${nm}` || oname === `сборка бюджет ${nm} обработка` || oname === `сборка бюджет ${nm} копировать`))
            ) {
              chain.objects.push({ id: obj.id, name: obj.name, meta: obj.meta || meta })
            }
          })
        })

        this.chainList = Object.values(chains).sort((a, b) => a.name.localeCompare(b.name))
      } catch (e) {
        console.error('[ChainWizard] loadChainList error:', e)
      } finally {
        this.chainListLoading = false
      }
    },
    pickChainForEdit(chain) {
      this.preStep = null
      const objectIds = chain.objects.map(o => o.id)
      this.enterEditModeWithObjects(chain.chainId, objectIds)
    },

    onHidden() {
      this.$emit('wizard-active', false)
      this.aiChatDisconnect()
      this.aiChatMessages = []
      this.resetEditState()
    },
    resetEditState() {
      this.preStep = 'choose'
      this.chainList = []
      this.chainListLoading = false
      this.podrFormList = []
      this.podrFormListLoading = false
      this.podrFormSearch = ''
      this.podrSourceForm = null
      this.podrLog = []
      this.podrProgress = 0
      this.podrDone = false
      this.podrError = false
      this.editMode = false
      this.editLoading = false
      this.editError = null
      this.chainId = null
      this.originalState = null
      this.step = 1
      this.budgetName = ''
      this.selectedParamIds = []
      this.selectedDimIds = []
      this.inputCubeFieldIds = []
      this.summaryCubeFieldIds = []
      this.formColumns = []
      this.showAttrPropsModal = false
      this.attrPropsEntityId = null
      this.inputCubeAttributes = []
      this.aiChatAttrProps = null
      this.log = []
      this.progressPercent = 0
      this.creationDone = false
      this.creationError = false
      this.created = {
        formId: null, inputCubeId: null, summaryCubeId: null, mainAsmId: null, procAsmId: null, copyAsmId: null,
      }
      this.phasesDone = {
        objects: false, attrs: false, props: false, steps: false, params: false, chainId: false,
      }
    },
    buildWizardState() {
      return {
        selectedParamIds: [...this.selectedParamIds],
        selectedDimIds: [...this.selectedDimIds],
        inputCubeFieldIds: [...this.inputCubeFieldIds],
        summaryCubeFieldIds: [...this.summaryCubeFieldIds],
        formColumns: JSON.parse(JSON.stringify(this.formColumns)),
      }
    },
    async phaseSaveWizardState() {
      const { formId } = this.created
      if (!formId) return
      const state = this.buildWizardState()
      this.addLog('Сохраняю состояние мастера (chain_wizard_state)...')
      if (this.editMode) {
        const updated = await this.overwriteObjectParam(formId, 'chain_wizard_state', '', state)
        if (!updated) {
          await this.saveObjectParam(formId, 'chain_wizard_state', '', state)
        }
      } else {
        await this.saveObjectParam(formId, 'chain_wizard_state', '', state)
      }
      this.addLog('  Состояние мастера сохранено', 'success')
    },
    finish() {
      const ids = Object.values(this.created).filter(Boolean)
      if (this.editMode) {
        this.$emit('chain-updated', ids, this.chainId)
      } else if (ids.length > 0) {
        this.$emit('chain-created', ids, this.chainId)
      }
      this.showModal = false
    },
    generateChainId() {
      if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID()
      }
      // Fallback UUID v4
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      })
    },
    addLog(text, type = 'info') {
      this.log.push({ text, type })
      this.$nextTick(() => {
        const el = this.$refs.logBox
        if (el) el.scrollTop = el.scrollHeight
      })
    },

    // ── WS helper ──
    sendWsAndWait(text) {
      return new Promise((resolve, reject) => {
        if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
          reject(new Error('WebSocket не подключён'))
          return
        }
        let timer = null
        const handler = event => {
          try {
            const data = JSON.parse(event.data)
            if (data.type === 'message' || data.type === 'error') {
              this.ws.removeEventListener('message', handler)
              clearTimeout(timer)
              if (data.type === 'error') {
                reject(new Error(data.text || 'WS error'))
              } else {
                resolve(data)
              }
            }
          } catch { /* ignore non-JSON */ }
        }
        timer = setTimeout(() => {
          this.ws.removeEventListener('message', handler)
          reject(new Error('Таймаут WS (30 сек)'))
        }, WS_TIMEOUT)
        this.ws.addEventListener('message', handler)
        this.ws.send(JSON.stringify({
          type: 'message', to: 'chatbot', text, token: this.getToken(),
        }))
      })
    },

    // ── REST helper ──
    restQuery(query) {
      return useJwt.query({
        token: useJwt.getCubusToken(),
        query,
      })
    },

    // ── Mount operand lookup ──
    getMountOperId(sid) {
      const op = this.mountOperands.find(o => o.sid === sid)
      return op ? op.id : null
    },

    // ── MAIN CREATION ──
    async runCreation() {
      this.step = 10
      this.creationError = false
      this.creationDone = false
      this.log = []
      this.progressPercent = 0
      this.$emit('wizard-active', true)

      try {
        // Phase 1: Create 6 objects
        if (!this.phasesDone.objects) {
          await this.phaseCreateObjects()
          this.phasesDone.objects = true
        }
        this.progressPercent = 20

        // Phase 1b: Save chain_id on all 6 objects
        if (!this.phasesDone.chainId) {
          await this.phaseSaveChainIds()
          this.phasesDone.chainId = true
        }
        this.progressPercent = 30

        // Phase 2: Add attributes
        if (!this.phasesDone.attrs) {
          await this.phaseAddAttributes()
          this.phasesDone.attrs = true
        }
        this.progressPercent = 55

        // Phase 3: Set attribute properties (calculation, default_value)
        if (!this.phasesDone.props) {
          await this.phaseSetProperties()
          this.phasesDone.props = true
        }
        this.progressPercent = 70

        // Phase 4: Create main assembly steps (only 2 mount-to-mount links)
        if (!this.phasesDone.steps) {
          await this.phaseCreateSteps()
          this.phasesDone.steps = true
        }
        this.progressPercent = 85

        // Phase 5: Save form params
        if (!this.phasesDone.params) {
          await this.phaseSaveFormParams()
          this.phasesDone.params = true
        }
        this.progressPercent = 95

        // Phase 6: Save wizard state for reliable reconstruction on edit
        await this.phaseSaveWizardState()
        this.progressPercent = 100

        this.addLog('Все объекты успешно созданы!', 'success')
        this.addLog('Теперь откройте сборки Обработка и Копировать и добавьте шаги вручную.', 'info')
        this.creationDone = true
      } catch (e) {
        this.addLog(`ОШИБКА: ${e.message}`, 'error')
        this.creationError = true
      }
    },

    // ── Phase 1: Create 6 objects via WS ──
    async phaseCreateObjects() {
      const nm = this.n
      const defs = [
        { key: 'formId', meta: 'form', name: `Форма Бюджет ${nm}` },
        { key: 'inputCubeId', meta: 'cube', name: `Куб Бюджет ${nm} Ввод` },
        { key: 'summaryCubeId', meta: 'cube', name: `Куб Бюджет ${nm}` },
        { key: 'mainAsmId', meta: 'mount', name: `Сборка Бюджет ${nm}` },
        { key: 'procAsmId', meta: 'mount', name: `Сборка Бюджет ${nm} Обработка` },
        { key: 'copyAsmId', meta: 'mount', name: `Сборка Бюджет ${nm} Копировать` },
      ]
      for (const def of defs) {
        if (this.created[def.key]) {
          this.addLog(`Пропуск: ${def.name} (уже создан #${this.created[def.key]})`)
          continue
        }
        this.addLog(`Создаю: ${def.name}...`)
        // eslint-disable-next-line no-await-in-loop
        const resp = await this.sendWsAndWait(`создай_объект ${def.meta} ${def.name}`)
        if (!resp.context || !resp.context.objectId) {
          throw new Error(`Не удалось создать объект "${def.name}": нет objectId в ответе`)
        }
        this.created[def.key] = resp.context.objectId
        this.addLog(`  Создан #${resp.context.objectId}`, 'success')
      }
    },

    // ── Phase 1b: Save chain_id on all 6 objects ──
    async phaseSaveChainIds() {
      if (!this.chainId) this.chainId = this.generateChainId()
      this.addLog(`Сохраняю chain_id: ${this.chainId}...`)
      const keys = ['formId', 'inputCubeId', 'summaryCubeId', 'mainAsmId', 'procAsmId', 'copyAsmId']
      for (const key of keys) {
        const objectId = this.created[key]
        if (!objectId) continue
        // eslint-disable-next-line no-await-in-loop
        await this.saveObjectParam(objectId, 'chain_id', this.chainId, {})
      }
      this.addLog('chain_id сохранён на всех объектах', 'success')
    },

    // ── Phase 2: Add attributes via WS ──
    async phaseAddAttributes() {
      const paramIds = this.allParamEntityIds
      const standardIds = [1, 11, 3, 4] // id, del, name, descr

      // Form: params (all isrequired)
      this.addLog('Добавляю атрибуты формы...')
      for (const eid of paramIds) {
        // eslint-disable-next-line no-await-in-loop
        await this.addAttr(this.created.formId, eid)
      }
      // Set all form attributes as required
      await this.setAttrsRequired(this.created.formId)

      // Input Cube: standard + params + dims + user-selected extra fields
      this.addLog(`Добавляю атрибуты куба ввода (${this.inputCubeTotalAttrs})...`)
      const inputAttrs = [
        ...standardIds,
        ...this.selectedParamIds,
        ...this.selectedDimIds,
        ...this.inputCubeFieldIds,
      ]
      for (const eid of inputAttrs) {
        // eslint-disable-next-line no-await-in-loop
        await this.addAttr(this.created.inputCubeId, eid)
      }

      // Summary Cube: standard + params + dims + user-selected extra fields
      this.addLog(`Добавляю атрибуты сводного куба (${this.summaryCubeTotalAttrs})...`)
      const summaryAttrs = [
        ...standardIds,
        ...this.selectedParamIds,
        ...this.selectedDimIds,
        ...this.summaryCubeFieldIds,
      ]
      for (const eid of summaryAttrs) {
        // eslint-disable-next-line no-await-in-loop
        await this.addAttr(this.created.summaryCubeId, eid)
      }

      // 3 assemblies: same params as form (scenario + extra params), all isrequired
      this.addLog('Добавляю атрибуты сборок...')
      for (const asmKey of ['mainAsmId', 'procAsmId', 'copyAsmId']) {
        for (const eid of paramIds) {
          // eslint-disable-next-line no-await-in-loop
          await this.addAttr(this.created[asmKey], eid)
        }
        // eslint-disable-next-line no-await-in-loop
        await this.setAttrsRequired(this.created[asmKey])
      }
      this.addLog('Атрибуты добавлены', 'success')
    },

    async addAttr(objectId, entityId) {
      await this.sendWsAndWait(`/add_attr ${objectId} ${entityId}`)
    },

    // Load object attributes and set isrequired=true for all of them
    async setAttrsRequired(objectId) {
      this.addLog('  Устанавливаю isrequired для атрибутов формы...')
      const resp = await this.restQuery({
        method: 'objectfull', mode: 'sync', param: { objectid: objectId },
      })
      const objectFull = resp.data.result && resp.data.result.objectfull
      if (!objectFull || !objectFull.attributes) {
        this.addLog('    Не удалось загрузить атрибуты для isrequired', 'error')
        return
      }
      for (const attr of objectFull.attributes) {
        if (attr.isrequired) continue // already required
        // eslint-disable-next-line no-await-in-loop
        await this.restQuery({
          method: 'saverecord',
          mode: 'sync',
          param: {
            objectsid: 'attribute',
            record: {
              id: { value: attr.attributeid, status: 'loaded' },
              name: { value: attr.label, status: 'loaded' },
              objectid: { value: objectId, status: 'loaded' },
              entityid: { value: attr.entityid, status: 'loaded' },
              isrequired: { value: true, status: 'changed' },
            },
          },
        })
      }
      this.addLog(`    isrequired установлен для ${objectFull.attributes.length} атрибутов`, 'success')
    },

    // ── Phase 3: Set attribute properties (calculation, default_value) ──
    async phaseSetProperties() {
      this.addLog('Устанавливаю свойства атрибутов...')

      const { inputCubeId } = this.created
      if (!inputCubeId) throw new Error('inputCubeId не найден')

      const resp = await this.restQuery({
        method: 'objectfull', mode: 'sync', param: { objectid: inputCubeId },
      })
      const objectFull = resp.data.result && resp.data.result.objectfull
      if (!objectFull || !objectFull.attributes) {
        throw new Error('Не удалось загрузить атрибуты куба ввода')
      }

      let propCount = 0
      for (const attr of objectFull.attributes) {
        const eid = attr.entityid

        if (DEFAULT_VALUE_PROPS[eid]) {
          const def = DEFAULT_VALUE_PROPS[eid]
          this.addLog(`  default_value: ${attr.label}`)
          // eslint-disable-next-line no-await-in-loop
          await this.saveAttrProperty(attr.attributeid, 'default_value', eid, def.operSid, def.ref, attr)
          propCount += 1
        }

        if (DIMENSION_FORMULA_DEFAULTS[eid] && !userParams.includes('default_value')) {
          const formula = DIMENSION_FORMULA_DEFAULTS[eid]
          this.addLog(`  default_value (formula): ${attr.label} → ${formula.title}`)
          // eslint-disable-next-line no-await-in-loop
          await this.saveAttrProperty(attr.attributeid, 'default_value', eid, 'formula', { value: formula.id, sid: formula.sid, title: formula.title }, attr)
          propCount += 1
        }
      }

      this.addLog(`Свойства атрибутов установлены: ${propCount} шт.`, 'success')
    },

    // Enrich modSet destentity with objectfull attribute metadata before saving
    // This ensures jsonmod contains the same fields as the working settings page
    enrichModSetFromAttr(modSet, attr) {
      if (!modSet || !modSet.list) return modSet
      const enriched = JSON.parse(JSON.stringify(modSet))
      for (const mod of enriched.list) {
        if (mod.destentity && mod.destentity.value === attr.entityid) {
          mod.destentity.title = attr.label || mod.destentity.title || ''
          mod.destentity.entitysid = attr.entitysid || mod.destentity.entitysid || ''
          mod.destentity.datatype = (attr.datatype && typeof attr.datatype === 'object'
            ? (attr.datatype.sid || attr.datatype.name || '')
            : (attr.datatype || '')) || mod.destentity.datatype || ''
          mod.destentity.attributeid = attr.attributeid || attr.id || mod.destentity.attributeid
          mod.destentity.parententityid = attr.parententityid || 0
          mod.destentity.refobjectid = attr.refobjectid || 0
        }
      }
      return enriched
    },

    // Build modification set JSON for cbsattributeparam.jsonmodification
    buildModification(entityId, operSid, ref) {
      const entity = this.allEntities.find(e => e.id === entityId)
      const destentity = entity
        ? {
          value: entity.id, sid: entity.sid || '', title: entity.name || '', datatype: entity.datatype || '',
        }
        : { value: entityId, sid: '', title: `#${entityId}` }

      // Build operMap from modoper refs (real DB IDs)
      const operMap = this.aiChatGetModOperMap()
      // Validate operSid — must be a known mod operand, not an action type like "insert"
      const validModFields = ['value', 'formula', 'function', 'scalar', 'entity', 'paramentity', 'sourceentity', 'sql']
      if (!validModFields.includes(operSid)) {
        console.warn(`[AI Chat] buildModification: invalid operSid="${operSid}", expected one of: ${validModFields.join(',')}`)
      }
      const oper = operMap[operSid] || operMap.value

      const mod = {
        isactive: true,
        name: '',
        descr: '',
        destentity,
        oper,
        value: { value: { value: null } },
        entity: { id: null, sid: null, title: null },
        scalar: { id: null, sid: null, title: null },
        formula: { id: null, sid: null, title: null },
        function: { id: null, sid: null, title: null },
      }

      if (operSid === 'value' && ref) {
        mod.value = { value: { value: ref.textValue || '' } }
      } else if (ref && operSid !== 'value') {
        // entity/paramentity/sourceentity all use the 'entity' field in the mod set
        const refField = ['entity', 'paramentity', 'sourceentity'].includes(operSid) ? 'entity' : operSid
        // Safety: only write to known fields, never create phantom fields like "insert"
        if (!['entity', 'formula', 'function', 'scalar'].includes(refField)) {
          console.warn(`[AI Chat] buildModification: unexpected refField="${refField}" for operSid="${operSid}"`)
        }
        mod[refField] = {
          value: ref.value, id: ref.value, sid: ref.sid || '', title: ref.title || '',
        }
      }

      return { isactive: true, list: [mod] }
    },

    async saveAttrProperty(attributeId, parameter, entityId, operSid, ref, attrMeta) {
      const rec = await recordApi.newRecord('cbsattributeparam')
      rec.attributeid.value = attributeId
      rec.attributeid.status = 'changed'
      rec.paramname.value = parameter
      rec.paramname.status = 'changed'
      let modSet = this.buildModification(entityId, operSid, ref)
      if (attrMeta) modSet = this.enrichModSetFromAttr(modSet, attrMeta)
      dbg('[AI Chat] saveAttrProperty SAVING jsonmod:', JSON.stringify(modSet, null, 2))
      if (rec.jsonmod) { rec.jsonmod.value = modSet; rec.jsonmod.status = 'changed' }
      if (rec.jsonargument) { rec.jsonargument.value = { argtype: null, argvalue: null }; rec.jsonargument.status = 'changed' }
      await recordApi.save('cbsattributeparam', rec)
    },

    // Save attribute property using ready modSet (from CbsModificationConstructor)
    // ── Phase 4: Create main assembly steps (only 2 mount links) ──
    async phaseCreateSteps() {
      const { mainAsmId, procAsmId, copyAsmId } = this.created

      this.addLog('Создаю шаги главной сборки...')
      await this.createMountStep({
        objectId: mainAsmId,
        name: 'Обработка',
        ordernum: 100,
        operId: this.getMountOperId('mount'),
        sourceobjectid: procAsmId,
      })
      await this.createMountStep({
        objectId: mainAsmId,
        name: 'Копирование',
        ordernum: 200,
        operId: this.getMountOperId('mount'),
        sourceobjectid: copyAsmId,
      })

      this.addLog('Шаги главной сборки созданы', 'success')
      this.addLog('Сборки Обработка и Копировать оставлены пустыми — добавьте шаги вручную.', 'info')
    },

    async createMountStep({
      objectId, name, ordernum, operId, sourceobjectid,
    }) {
      this.addLog(`  Шаг: ${name}`)

      // Get mountstep object numeric ID and build parent filter (like CbsObjectTable)
      const mountStepObjId = this.mountStepObjectFull && this.mountStepObjectFull.object
        ? this.mountStepObjectFull.object.id : null
      const asmFilter = this.mountStepFilter(objectId)

      // Load new record template WITH filter to pre-fill parent objectid
      const tplResp = await this.restQuery({
        method: 'newrecord',
        mode: 'sync',
        param: mountStepObjId
          ? { objectid: mountStepObjId, filter: asmFilter }
          : { objectsid: 'mountstep' },
      })
      const tpl = tplResp.data.result ? tplResp.data.result.record : (tplResp.data.record || null)
      if (!tpl || !tpl.record) throw new Error('Не удалось загрузить шаблон mountstep')
      const rec = tpl.record

      // Fill fields — objectid should be pre-filled via filter, set as fallback
      if (rec.objectid && !rec.objectid.value) { rec.objectid.value = objectId; rec.objectid.status = 'changed' }
      if (rec.name) { rec.name.value = name; rec.name.status = 'changed' }
      if (rec.ordernum) { rec.ordernum.value = ordernum; rec.ordernum.status = 'changed' }
      if (rec.mountoperid && operId) { rec.mountoperid.value = operId; rec.mountoperid.status = 'changed' }
      if (rec.sourceobjectid && sourceobjectid) { rec.sourceobjectid.value = sourceobjectid; rec.sourceobjectid.status = 'changed' }

      // Save — use objectid (numeric) like CbsObjectTable
      const saveResp = await this.restQuery({
        method: 'saverecord',
        mode: 'sync',
        param: mountStepObjId
          ? { objectid: mountStepObjId, record: rec }
          : { objectsid: 'mountstep', keymode: 'sid', record: rec },
      })
      if (saveResp.data.error) throw new Error(`Ошибка сохранения шага "${name}": ${saveResp.data.error}`)
    },

    // ── Phase 5: Save form params ──
    async phaseSaveFormParams() {
      const { formId } = this.created
      if (!formId) throw new Error('formId не найден — форма не была создана в Phase 1')
      this.addLog(`Сохраняю параметры формы (formId=${formId})...`)

      // Save render_type = pivot_input (jsonstring must be {} not null — backend parses it)
      await this.saveObjectParam(formId, 'render_type', 'pivot_input', {})

      // Save form_param with JSON config (paramvalue must be "" not null)
      const fp = this.buildFormParamJson()
      this.addLog(`  form_param JSON: ${fp.rows ? fp.rows.length : 0} rows, ${fp.column_heads ? fp.column_heads.length : 0} cols`)
      await this.saveObjectParam(formId, 'form_param', '', fp)

      this.addLog('Параметры формы сохранены', 'success')
    },

    // Overwrite existing objectparam: query to find record ID, then saverecord to update (no delete)
    async overwriteObjectParam(objectId, paramname, paramvalue, jsonstring) {
      // 1. Query objectparam to find existing record by object + paramname
      const resp = await this.restQuery({
        method: 'query',
        mode: 'sync',
        param: {
          objectsid: 'objectparam',
          limit: 100,
          offset: 0,
          filter: {
            node: {
              isactive: true,
              oper: { sid: 'and' },
              nodes: [],
              conds: [
                {
                  isactive: true,
                  oper: { sid: 'equal' },
                  args: [
                    { type: { sid: 'entitysid' }, value: 'object' },
                    { type: { sid: 'value' }, value: String(objectId) },
                  ],
                },
                {
                  isactive: true,
                  oper: { sid: 'equal' },
                  args: [
                    { type: { sid: 'entitysid' }, value: 'paramname' },
                    { type: { sid: 'value' }, value: paramname },
                  ],
                },
              ],
            },
          },
        },
      })
      const records = resp.data.result && resp.data.result.query && resp.data.result.query.recordset
        ? resp.data.result.query.recordset.records || []
        : []
      if (records.length === 0) return false

      // 2. Take the first record — update it via saverecord
      const c = records[0].cells || records[0]
      const existingId = c.id ? c.id.value : null
      if (!existingId) return false

      this.addLog(`  Перезаписываю ${paramname} (id=${existingId})...`)

      // 3. Build update record from existing cells — set changed fields
      const rec = {}
      // Copy all existing cell fields with status 'loaded'
      const cells = records[0].cells || records[0]
      for (const key of Object.keys(cells)) {
        if (cells[key] && typeof cells[key] === 'object' && 'value' in cells[key]) {
          rec[key] = { value: cells[key].value, status: 'loaded' }
        }
      }

      // 4. Overwrite the fields we want to change
      if (rec.paramvalue) {
        rec.paramvalue.value = paramvalue != null ? paramvalue : ''
        rec.paramvalue.status = 'changed'
      }
      if (rec.strvalue) {
        rec.strvalue.value = paramvalue != null ? paramvalue : ''
        rec.strvalue.status = 'changed'
      }
      if (rec.jsonstring && jsonstring !== null && jsonstring !== undefined) {
        rec.jsonstring.value = (typeof jsonstring === 'object') ? jsonstring : {}
        rec.jsonstring.status = 'changed'
      }

      // 5. Save
      const saveResp = await this.restQuery({
        method: 'saverecord', mode: 'sync', param: { objectsid: 'objectparam', keymode: 'sid', record: rec },
      })

      const err = saveResp.data.error || (saveResp.data.result && saveResp.data.result.error)
      if (err) {
        this.addLog(`    Ошибка перезаписи ${paramname}: ${JSON.stringify(err)}`, 'error')
        return false
      }

      this.addLog(`    ${paramname} перезаписан (id=${existingId})`, 'success')
      return true
    },

    async saveObjectParam(objectId, paramname, paramvalue, jsonstring) {
      const tplResp = await this.restQuery({
        method: 'newrecord', mode: 'sync', param: { objectsid: 'objectparam', keymode: 'sid' },
      })
      if (tplResp.data.error) throw new Error(`newrecord objectparam: ${JSON.stringify(tplResp.data.error)}`)

      const tpl = tplResp.data.result ? tplResp.data.result.record : (tplResp.data.record || null)
      if (!tpl || !tpl.record) {
        throw new Error('Не удалось загрузить шаблон objectparam')
      }
      const rec = tpl.record

      if (!rec.object) throw new Error('Поле object не найдено в шаблоне')
      rec.object.value = objectId
      rec.object.status = 'changed'

      if (!rec.paramname) throw new Error('Поле paramname не найдено в шаблоне')
      rec.paramname.value = paramname
      rec.paramname.status = 'changed'

      if (rec.strvalue) {
        rec.strvalue.value = paramvalue != null ? paramvalue : ''
        rec.strvalue.status = 'changed'
      }
      if (rec.paramvalue) {
        rec.paramvalue.value = paramvalue != null ? paramvalue : ''
        rec.paramvalue.status = 'changed'
      }

      if (rec.jsonstring && jsonstring !== null && jsonstring !== undefined) {
        rec.jsonstring.value = (typeof jsonstring === 'object') ? jsonstring : {}
        rec.jsonstring.status = 'changed'
      }

      const resp = await this.restQuery({
        method: 'saverecord', mode: 'sync', param: { objectsid: 'objectparam', keymode: 'sid', record: rec },
      })

      const err = resp.data.error || (resp.data.result && resp.data.result.error)
      if (err) throw new Error(`Ошибка сохранения параметра "${paramname}": ${JSON.stringify(err)}`)
    },

    // ── EDIT MODE: Enter & Load ──
    // Enter edit mode with known object IDs (from chain list picker)
    async enterEditModeWithObjects(chainId, objectIds) {
      this.editMode = true
      this.editLoading = true
      this.chainId = chainId
      this.editError = null
      try {
        this.identifyChainObjects(objectIds)
        await this.loadAndReconstructState()
        this.snapshotState()
      } catch (e) {
        console.error('[ChainWizard] enterEditModeWithObjects error:', e)
        this.editError = e.message
      } finally {
        this.editLoading = false
      }
    },

    // Enter edit mode by chain_id (from /chain_edit command — needs to discover objects)
    async enterEditMode(chainId) {
      this.editMode = true
      this.editLoading = true
      this.chainId = chainId
      this.editError = null
      try {
        const objectIds = await this.findChainObjectsByFullScan(chainId)
        if (objectIds.length === 0) throw new Error(`Не найдены объекты с chain_id=${chainId}`)
        this.identifyChainObjects(objectIds)
        await this.loadAndReconstructState()
        this.snapshotState()
      } catch (e) {
        console.error('[ChainWizard] enterEditMode error:', e)
        this.editError = e.message
      } finally {
        this.editLoading = false
      }
    },

    // Find all objects belonging to a chain by scanning objectfull params
    async findChainObjectsByFullScan(chainId) {
      // Scan form/cube/mount objects to find those with matching chain_id in objectfull params
      const candidates = this.allObjects.filter(o => {
        const meta = (o.meta || '').toLowerCase()
        return meta === 'form' || meta === 'cube' || meta === 'mount'
      })
      const found = []
      for (let i = 0; i < candidates.length; i += 10) {
        const batch = candidates.slice(i, i + 10)
        // eslint-disable-next-line no-await-in-loop
        const results = await Promise.all(
          batch.map(obj => this.restQuery({
            method: 'objectfull', mode: 'sync', param: { objectid: obj.id },
          }).catch(() => null)),
        )
        results.forEach((resp, idx) => {
          if (!resp) return
          const full = resp.data.result && resp.data.result.objectfull
          if (!full || !full.params || !full.params.params) return
          const cp = full.params.params.find(p => p.paramname === 'chain_id')
          if (!cp) return
          const cid = cp.paramvalue || cp.strvalue || ''
          if (cid === chainId) found.push(batch[idx].id)
        })
      }
      return found
    },

    identifyChainObjects(objectIds) {
      // Match each objectId to a role using allObjects meta + name patterns
      this.created = {
        formId: null, inputCubeId: null, summaryCubeId: null, mainAsmId: null, procAsmId: null, copyAsmId: null,
      }
      const objs = objectIds.map(id => this.allObjects.find(o => o.id === id)).filter(Boolean)

      for (const obj of objs) {
        const name = (obj.name || '').toLowerCase()
        const meta = (obj.meta || '').toLowerCase()
        if (meta === 'form') {
          this.created.formId = obj.id
        } else if (meta === 'cube') {
          if (name.includes('ввод') || name.includes('ввoд')) {
            this.created.inputCubeId = obj.id
          } else {
            this.created.summaryCubeId = obj.id
          }
        } else if (meta === 'mount') {
          if (name.includes('обработка')) {
            this.created.procAsmId = obj.id
          } else if (name.includes('копировать') || name.includes('копиров')) {
            this.created.copyAsmId = obj.id
          } else {
            this.created.mainAsmId = obj.id
          }
        }
      }
    },

    async loadAndReconstructState() {
      const { formId, inputCubeId, summaryCubeId } = this.created
      if (!formId || !inputCubeId || !summaryCubeId) {
        throw new Error('Не удалось идентифицировать все объекты цепочки (form, inputCube, summaryCube)')
      }

      // Load objectfull in parallel
      const [formResp, inputResp, summaryResp] = await Promise.all([
        this.restQuery({ method: 'objectfull', mode: 'sync', param: { objectid: formId } }),
        this.restQuery({ method: 'objectfull', mode: 'sync', param: { objectid: inputCubeId } }),
        this.restQuery({ method: 'objectfull', mode: 'sync', param: { objectid: summaryCubeId } }),
      ])

      const formFull = formResp.data.result && formResp.data.result.objectfull
      const inputFull = inputResp.data.result && inputResp.data.result.objectfull
      const summaryFull = summaryResp.data.result && summaryResp.data.result.objectfull

      if (!formFull || !inputFull || !summaryFull) {
        throw new Error('Не удалось загрузить objectfull для одного из объектов')
      }

      // Extract budget name from form object name: "Форма Бюджет X" → "X"
      const formName = (formFull.object && formFull.object.name) || ''
      const nameMatch = formName.match(/Форма\s+Бюджет\s+(.+)/i)
      this.budgetName = nameMatch ? nameMatch[1].trim() : formName

      // Try to load saved wizard state (reliable) before falling back to heuristic
      const savedState = this.extractWizardStateFromParams(formFull)

      if (savedState) {
        // ── Reliable path: use saved wizard state for structure ──
        this.selectedParamIds = savedState.selectedParamIds || []
        this.selectedDimIds = savedState.selectedDimIds || []
        this.inputCubeFieldIds = savedState.inputCubeFieldIds || []
        this.summaryCubeFieldIds = savedState.summaryCubeFieldIds || []
        this.formColumns = savedState.formColumns || []

        // ── Reconcile: merge actual server attributes into wizard state ──
        this.reconcileWithServerAttrs(formFull, inputFull, summaryFull)
      } else {
        // ── Fallback: heuristic reconstruction (old chains without saved state) ──
        const formEntityIds = (formFull.attributes || []).map(a => a.entityid).filter(Boolean)
        this.selectedParamIds = formEntityIds.filter(id => !STANDARD_IDS.has(id))

        const standardAndParamSet = new Set([...STANDARD_IDS, ...this.selectedParamIds])

        const inputEntityIds = (inputFull.attributes || []).map(a => a.entityid).filter(Boolean)
        const inputNonStandardParam = inputEntityIds.filter(id => !standardAndParamSet.has(id))

        const summaryEntityIds = (summaryFull.attributes || []).map(a => a.entityid).filter(Boolean)
        const summaryNonStandardParam = summaryEntityIds.filter(id => !standardAndParamSet.has(id))

        const summaryNSPSet = new Set(summaryNonStandardParam)
        // Only ref-type entities can be dimensions (excludes auto-created fields like SID)
        const isRefType = id => { const e = this.allEntities.find(x => x.id === id); return e && (e.datatype === 'ref' || e.datatype === 'refsid') }
        this.selectedDimIds = inputNonStandardParam.filter(id => summaryNSPSet.has(id) && isRefType(id))

        const dimSet = new Set(this.selectedDimIds)

        this.inputCubeFieldIds = inputNonStandardParam.filter(id => !dimSet.has(id))
        this.summaryCubeFieldIds = summaryNonStandardParam.filter(id => !dimSet.has(id))

        // Build default formColumns from dims + fields (all visible)
        this.formColumns = [
          ...this.selectedDimIds.map(id => ({
            id, type: 'dim', name: this.entityName(id), visible: true,
          })),
          ...this.inputCubeFieldIds.map(id => ({
            id, type: 'field', name: this.entityName(id), visible: true,
          })),
        ]
      }

      // Store input cube attributes for attribute properties panel
      this.inputCubeAttributes = (inputFull.attributes || []).map(a => ({
        attributeid: a.attributeid,
        entityid: a.entityid,
        label: a.label,
        entitysid: a.entitysid,
      }))

      // If formColumns is empty but we have dims/fields, build defaults
      if (this.formColumns.length === 0 && (this.selectedDimIds.length > 0 || this.inputCubeFieldIds.length > 0)) {
        this.formColumns = [
          ...this.selectedDimIds.map(id => ({
            id, type: 'dim', name: this.entityName(id), visible: true,
          })),
          ...this.inputCubeFieldIds.map(id => ({
            id, type: 'field', name: this.entityName(id), visible: true,
          })),
        ]
      }

      // ── Sanitize: remove invalid / standard entity IDs from all lists ──
      this.sanitizeLoadedState()

      // Mark all creation phases as done (objects already exist)
      this.phasesDone = {
        objects: true, attrs: true, props: true, steps: true, params: true, chainId: true,
      }
    },

    reconcileWithServerAttrs(formFull, inputFull, summaryFull) {
      const knownIds = new Set(this.allEntities.map(e => e.id))
      const isPickable = id => knownIds.has(id) && !STANDARD_IDS.has(id)

      // Build a set of ALL IDs already tracked in wizard state
      const alreadyTracked = () => new Set([
        ...this.selectedParamIds,
        ...this.selectedDimIds,
        ...this.inputCubeFieldIds,
        ...this.summaryCubeFieldIds,
      ])

      // Params: form attributes that aren't standard and not tracked anywhere
      const formEntityIds = (formFull.attributes || []).map(a => a.entityid).filter(Boolean)
      let tracked = alreadyTracked()
      let added = 0
      formEntityIds.forEach(id => {
        if (isPickable(id) && !tracked.has(id)) {
          this.selectedParamIds.push(id)
          added += 1
        }
      })
      if (added) console.warn(`[ChainWizard] Reconcile: added ${added} server params not in saved state`)

      // Rebuild exclusion set after params may have changed
      const excludeSet = new Set([...STANDARD_IDS, ...this.selectedParamIds])

      // Input cube: non-standard non-param entity IDs not tracked anywhere
      const inputEntityIds = (inputFull.attributes || []).map(a => a.entityid).filter(Boolean)
      const inputExtra = inputEntityIds.filter(id => isPickable(id) && !excludeSet.has(id))

      // Summary cube: non-standard non-param entity IDs
      const summaryEntityIds = (summaryFull.attributes || []).map(a => a.entityid).filter(Boolean)
      const summaryExtraSet = new Set(summaryEntityIds.filter(id => isPickable(id) && !excludeSet.has(id)))

      // Dims = in both cubes AND ref-type AND not already tracked
      const isRefType = id => { const e = this.allEntities.find(x => x.id === id); return e && (e.datatype === 'ref' || e.datatype === 'refsid') }
      tracked = alreadyTracked()
      let dimsAdded = 0
      inputExtra.forEach(id => {
        if (summaryExtraSet.has(id) && !tracked.has(id) && isRefType(id)) {
          this.selectedDimIds.push(id)
          dimsAdded += 1
        }
      })
      if (dimsAdded) console.warn(`[ChainWizard] Reconcile: added ${dimsAdded} server dims`)

      const dimSet = new Set(this.selectedDimIds)

      // Input fields = inputCube extras not dims, not already tracked
      tracked = alreadyTracked()
      let inputFieldsAdded = 0
      inputExtra.forEach(id => {
        if (!dimSet.has(id) && !tracked.has(id)) {
          this.inputCubeFieldIds.push(id)
          inputFieldsAdded += 1
        }
      })
      if (inputFieldsAdded) console.warn(`[ChainWizard] Reconcile: added ${inputFieldsAdded} server input fields`)

      // Summary fields = summaryCube extras not dims, not already tracked
      tracked = alreadyTracked()
      let summaryFieldsAdded = 0
      summaryEntityIds.forEach(id => {
        if (isPickable(id) && !excludeSet.has(id) && !dimSet.has(id) && !tracked.has(id)) {
          this.summaryCubeFieldIds.push(id)
          summaryFieldsAdded += 1
        }
      })
      if (summaryFieldsAdded) console.warn(`[ChainWizard] Reconcile: added ${summaryFieldsAdded} server summary fields`)
    },

    sanitizeLoadedState() {
      const knownIds = new Set(this.allEntities.map(e => e.id))
      const isValid = id => knownIds.has(id) && !STANDARD_IDS.has(id)

      const cleanArr = (arr, label) => {
        const clean = arr.filter(isValid)
        const removed = arr.filter(id => !isValid(id))
        if (removed.length > 0) {
          console.warn(`[ChainWizard] Sanitize: removed ${removed.length} invalid IDs from ${label}:`, removed)
        }
        return clean
      }

      this.selectedParamIds = cleanArr(this.selectedParamIds, 'params')
      this.selectedDimIds = cleanArr(this.selectedDimIds, 'dims')
      this.inputCubeFieldIds = cleanArr(this.inputCubeFieldIds, 'inputFields')
      this.summaryCubeFieldIds = cleanArr(this.summaryCubeFieldIds, 'summaryFields')

      // Clean formColumns: remove entries for entities no longer valid
      const allCurrentIds = new Set([...this.selectedDimIds, ...this.inputCubeFieldIds])
      this.formColumns = this.formColumns.filter(c => allCurrentIds.has(c.id) && knownIds.has(c.id))
    },

    extractWizardStateFromParams(formFull) {
      if (!formFull.params || !formFull.params.params) return null
      const stateParam = formFull.params.params.find(p => p.paramname === 'chain_wizard_state')
      if (!stateParam) return null

      // New format: stored as object in jsonstring
      if (stateParam.jsonstring && typeof stateParam.jsonstring === 'object' && Array.isArray(stateParam.jsonstring.selectedDimIds)) {
        return stateParam.jsonstring
      }

      // Legacy fallback: stored as JSON string in strvalue/paramvalue
      const raw = stateParam.paramvalue || stateParam.strvalue
      if (!raw) return null
      try {
        const parsed = JSON.parse(raw)
        if (parsed && Array.isArray(parsed.selectedDimIds)) return parsed
        return null
      } catch (e) {
        return null
      }
    },

    snapshotState() {
      this.originalState = {
        budgetName: this.budgetName,
        selectedParamIds: [...this.selectedParamIds],
        selectedDimIds: [...this.selectedDimIds],
        inputCubeFieldIds: [...this.inputCubeFieldIds],
        summaryCubeFieldIds: [...this.summaryCubeFieldIds],
        formColumns: JSON.parse(JSON.stringify(this.formColumns)),
      }
    },

    // ── DIFF COMPUTATION ──
    computeDiff() {
      const orig = this.originalState
      if (!orig) return null
      const arrDiff = (oldArr, newArr) => ({
        added: newArr.filter(id => !oldArr.includes(id)),
        removed: oldArr.filter(id => !newArr.includes(id)),
      })
      const paramsDiff = arrDiff(orig.selectedParamIds, this.selectedParamIds)
      const dimsDiff = arrDiff(orig.selectedDimIds, this.selectedDimIds)
      const inputFieldsDiff = arrDiff(orig.inputCubeFieldIds, this.inputCubeFieldIds)
      const summaryFieldsDiff = arrDiff(orig.summaryCubeFieldIds, this.summaryCubeFieldIds)
      const formColumnsChanged = JSON.stringify(orig.formColumns || []) !== JSON.stringify(this.formColumns)
      // form_param changes if dims, params, inputFields, summaryFields, formColumns or name changed
      const formParamChanged = paramsDiff.added.length > 0 || paramsDiff.removed.length > 0
        || dimsDiff.added.length > 0 || dimsDiff.removed.length > 0
        || inputFieldsDiff.added.length > 0 || inputFieldsDiff.removed.length > 0
        || summaryFieldsDiff.added.length > 0 || summaryFieldsDiff.removed.length > 0
        || formColumnsChanged
        || orig.budgetName !== this.budgetName.trim()
      return {
        nameChanged: orig.budgetName !== this.budgetName.trim(),
        paramsAdded: paramsDiff.added,
        paramsRemoved: paramsDiff.removed,
        dimsAdded: dimsDiff.added,
        dimsRemoved: dimsDiff.removed,
        inputFieldsAdded: inputFieldsDiff.added,
        inputFieldsRemoved: inputFieldsDiff.removed,
        summaryFieldsAdded: summaryFieldsDiff.added,
        summaryFieldsRemoved: summaryFieldsDiff.removed,
        formColumnsChanged,
        formParamChanged,
      }
    },

    // ── EDIT MODE: Apply changes ──
    async runEdit() {
      const diff = this.computeDiff()
      if (!diff) return

      this.step = 10
      this.creationError = false
      this.creationDone = false
      this.log = []
      this.progressPercent = 0
      this.$emit('wizard-active', true)

      try {
        const t0 = Date.now()
        const elapsed = () => `${((Date.now() - t0) / 1000).toFixed(1)}s`

        // Phase 1: Rename objects if name changed
        if (diff.nameChanged) {
          await this.phaseRenameObjects()
          this.addLog(`  [${elapsed()}]`)
        }
        this.progressPercent = 15

        // Phase 2: Edit params (add/remove on form + 3 assemblies)
        if (diff.paramsAdded.length > 0 || diff.paramsRemoved.length > 0) {
          await this.phaseEditParams(diff)
          this.addLog(`  [${elapsed()}]`)
        }
        this.progressPercent = 30

        // Phase 3: Edit dimensions (add/remove on both cubes)
        if (diff.dimsAdded.length > 0 || diff.dimsRemoved.length > 0) {
          await this.phaseEditDimensions(diff)
          this.addLog(`  [${elapsed()}]`)
        }
        this.progressPercent = 45

        // Phase 4: Edit input cube fields
        if (diff.inputFieldsAdded.length > 0 || diff.inputFieldsRemoved.length > 0) {
          await this.phaseEditInputFields(diff)
          this.addLog(`  [${elapsed()}]`)
        }
        this.progressPercent = 55

        // Phase 5: Edit summary cube fields
        if (diff.summaryFieldsAdded.length > 0 || diff.summaryFieldsRemoved.length > 0) {
          await this.phaseEditSummaryFields(diff)
          this.addLog(`  [${elapsed()}]`)
        }
        this.progressPercent = 65

        // Set auto-defaults for newly added attributes
        const newAttrIds = [...(diff.dimsAdded || []), ...(diff.inputFieldsAdded || [])]
        if (newAttrIds.length > 0) {
          await this.phaseSetNewAttrDefaults(newAttrIds)
          this.addLog(`  [${elapsed()}]`)
        }
        this.progressPercent = 70

        this.progressPercent = 80

        // Phase 7: Rebuild form_param
        if (diff.formParamChanged) {
          await this.phaseRebuildFormParam()
          this.addLog(`  [${elapsed()}]`)
        }
        this.progressPercent = 90

        // Phase 8: Save updated wizard state for reliable reconstruction
        await this.phaseSaveWizardState()
        this.progressPercent = 100

        this.addLog(`Все изменения успешно применены! [${elapsed()}]`, 'success')
        this.creationDone = true
      } catch (e) {
        this.addLog(`ОШИБКА: ${e.message}`, 'error')
        this.creationError = true
      }
    },

    async phaseRenameObjects() {
      const nm = this.n
      this.addLog('Переименование объектов...')
      const renames = [
        { key: 'formId', name: `Форма Бюджет ${nm}` },
        { key: 'inputCubeId', name: `Куб Бюджет ${nm} Ввод` },
        { key: 'summaryCubeId', name: `Куб Бюджет ${nm}` },
        { key: 'mainAsmId', name: `Сборка Бюджет ${nm}` },
        { key: 'procAsmId', name: `Сборка Бюджет ${nm} Обработка` },
        { key: 'copyAsmId', name: `Сборка Бюджет ${nm} Копировать` },
      ]
      for (const r of renames) {
        const objectId = this.created[r.key]
        if (!objectId) continue
        this.addLog(`  Переименование #${objectId} → ${r.name}`)
        // eslint-disable-next-line no-await-in-loop
        await this.restQuery({
          method: 'saverecord',
          mode: 'sync',
          param: {
            objectsid: 'object',
            record: {
              id: { value: objectId, status: 'loaded' },
              name: { value: r.name, status: 'changed' },
            },
          },
        })
      }
      this.addLog('Объекты переименованы', 'success')
    },

    async phaseEditParams(diff) {
      this.addLog('Изменение параметров...')
      // Objects that have params: form + 3 assemblies
      const targets = ['formId', 'mainAsmId', 'procAsmId', 'copyAsmId']

      // Add new params
      for (const eid of diff.paramsAdded) {
        this.addLog(`  Добавляю параметр ${this.entityName(eid)}...`)
        for (const key of targets) {
          const objectId = this.created[key]
          if (!objectId) continue
          // eslint-disable-next-line no-await-in-loop
          await this.addAttr(objectId, eid)
        }
      }

      // Remove old params
      for (const eid of diff.paramsRemoved) {
        this.addLog(`  Удаляю параметр ${this.entityName(eid)}...`)
        for (const key of targets) {
          const objectId = this.created[key]
          if (!objectId) continue
          // eslint-disable-next-line no-await-in-loop
          await this.removeAttrByEntityId(objectId, eid)
        }
      }

      // Set isrequired only when new params were added
      if (diff.paramsAdded.length > 0) {
        for (const key of targets) {
          const objectId = this.created[key]
          if (!objectId) continue
          // eslint-disable-next-line no-await-in-loop
          await this.setAttrsRequired(objectId)
        }
      }

      this.addLog('Параметры обновлены', 'success')
    },

    async phaseEditDimensions(diff) {
      this.addLog('Изменение измерений...')
      const cubes = ['inputCubeId', 'summaryCubeId']

      for (const eid of diff.dimsAdded) {
        this.addLog(`  Добавляю измерение ${this.entityName(eid)}...`)
        for (const key of cubes) {
          const objectId = this.created[key]
          if (!objectId) continue
          // eslint-disable-next-line no-await-in-loop
          await this.addAttr(objectId, eid)
        }
      }

      for (const eid of diff.dimsRemoved) {
        this.addLog(`  Удаляю измерение ${this.entityName(eid)}...`)
        for (const key of cubes) {
          const objectId = this.created[key]
          if (!objectId) continue
          // eslint-disable-next-line no-await-in-loop
          await this.removeAttrByEntityId(objectId, eid)
        }
      }

      this.addLog('Измерения обновлены', 'success')
    },

    async phaseEditInputFields(diff) {
      this.addLog('Изменение полей куба ввода...')
      const objectId = this.created.inputCubeId
      if (!objectId) return

      for (const eid of diff.inputFieldsAdded) {
        this.addLog(`  Добавляю поле ${this.entityName(eid)}...`)
        // eslint-disable-next-line no-await-in-loop
        await this.addAttr(objectId, eid)
      }

      for (const eid of diff.inputFieldsRemoved) {
        this.addLog(`  Удаляю поле ${this.entityName(eid)}...`)
        // eslint-disable-next-line no-await-in-loop
        await this.removeAttrByEntityId(objectId, eid)
      }

      this.addLog('Поля куба ввода обновлены', 'success')
    },

    async phaseEditSummaryFields(diff) {
      this.addLog('Изменение полей сводного куба...')
      const objectId = this.created.summaryCubeId
      if (!objectId) return

      for (const eid of diff.summaryFieldsAdded) {
        this.addLog(`  Добавляю поле ${this.entityName(eid)}...`)
        // eslint-disable-next-line no-await-in-loop
        await this.addAttr(objectId, eid)
      }

      for (const eid of diff.summaryFieldsRemoved) {
        this.addLog(`  Удаляю поле ${this.entityName(eid)}...`)
        // eslint-disable-next-line no-await-in-loop
        await this.removeAttrByEntityId(objectId, eid)
      }

      this.addLog('Поля сводного куба обновлены', 'success')
    },

    // Set auto-defaults (DEFAULT_VALUE_PROPS, DIMENSION_FORMULA_DEFAULTS) for newly added attributes only
    async phaseSetNewAttrDefaults(newEntityIds) {
      if (newEntityIds.length === 0) return
      const needDefaults = newEntityIds.filter(eid => DEFAULT_VALUE_PROPS[eid] || DIMENSION_FORMULA_DEFAULTS[eid])
      if (needDefaults.length === 0) return

      const objectId = this.created.inputCubeId
      if (!objectId) return

      this.addLog('Устанавливаю авто-дефолты для новых атрибутов...')
      const resp = await this.restQuery({
        method: 'objectfull', mode: 'sync', param: { objectid: objectId },
      })
      const objectFull = resp.data.result && resp.data.result.objectfull
      if (!objectFull || !objectFull.attributes) return

      const needSet = new Set(needDefaults)
      let count = 0
      for (const attr of objectFull.attributes) {
        const eid = attr.entityid
        if (!needSet.has(eid)) continue

        // Auto-defaults are always applied for newly added attributes

        if (DEFAULT_VALUE_PROPS[eid]) {
          const def = DEFAULT_VALUE_PROPS[eid]
          this.addLog(`  default_value: ${attr.label}`)
          // eslint-disable-next-line no-await-in-loop
          await this.saveAttrProperty(attr.attributeid, 'default_value', eid, def.operSid, def.ref, attr)
          count += 1
        }
        if (DIMENSION_FORMULA_DEFAULTS[eid]) {
          const formula = DIMENSION_FORMULA_DEFAULTS[eid]
          this.addLog(`  default_value (formula): ${attr.label} → ${formula.title}`)
          // eslint-disable-next-line no-await-in-loop
          await this.saveAttrProperty(attr.attributeid, 'default_value', eid, 'formula', { value: formula.id, sid: formula.sid, title: formula.title }, attr)
          count += 1
        }
      }
      if (count) this.addLog(`Авто-дефолты установлены: ${count} шт.`, 'success')
    },

    async phaseRebuildFormParam() {
      const { formId } = this.created
      if (!formId) return

      this.addLog('Обновление form_param...')
      const fp = this.buildFormParamJson()
      this.addLog(`  form_param JSON: ${fp.rows ? fp.rows.length : 0} rows, ${fp.column_heads ? fp.column_heads.length : 0} cols`)

      // Try to find existing record via query and update in-place (no delete — removerecord hangs)
      const updated = await this.overwriteObjectParam(formId, 'form_param', '', fp)
      if (!updated) {
        // No existing record — create new one
        await this.saveObjectParam(formId, 'form_param', '', fp)
      }

      this.addLog('form_param обновлён', 'success')
    },

    // ── Helper: remove attribute by entityId ──
    async removeAttrByEntityId(objectId, entityId) {
      // Load objectfull to find attribute by entityId
      const resp = await this.restQuery({
        method: 'objectfull', mode: 'sync', param: { objectid: objectId },
      })
      const objectFull = resp.data.result && resp.data.result.objectfull
      if (!objectFull || !objectFull.attributes) {
        this.addLog(`    Предупреждение: не удалось загрузить атрибуты объекта #${objectId}`, 'error')
        return
      }

      const attr = objectFull.attributes.find(a => a.entityid === entityId)
      if (!attr) {
        this.addLog(`    Предупреждение: атрибут с entityId=${entityId} не найден в объекте #${objectId}`, 'error')
        return
      }

      // First mark as deleted via saverecord
      await this.restQuery({
        method: 'saverecord',
        mode: 'sync',
        param: {
          objectsid: 'attribute',
          record: {
            id: { value: attr.attributeid, status: 'loaded' },
            name: { value: attr.label, status: 'loaded' },
            objectid: { value: objectId, status: 'loaded' },
            entityid: { value: attr.entityid, status: 'loaded' },
            del: { value: true, status: 'changed' },
          },
        },
      })

      // Then remove
      const attrObj = this.allObjects.find(o => o.sid === 'attribute')
      const param = {
        objectsid: 'attribute',
        record: {
          id: { value: attr.attributeid, status: 'loaded' },
          name: { value: attr.label, status: 'loaded' },
          objectid: { value: objectId, status: 'loaded' },
          entityid: { value: attr.entityid, status: 'loaded' },
          del: { value: true, status: 'loaded' },
        },
      }
      if (attrObj) param.objectid = attrObj.id

      try {
        const removeResp = await this.restQuery({ method: 'removerecord', param })
        if (removeResp.data && removeResp.data.thread) {
          await this.waitForThread(removeResp.data.thread)
        }
      } catch (e) {
        // Log but don't crash — continue with other operations
        this.addLog(`    Ошибка удаления атрибута ${attr.label} (${entityId}): ${e.message}`, 'error')
      }
    },

    // ── Helper: wait for thread completion ──
    waitForThread(threadName) {
      return new Promise((resolve, reject) => {
        const poll = () => {
          this.restQuery({
            method: 'thread',
            param: { threadname: threadName },
          })
            .then(r => {
              const t = r.data && r.data.thread
              if (t && t.status === 'done') {
                resolve(t)
              } else if (t && t.status === 'error') {
                // Extract actual error message from thread result
                const errMsg = (t.result && (t.result.error || t.result.message))
                  || t.error || t.message || threadName
                reject(new Error(String(errMsg)))
              } else {
                setTimeout(poll, 500)
              }
            })
            .catch(e => reject(e))
        }
        setTimeout(poll, 500)
      })
    },

    // ── Helper: delete attribute properties (soft-delete via saverecord, no removerecord — it hangs) ──
    // ── Helper: delete objectparam by paramname (via query — returns real record IDs) ──
    async deleteObjectParam(objectId, paramname) {
      // Query objectparam records for this object + paramname (same pattern as deleteAttrProperties)
      const resp = await this.restQuery({
        method: 'query',
        mode: 'sync',
        param: {
          objectsid: 'objectparam',
          limit: 1000,
          offset: 0,
          filter: {
            node: {
              isactive: true,
              oper: { sid: 'and' },
              nodes: [],
              conds: [
                {
                  isactive: true,
                  oper: { sid: 'equal' },
                  args: [
                    { type: { sid: 'entitysid' }, value: 'object' },
                    { type: { sid: 'value' }, value: String(objectId) },
                  ],
                },
                {
                  isactive: true,
                  oper: { sid: 'equal' },
                  args: [
                    { type: { sid: 'entitysid' }, value: 'paramname' },
                    { type: { sid: 'value' }, value: paramname },
                  ],
                },
              ],
            },
          },
        },
      })
      const records = resp.data.result && resp.data.result.query && resp.data.result.query.recordset
        ? resp.data.result.query.recordset.records || []
        : []
      for (const rec of records) {
        const c = rec.cells || rec
        const id = c.id ? c.id.value : null
        if (!id) continue
        // eslint-disable-next-line no-await-in-loop
        try {
          const removeResp = await this.restQuery({
            method: 'removerecord',
            param: {
              objectsid: 'objectparam',
              record: {
                id: { value: id, status: 'loaded' },
                del: { value: true, status: 'loaded' },
              },
            },
          })
          if (removeResp.data && removeResp.data.thread) {
            // eslint-disable-next-line no-await-in-loop
            await this.waitForThread(removeResp.data.thread)
          }
        } catch (e) {
          this.addLog(`    Ошибка удаления objectparam ${id}: ${e.message}`, 'error')
        }
      }
    },

    // ── form_param JSON builder ──
    buildFormParamJson() {
      const dimIds = this.formColumns.length > 0 ? this.visibleFormDimIds : this.selectedDimIds
      const paramIds = this.allParamEntityIds
      const fieldIds = this.formColumns.length > 0 ? this.visibleFormFieldIds : this.inputCubeFieldIds
      const cubeId = this.created.inputCubeId

      // column_heads: follow user-configured order from visibleFormColumns
      let columnHeads
      if (this.formColumns.length > 0) {
        columnHeads = this.visibleFormColumns.map(c => this.entityName(c.id))
      } else {
        columnHeads = [
          ...dimIds.map(id => this.entityName(id)),
          ...fieldIds.map(id => this.entityName(id)),
        ]
      }

      // ── Column order: follow visibleFormColumns if available, else dims+fields ──
      const useFormOrder = this.formColumns.length > 0
      const orderedCols = useFormOrder ? this.visibleFormColumns : [
        ...dimIds.map(id => ({ id, type: 'dim' })),
        ...fieldIds.map(id => ({ id, type: 'field' })),
      ]

      // ── Build rows: groupby rows (one per dimension) + record row ──
      const rows = []

      // Groupby rows — each groups by one dimension
      dimIds.forEach((groupDimId, groupIdx) => {
        const cols = orderedCols.map(c => {
          if (c.type === 'dim') {
            return c.id === groupDimId ? { entityid: c.id } : { entityid: null }
          }
          return { type: 'aggr_sum', destination_entityid: c.id, align: 'right' }
        })

        // filter: base (del=false + params) + all parent groupby dims as paramentity
        const filterConds = this.buildBaseConds(paramIds)
        for (let pi = 0; pi < groupIdx; pi++) {
          filterConds.push(this.buildParamCond(dimIds[pi]))
        }

        rows.push({
          objectid: cubeId,
          addrecord: true,
          columns: cols,
          results: [{ destination_entityid: groupDimId, source_entityid: groupDimId }],
          filter: {
            isActive: true,
            node: {
              isactive: true, oper: { sid: 'and' }, nodes: [], conds: filterConds,
            },
          },
          groupby: { isactive: true, groups: [{ isactive: true, oper: { sid: 'group' }, entity: { value: groupDimId } }] },
          orderby: { isactive: true, sorts: [{ isactive: true, oper: { sid: 'asc' }, entity: { value: groupDimId } }] },
        })
      })

      // Record row — detail level
      const recCols = orderedCols.map(c => {
        const editable = c.editable !== false
        if (c.type === 'dim') return { entityid: c.id, editable }
        return { entityid: c.id, editable, align: 'right' }
      })

      // filter: base + ALL dimensions as paramentity
      const recFilterConds = this.buildBaseConds(paramIds)
      dimIds.forEach(dimId => { recFilterConds.push(this.buildParamCond(dimId)) })

      rows.push({
        objectid: cubeId,
        mode: 'record',
        addrecord: true,
        columns: recCols,
        results: [],
        filter: {
          isActive: true,
          node: {
            isactive: true, oper: { sid: 'and' }, nodes: [], conds: recFilterConds,
          },
        },
        orderby: { isactive: true, sorts: [{ isactive: true, oper: { sid: 'asc' }, entity: { value: 1 } }] },
      })

      // grand_total: null for dims, sumrows for numeric fields
      const gtCols = orderedCols.map(c => {
        if (c.type === 'dim') return null
        return { type: 'sumrows', entityid: c.id, align: 'right' }
      })

      return {
        name: `Форма Бюджет ${this.n}`,
        column_heads: columnHeads,
        rows,
        grand_total: { column_heads: gtCols },
      }
    },

    // Base filter conditions: del=false + each param = paramentity
    buildBaseConds(paramIds) {
      const conds = [
        {
          isactive: true,
          oper: { sid: 'equal' },
          args: [
            { type: { sid: 'entity' }, value: 11 },
            { type: { sid: 'value' }, value: false },
          ],
        },
      ]
      paramIds.forEach(eid => { conds.push(this.buildParamCond(eid)) })
      return conds
    },

    // Single condition: entity = paramentity
    buildParamCond(entityId) {
      return {
        isactive: true,
        oper: { sid: 'equal' },
        args: [
          { type: { sid: 'entity' }, value: entityId },
          { type: { sid: 'paramentity' }, value: entityId },
        ],
      }
    },

    // ── AI Chat Panel ──
    aiChatGetWsUrl() {
      const baseURL = getConfig()
      const url = new URL('/ws/chat', baseURL)
      url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:'
      return url.toString()
    },
    aiChatConnect() {
      if (this.aiChatWs && this.aiChatWs.readyState === WebSocket.OPEN) return
      this.aiChatDisconnect()
      const url = this.aiChatGetWsUrl()
      if (process.env.NODE_ENV === 'development') dbg('[AI Chat] Connecting to', url)
      this.aiChatWs = new WebSocket(url)
      this.aiChatWs.onopen = () => {
        if (process.env.NODE_ENV === 'development') dbg('[AI Chat] WebSocket opened')
        this.aiChatConnected = true
        this.aiChatReconnectAttempts = 0
        this.aiChatWs.send(JSON.stringify({ type: 'auth', token: this.getToken() }))
      }
      this.aiChatWs.onmessage = event => {
        if (process.env.NODE_ENV === 'development') {
          dbg('[AI Chat] Raw WS message:', event.data.substring(0, 500))
          if (isDev) console.timeEnd('[AI Chat] Response time')
        }
        try {
          const data = JSON.parse(event.data)
          if (data.type === 'message') {
            this.aiChatWaiting = false
            const { text: cleanText, actions } = this.aiChatParseActions(data.text || '')
            this.aiChatMessages.push({ sender: 'bot', text: cleanText, format: data.format })
            this.$nextTick(() => this.aiChatScrollToBottom())
            if (actions.length > 0) {
              this.aiChatExecuteActions(actions)
            }
          } else if (data.type === 'error') {
            this.aiChatWaiting = false
            this.aiChatMessages.push({ sender: 'bot', text: `Ошибка: ${data.text}` })
          }
        } catch (err) { console.warn('[AI Chat] Failed to parse WS message:', err) }
      }
      this.aiChatWs.onclose = ev => {
        if (process.env.NODE_ENV === 'development') dbg('[AI Chat] WebSocket closed, code:', ev.code, 'reason:', ev.reason)
        this.aiChatConnected = false
        if (this.aiChatReconnectAttempts < 10) {
          const delay = Math.min(3000 * Math.pow(2, this.aiChatReconnectAttempts), 30000)
          this.aiChatReconnectAttempts += 1
          this.aiChatReconnectTimer = setTimeout(() => this.aiChatConnect(), delay)
        }
      }
      this.aiChatWs.onerror = ev => {
        console.error('[AI Chat] WebSocket error:', ev)
        this.aiChatConnected = false
      }
    },
    aiChatDisconnect() {
      if (this.aiChatReconnectTimer) { clearTimeout(this.aiChatReconnectTimer); this.aiChatReconnectTimer = null }
      if (this.aiChatWs) { this.aiChatWs.onclose = null; this.aiChatWs.close(); this.aiChatWs = null }
      this.aiChatConnected = false
      this.aiChatReconnectAttempts = 0
    },
    aiChatBuildContext() {
      const ctx = { step: this.step, budgetName: this.n }

      // ── Shared: build refs context (formula/function/scalar) ──
      const buildRefsCtx = (maxRefs = 80) => {
        const operRefs = {}
        const hasDetails = Object.keys(this.aiChatRefDetails).length > 0
        for (const sid of ['formula', 'function', 'scalar']) {
          const refs = this.aiChatOperandRefs[sid]
          if (refs && refs.length > 0) {
            operRefs[sid] = refs.slice(0, maxRefs).map(r => {
              const fp = hasDetails ? this.aiChatRefFingerprint(sid, r.value) : ''
              return fp ? [r.value, r.title, fp] : [r.value, r.title]
            })
            if (refs.length > maxRefs) operRefs[`${sid}_total`] = refs.length
          }
        }
        return operRefs
      }

      // ── Shared: system prompt (communication style) ──
      const systemPrompt = 'Ты — помощник по настройке бюджетной модели. Общайся с пользователем ЕСТЕСТВЕННО, как коллега-эксперт.\n'
        + 'ПРАВИЛА ОБЩЕНИЯ:\n'
        + '- Отвечай на вопрос пользователя ПРЯМО. Если спрашивают "что сейчас настроено?" — опиши словами, не JSON.\n'
        + '- Если что-то непонятно — спроси на ЧЕЛОВЕЧЕСКОМ языке (например: "Какой курс использовать для Июля?" а НЕ "Укажите refId").\n'
        + '- Пользователь НЕ видит id. Говори НАЗВАНИЯМИ: "Сумма Авг", "функция Курс Валюты", а не "id=275".\n'
        + '- Кратко объясни ЧТО делаешь и ЗАЧЕМ, прежде чем выполнить.\n'
        + '- Для массовых операций (>5 штук) — покажи короткий план и жди "да"/"ок".\n'
        + '- Для 1-5 операций — СРАЗУ выполняй, не спрашивай подтверждение.\n'
        + '- НЕ предлагай варианты A/B/C. Исследуй сам, выбери лучший вариант, выполни.\n'

      // ── Shared: technical reference (action execution) ──
      const techRef = 'ТЕХНИЧЕСКАЯ СПРАВКА (для внутреннего использования, НЕ показывай пользователю):\n'
        + 'Выполнение действий: добавь блок ```action\\n{...}\\n```.\n'
        + 'Поиск: {"action":"search_refs_by_content","entityNames":["Имя1","Имя2"],"refType":"formula|function|scalar|all"}\n'
        + 'Детали рефа: {"action":"get_ref_details","refType":"formula|function","refIds":[id1,id2,...]} (до 5 за раз)\n'
        + 'Результаты search/get_details отправляются тебе автоматически.\n'
        + 'refs в контексте — первые 80. Если нужного нет — используй search_refs_by_content.\n'
        + 'Алгоритм поиска: 1) ищи в refs по НАЗВАНИЮ, 2) search_refs_by_content, 3) только если не нашлось — спроси пользователя.\n'
        + 'НИКОГДА не выдумывай id — бери ТОЛЬКО из данных контекста, refs или результатов поиска.\n'
        + 'КРИТИЧЕСКИ ВАЖНО: ВСЕГДА указывай operSid (тип: formula/function/scalar) И refName (ТОЧНОЕ название из списка refs).\n'
        + 'НЕ полагайся на refId — разные типы могут иметь одинаковый id! refName+operSid = однозначная идентификация.\n'
        + 'Для полей используй НАЗВАНИЯ: fieldName, destName, srcName, entityName вместо числовых id.\n'

      if (this.step === 4) {
        ctx.description = 'Настройка свойств полей куба ввода (формулы расчёта, значения по умолчанию).'
        ctx.inputCubeId = this.created.inputCubeId
        const hasRefMap = this.aiChatAttrRefMap && Object.keys(this.aiChatAttrRefMap).length > 0
        // Compact attributes list with per-attribute relevant refs (cap at 50 to limit context size)
        const attrsForCtx = this.inputCubeAttributes.slice(0, 50)
        if (this.inputCubeAttributes.length > 50) ctx.inputCubeAttributesTotal = this.inputCubeAttributes.length
        ctx.inputCubeAttributes = attrsForCtx.map(a => {
          const props = this.aiChatAttrProps ? this.aiChatAttrProps[a.attributeid] : null
          const shortProps = (props || []).map(p => {
            const s = { p: p.paramname }
            if (p.id) s.rid = p.id
            if (p.jsonmod && p.jsonmod.list && p.jsonmod.list[0]) {
              const m = p.jsonmod.list[0]
              if (m.oper) s.o = m.oper.sid
              if (m.formula && m.formula.id) { s.f = m.formula.title; s.fid = m.formula.id }
              if (m.function && m.function.id) { s.fn = m.function.title; s.fnid = m.function.id }
              if (m.scalar && m.scalar.id) { s.sc = m.scalar.title; s.scid = m.scalar.id }
              if (m.entity && m.entity.id) { s.ent = m.entity.title; s.entid = m.entity.id }
              if (m.value && m.value.value && m.value.value.value != null) s.v = m.value.value.value
            }
            return s
          })
          const attr = { name: a.label, props: shortProps.length > 0 ? shortProps : undefined }
          // Attach relevant refs (matched by internal entity references)
          if (hasRefMap && this.aiChatAttrRefMap[a.entityid]) {
            const rm = this.aiChatAttrRefMap[a.entityid]
            const relevant = []
            for (const type of ['function', 'formula', 'scalar']) {
              for (const r of (rm[type] || []).slice(0, 5)) {
                relevant.push({ type, name: r.title, desc: r.desc })
              }
            }
            if (relevant.length > 0) attr.relevantRefs = relevant
          }
          return attr
        })
        const validOperSids = (this.mountOperands || []).map(o => o.sid).filter(Boolean)
        if (validOperSids.length === 0) validOperSids.push('value', 'formula', 'function', 'scalar', 'entity', 'paramentity', 'sourceentity', 'sql')
        ctx.operands = validOperSids
        ctx.refs = buildRefsCtx()

        ctx.actions_help = `${systemPrompt
        }\nКОНТЕКСТ ШАГА: Настройка свойств полей. Каждое поле может иметь calculation (формула расчёта) и default_value (значение по умолчанию).\n`
          + 'Свойство задаётся через тип: function (функция), formula (формула), scalar (скаляр), value (текстовое значение).\n'
          + 'В inputCubeAttributes — список полей с текущими свойствами и РЕКОМЕНДОВАННЫМИ рефами (relevantRefs).\n'
          + 'relevantRefs — рефы, которые ВНУТРИ себя ссылаются на это поле. desc — описание внутренней структуры.\n'
          + 'ВАЖНО: выбирай реф из relevantRefs поля! Если там function с desc="Умножение(Сумма Авг, Курс_Валюты)" — это правильный выбор.\n'
          + 'Если relevantRefs пуст — используй search_refs_by_content или спроси пользователя.\n'
          + '\nОТВЕТ ПОЛЬЗОВАТЕЛЮ: описывай что делаешь внутренностями рефа, например:\n'
          + '"Назначаю полю «Сумма Авг» функцию «Сумма_В_Валюте * Курс_Валюты» (умножает Сумму в валюте на Курс валюты)"\n'
          + `\n${techRef
          }\nДЕЙСТВИЯ ШАГА 4:\n`
          + 'Удалить свойство: {"action":"delete_attr_prop","rid":<recordId>}\n'
          + 'Добавить свойство: {"action":"save_attr_prop","fieldName":"<название поля>","param":"calculation|default_value","operSid":"<тип>","refName":"<название рефа>"}\n'
          + '  Пример: {"action":"save_attr_prop","fieldName":"Сумма Авг","param":"calculation","operSid":"function","refName":"Сумма_В_Валюте * Курс_Валюты"}\n'
          + `  operSid — ТИП модификации (ОБЯЗАТЕЛЬНО указать правильный): ${validOperSids.map(s => `"${s}"`).join(',')}.\n`
          + '  refName — ТОЧНОЕ название функции/формулы/скаляра из списка refs или relevantRefs.\n'
          + '  Для value — вместо refName передай "textValue":"<значение>".\n'
          + '  aid/eid — необязательны если указан fieldName (система найдёт по названию).\n'
          + '  Для замены свойства — сначала delete_attr_prop, потом save_attr_prop.\n'
      } else if (this.step === 7 || this.step === 8) {
        const isProc = this.step === 7
        const asmId = isProc ? this.created.procAsmId : this.created.copyAsmId
        ctx.description = isProc
          ? 'Настройка шагов обработки данных. Каждый шаг — операция (insert/update/delete) с маппингом полей и фильтрами.'
          : 'Настройка шагов копирования из куба ввода в сводный куб. Каждый шаг — вставка с маппингом полей.'
        ctx.asmId = asmId
        ctx.inputCubeId = this.created.inputCubeId
        ctx.summaryCubeId = this.created.summaryCubeId
        const hasRefMap78 = this.aiChatAttrRefMap && Object.keys(this.aiChatAttrRefMap).length > 0
        ctx.inputFields = [...this.selectedDimIds, ...this.inputCubeFieldIds].map(id => {
          const f = { id, name: this.entityName(id) }
          if (hasRefMap78 && this.aiChatAttrRefMap[id]) {
            const rm = this.aiChatAttrRefMap[id]
            const rel = []
            for (const type of ['function', 'formula', 'scalar']) {
              for (const r of (rm[type] || []).slice(0, 3)) rel.push({ type, name: r.title, desc: r.desc })
            }
            if (rel.length > 0) f.relevantRefs = rel
          }
          return f
        })
        ctx.summaryFields = [...this.selectedDimIds, ...this.summaryCubeFieldIds].map(id => {
          const f = { id, name: this.entityName(id) }
          if (hasRefMap78 && this.aiChatAttrRefMap[id]) {
            const rm = this.aiChatAttrRefMap[id]
            const rel = []
            for (const type of ['function', 'formula', 'scalar']) {
              for (const r of (rm[type] || []).slice(0, 3)) rel.push({ type, name: r.title, desc: r.desc })
            }
            if (rel.length > 0) f.relevantRefs = rel
          }
          return f
        })
        ctx.paramFields = this.selectedParamIds.map(id => ({ id, name: this.entityName(id) }))
        const stepsKey = String(asmId)
        if (this.aiChatMountSteps && this.aiChatMountSteps[stepsKey]) {
          ctx.mountSteps = this.aiChatMountSteps[stepsKey]
        }
        ctx.mountOpers = (this.mountOperands || []).map(o => ({ id: o.id, sid: o.sid, name: o.name }))
        ctx.refs = buildRefsCtx()

        ctx.actions_help = `${systemPrompt
        }\nКОНТЕКСТ ШАГА: ${isProc
          ? 'Шаги обработки определяют как данные обрабатываются (insert/update/delete по условиям).'
          : 'Шаги копирования переносят данные из куба ввода в сводный куб по месяцам/полям.'}\n`
          + 'inputFields — поля куба ввода, summaryFields — поля сводного куба, paramFields — параметры (сценарий, год и т.д.).\n'
          + 'mountSteps — существующие шаги. Изучи их структуру (маппинги, фильтры) прежде чем создавать новые — повторяй паттерн.\n'
          + `\n${techRef
          }\nДЕЙСТВИЯ ШАГА ${this.step}:\n`
          + 'Обновить шаги: {"action":"query_mountsteps"}\n'
          + 'Создать шаг: {"action":"create_mountstep","name":"<имя>","operSid":"insert",\n'
          + '  "mappings":[{"srcName":"<поле источника>","destName":"<поле назначения>","oper":"sourceentity"}],\n'
          + '  "functions":[{"destName":"<поле>","refName":"<название функции>"}],\n'
          + '  "formulas":[{"destName":"<поле>","refName":"<название формулы>"}],\n'
          + '  "values":[{"destName":"<поле>","val":"<текст>"}],\n'
          + '  "filters":[{"entityName":"<название поля>","oper":"equal","value":"<значение>"},\n'
          + '             {"entityName":"<название поля>","oper":"equal","value":<paramFieldId>,"argType":"paramentity"},\n'
          + '             {"entityName":"<название поля>","oper":"isnull"}]}\n'
          + '  ВАЖНО: используй НАЗВАНИЯ полей (srcName/destName/entityName) и рефов (refName) — НЕ числовые ID!\n'
          + '  Числовые src/dest/refId можно добавить как подсказку, но названия ПРИОРИТЕТНЕЕ.\n'
          + '  operSid шага: insert, update, delete.\n'
          + '  Маппинг: mappings — копирование полей, functions/formulas — вычисление через функцию/формулу, values — статическое значение.\n'
          + '  Фильтры: oper — equal/notequal/greater/less/isnull/isnotnull/like/in. argType:"paramentity" — сравнить с параметром.\n'
          + 'Удалить шаг: {"action":"delete_mountstep","stepId":<recordId>}\n'
      }
      return ctx
    },
    // Load all attribute properties (cbsattributeparam) for input cube attributes
    async aiChatLoadAttrProps() {
      if (!this.inputCubeAttributes.length) return
      this.aiChatAttrProps = {}
      const attrIds = this.inputCubeAttributes.map(a => a.attributeid).filter(Boolean)
      if (attrIds.length === 0) return

      // Query cbsattributeparam for all attributes of the input cube in batches
      for (let i = 0; i < attrIds.length; i += 20) {
        const batch = attrIds.slice(i, i + 20)
        // Build OR conditions for each attribute ID
        const conds = batch.map(aid => ({
          isactive: true,
          oper: { sid: 'equal' },
          args: [
            { type: { sid: 'entitysid' }, value: 'attribute' },
            { type: { sid: 'value' }, value: String(aid) },
          ],
        }))
        try {
          // eslint-disable-next-line no-await-in-loop
          const records = await recordApi.query('cbsattributeparam', {
            limit: 500,
            filter: {
              node: {
                isactive: true, oper: { sid: 'or' }, nodes: [], conds,
              },
            },
          })
          for (const rec of records) {
            const cells = rec.cells || rec
            if (cells.del && cells.del.value) continue
            const aid = cells.attributeid ? cells.attributeid.value : null
            if (!aid) continue
            if (!this.aiChatAttrProps[aid]) this.aiChatAttrProps[aid] = []
            this.aiChatAttrProps[aid].push({
              id: cells.id ? cells.id.value : null,
              paramname: cells.paramname ? cells.paramname.value : '',
              jsonmod: cells.jsonmod ? cells.jsonmod.value : null,
            })
          }
        } catch (e) {
          console.error('[ChainWizard] aiChatLoadAttrProps error:', e)
        }
      }
    },
    // Load mount steps for an assembly (steps 7-8)
    async aiChatLoadMountSteps(asmId) {
      if (!asmId) return
      try {
        const records = await recordApi.query('mountstep', { limit: 200, filter: this.mountStepFilter(asmId) })
        const steps = records.filter(rec => { const c = rec.cells || rec; return !(c.del && c.del.value) }).map(rec => {
          const c = rec.cells || rec
          const operId = c.mountoperid ? c.mountoperid.value : null
          const op = operId ? (this.mountOperands || []).find(o => o.id === operId) : null
          // Parse jsonmod field mappings
          const jsonmod = c.jsonmod ? c.jsonmod.value : null
          const mappings = []
          if (jsonmod && jsonmod.list) {
            for (const m of jsonmod.list) {
              const destId = m.destentity ? (m.destentity.value || m.destentity.id) : null
              const destName = m.destentity ? (m.destentity.title || '') : ''
              const operSid = m.oper ? m.oper.sid : ''
              if (operSid === 'sourceentity' || operSid === 'entity') {
                const srcId = m.entity ? (m.entity.id || m.entity.value) : null
                const srcName = m.entity ? (m.entity.title || '') : ''
                mappings.push({
                  src: srcId, srcName, dest: destId, destName, oper: operSid,
                })
              } else if (operSid === 'value') {
                const val = m.value && m.value.value ? m.value.value.value : null
                mappings.push({
                  dest: destId, destName, oper: 'value', val,
                })
              } else if (operSid === 'formula' || operSid === 'function' || operSid === 'scalar') {
                const refObj = m[operSid]
                const refId = refObj ? (refObj.id || refObj.value) : null
                const refName = refObj ? (refObj.title || '') : ''
                mappings.push({
                  dest: destId, destName, oper: operSid, refId, refName,
                })
              }
            }
          }
          // Parse jsonfilter conditions (handles both entity-object and entitysid formats)
          const jsonfilter = c.jsonfilter ? c.jsonfilter.value : null
          const filterConds = []
          if (jsonfilter && jsonfilter.node && jsonfilter.node.conds) {
            for (const cond of jsonfilter.node.conds) {
              if (!cond.isactive || !cond.args || cond.args.length < 2) continue
              const arg0 = cond.args[0]
              const arg1 = cond.args[1]
              // entity type: value is object {value, entitysid, ...}; entitysid type: value is string
              let entityId = arg0.entityid
              if (!entityId && arg0.value) {
                entityId = typeof arg0.value === 'object' ? (arg0.value.value || arg0.value.id) : arg0.value
              }
              const entitySid = arg0.entitysid
                || (arg0.value && typeof arg0.value === 'object' ? arg0.value.entitysid : '')
                || ''
              filterConds.push({
                entityId,
                entitySid,
                oper: cond.oper ? cond.oper.sid : 'equal',
                value: arg1.value,
                argType: arg1.type ? arg1.type.sid : 'value',
              })
            }
          }
          return {
            id: c.id ? c.id.value : null,
            name: c.name ? c.name.value : '',
            ordernum: c.ordernum ? c.ordernum.value : 0,
            operSid: op ? op.sid : `operId=${operId}`,
            mappings,
            filters: filterConds.length > 0 ? filterConds : undefined,
          }
        }).sort((a, b) => (a.ordernum || 0) - (b.ordernum || 0))
        if (!this.aiChatMountSteps) this.aiChatMountSteps = {}
        this.$set(this.aiChatMountSteps, String(asmId), steps)
        dbg(`[AI Chat] Loaded ${steps.length} mount steps for assembly ${asmId}`)
      } catch (e) {
        console.error('[AI Chat] aiChatLoadMountSteps error:', e)
      }
    },
    // Build jsonmod for a mount step with field mappings
    aiChatBuildMountStepMod(mappings) {
      const list = mappings.map((m, idx) => {
        // Resolve dest entity: by ID or by name
        let destEntity = m.dest ? this.allEntities.find(e => e.id === m.dest) : null
        if (!destEntity && m.destName) destEntity = this.aiChatFindEntityByName(m.destName)
        const destentity = destEntity
          ? { value: destEntity.id, sid: destEntity.sid || '', title: destEntity.name || '' }
          : { value: m.dest, sid: '', title: m.destName || `#${m.dest}` }

        // Build oper from modoper refs (real DB IDs)
        const operMap = this.aiChatGetModOperMap()
        const oper = operMap[m.oper] || operMap.sourceentity

        const mod = {
          isactive: true,
          name: '',
          descr: '',
          destentity,
          oper,
          value: { value: { value: null } },
          entity: { id: null, sid: null, title: null },
          scalar: { id: null, sid: null, title: null },
          formula: { id: null, sid: null, title: null },
          function: { id: null, sid: null, title: null },
        }

        if (m.oper === 'value') {
          mod.value = { value: { value: m.val != null ? String(m.val) : '' } }
          dbg(`[AI Chat] mod[${idx}] dest=${destentity.title} oper=value val=${m.val}`)
        } else if (m.oper === 'sourceentity' || m.oper === 'entity') {
          // Resolve src entity: by ID or by name
          let srcEntity = m.src ? this.allEntities.find(e => e.id === m.src) : null
          if (!srcEntity && m.srcName) srcEntity = this.aiChatFindEntityByName(m.srcName)
          mod.entity = srcEntity
            ? {
              value: srcEntity.id, id: srcEntity.id, sid: srcEntity.sid || '', title: srcEntity.name || '',
            }
            : {
              value: m.src, id: m.src, sid: '', title: m.srcName || `#${m.src}`,
            }
          dbg(`[AI Chat] mod[${idx}] dest=${destentity.title} oper=${m.oper} src=${srcEntity ? srcEntity.name : m.src}`)
        } else if (['formula', 'function', 'scalar'].includes(m.oper) || m.refId || m.refName) {
          // Resolve ref: NAME-based primary, ID-based secondary (within specified type only)
          const numRefId = Number(m.refId)
          let ref = null
          let resolvedOper = m.oper

          // ── PRIMARY: Name-based resolution ──
          if (m.refName && ['formula', 'function', 'scalar'].includes(m.oper)) {
            ref = this.aiChatFindRefByName(m.refName, m.oper)
            if (ref) {
              dbg(`[AI Chat] mod[${idx}] found "${m.refName}" by name in ${m.oper} → id=${ref.value} "${ref.title}"`)
            } else {
              // Try other types by name (safe — name is unique enough)
              for (const type of ['formula', 'function', 'scalar']) {
                if (type === m.oper) continue
                ref = this.aiChatFindRefByName(m.refName, type)
                if (ref) {
                  resolvedOper = type
                  dbg(`[AI Chat] mod[${idx}] "${m.refName}" found in ${type} (was ${m.oper}) → id=${ref.value}`)
                  break
                }
              }
            }
          }

          // ── SECONDARY: ID-based (only within specified type — NO cross-type auto-detect!) ──
          if (!ref && numRefId && ['formula', 'function', 'scalar'].includes(m.oper)) {
            const refList = this.aiChatOperandRefs[m.oper] || []
            ref = refList.find(r => r.value === numRefId || r.value === m.refId)
          }

          if (!ref) {
            console.warn(`[AI Chat] mod[${idx}] dest=${destentity.title} oper=${m.oper} refName=${m.refName} refId=${m.refId} NOT FOUND — skipping`)
            this.aiChatMessages.push({ sender: 'bot', text: `Ошибка: реф "${m.refName || m.refId}" (${m.oper}) не найден — пропуск модификации для ${destentity.title}` })
            return null // skip broken mod item
          }
          dbg(`[AI Chat] mod[${idx}] dest=${destentity.title} oper=${resolvedOper} ref="${ref.title}" (id=${ref.value})`)
          const resolvedOperMap = operMap[resolvedOper] || operMap[m.oper] || operMap.sourceentity
          mod.oper = resolvedOperMap
          mod[resolvedOper] = {
            value: ref.value, id: ref.value, sid: ref.sid || '', title: ref.title || '',
          }
        }
        return mod
      }).filter(m => m !== null)
      return { isactive: true, list }
    },
    // Build jsonfilter for a mount step from filter conditions array
    // Each filter: { entityId, entitySid?, oper, value, argType?: "paramentity"|"value" }
    aiChatBuildMountStepFilter(filters) {
      // Operator metadata: sid → { name, args (number of arguments) }
      const operMeta = {
        equal: { name: '=', args: 2 },
        notequal: { name: '<>', args: 2 },
        greater: { name: '>', args: 2 },
        less: { name: '<', args: 2 },
        greaterorequal: { name: '>=', args: 2 },
        lessorequal: { name: '<=', args: 2 },
        notgreater: { name: '<=', args: 2 },
        notless: { name: '>=', args: 2 },
        like: { name: 'Like', args: 2 },
        contain: { name: 'Contain', args: 2 },
        isnull: { name: 'IsNull', args: 1 },
        isnotnull: { name: 'IsNotNull', args: 1 },
        null: { name: 'IsNull', args: 1 },
        notnull: { name: 'IsNotNull', args: 1 },
        in: { name: 'In', args: 2 },
      }
      const conds = filters.map(f => {
        // Robustly extract entity ID (AI may send number, string, or object {id, name})
        let eid = f.entityId
        if (eid && typeof eid === 'object') eid = eid.id || eid.value
        eid = Number(eid)
        // ── Name-based entity resolution (primary) ──
        if ((isNaN(eid) || !eid) && f.entityName) {
          const resolved = this.aiChatFindEntityByName(f.entityName)
          if (resolved) { eid = resolved.id; dbg(`[AI Chat] filter: resolved "${f.entityName}" → id=${eid}`) }
        }
        // Resolve entity from numeric ID
        const entity = !isNaN(eid) ? this.allEntities.find(e => e.id === eid) : null
        const entitySid = entity ? entity.sid : (f.entitySid || '')
        if (!entitySid) {
          console.warn('[AI Chat] filter: cannot resolve entity for', f.entityId)
        }
        let operSid = f.oper || 'equal'
        // Robustly extract filter value
        let val = f.value
        if (val && typeof val === 'object') val = val.id || val.value || val.name || ''
        // Auto-convert "equal null" to "isnull" (unless paramentity)
        if (operSid === 'equal' && val == null && f.argType !== 'paramentity') {
          operSid = 'isnull'
        }
        // Build entity selection object matching CbsFilterConstructor format
        const entityValue = entity ? {
          value: entity.id,
          title: entity.name || '',
          entitysid: entity.sid || '',
          datatype: entity.datatype || null,
          parententityid: entity.parententityid || null,
        } : (eid || null)
        const meta = operMeta[operSid] || { name: operSid, args: 2 }
        const oper = { sid: operSid, name: meta.name, args: meta.args }
        // Entity arg (first arg — always present)
        const entityArg = {
          type: { id: 1, sid: 'entity', name: 'Entity' },
          datatype: null,
          entityid: entity ? entity.id : null,
          entitysid: entitySid || null,
          parententityid: null,
          value: entityValue,
        }
        // For 1-arg operators (isnull, isnotnull) — only entity arg
        if (meta.args === 1) {
          dbg(`[AI Chat] filter cond: entity=${entitySid}(${eid}) oper=${operSid} (1-arg)`)
          return { isactive: true, oper, args: [entityArg] }
        }
        // Build second arg based on argType
        const argType = f.argType || 'value'
        let secondArg
        if (argType === 'paramentity') {
          // Param entity reference: value is the param entity ID
          let paramVal = f.value
          if (paramVal && typeof paramVal === 'object') paramVal = paramVal.id || paramVal.value
          paramVal = Number(paramVal) || eid
          const paramEntity = !isNaN(paramVal) ? this.allEntities.find(e => e.id === paramVal) : null
          const paramValue = paramEntity ? {
            value: paramEntity.id,
            title: paramEntity.name || '',
            entitysid: paramEntity.sid || '',
            datatype: paramEntity.datatype || null,
            parententityid: paramEntity.parententityid || null,
          } : paramVal
          secondArg = {
            type: { id: 3, sid: 'paramentity', name: 'ParamEntity' },
            datatype: null,
            entityid: paramEntity ? paramEntity.id : paramVal,
            entitysid: paramEntity ? (paramEntity.sid || null) : null,
            parententityid: null,
            value: paramValue,
          }
        } else {
          // Regular value arg
          secondArg = {
            type: { id: 2, sid: 'value', name: 'Value' },
            datatype: entity ? (entity.datatype || null) : null,
            entityid: entity ? entity.id : null,
            entitysid: entitySid || null,
            parententityid: entity ? (entity.parententityid || null) : null,
            value: val != null ? String(val) : '',
          }
        }
        dbg(`[AI Chat] filter cond: entity=${entitySid}(${eid}) oper=${operSid} argType=${argType} value=${val}`)
        return { isactive: true, oper, args: [entityArg, secondArg] }
      })
      return {
        isActive: true,
        node: {
          isactive: true,
          isexpanded: true,
          oper: { id: 1, sid: 'and', name: 'And' },
          nodes: [],
          conds,
        },
      }
    },
    // Load available references for each operand type (formula, function, scalar) via entref API
    async aiChatLoadOperandRefs() {
      if (this.aiChatOperandRefsLoading) return
      if (Object.keys(this.aiChatOperandRefs).length > 0) return
      this.aiChatOperandRefsLoading = true
      for (const sid of ['formula', 'function', 'scalar']) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const items = await recordApi.loadRefs(sid)
          const arr = Array.isArray(items) ? items : []
          const mapped = arr.map(x => ({ value: x.value, sid: x.sid, title: x.title || `(${x.value})` }))
          this.$set(this.aiChatOperandRefs, sid, mapped)
        } catch (e) {
          console.error(`[AI Chat] Failed to load ${sid} refs:`, e)
          this.$set(this.aiChatOperandRefs, sid, [])
        }
      }
      this.aiChatOperandRefsLoading = false
      dbg('[AI Chat] Operand refs loaded:', Object.keys(this.aiChatOperandRefs).map(k => `${k}:${(this.aiChatOperandRefs[k] || []).length}`).join(', '))
      if (!this.aiChatModOperRefs) this.aiChatLoadModOperRefs()
    },
    async aiChatLoadModOperRefs() {
      try {
        const items = await recordApi.loadRefs('modoper')
        const arr = Array.isArray(items) ? items : []
        const mapped = arr.map(x => ({ value: x.value, sid: x.sid, title: x.title || x.sid }))
        this.aiChatModOperRefs = mapped
        dbg('[AI Chat] ModOper refs loaded:', mapped.map(r => `${r.sid}:${r.value}`).join(', '))
      } catch (e) {
        console.error('[AI Chat] Failed to load modoper refs:', e)
        this.aiChatModOperRefs = []
      }
    },
    // Build modification operand map using real modoper IDs (falls back to hardcoded)
    aiChatGetModOperMap() {
      const operMap = {
        sourceentity: { sid: 'sourceentity', title: 'SourceEntity', value: 4 },
        value: { sid: 'value', title: 'Value', value: 1 },
        entity: { sid: 'entity', title: 'Entity', value: 2 },
        paramentity: { sid: 'paramentity', title: 'ParamEntity', value: 3 },
        formula: { sid: 'formula', title: 'Формула', value: 6 },
        function: { sid: 'function', title: 'Функция', value: 9 },
        scalar: { sid: 'scalar', title: 'Скаляр', value: 8 },
        sql: { sid: 'sql', title: 'SQL', value: 10 },
      }
      // Override with real modoper IDs if loaded
      if (this.aiChatModOperRefs && this.aiChatModOperRefs.length > 0) {
        for (const mo of this.aiChatModOperRefs) {
          if (mo.sid) operMap[mo.sid] = { sid: mo.sid, title: mo.title || mo.sid, value: mo.value }
        }
      }
      return operMap
    },
    // Poll thread for entref result
    aiChatPollThread(threadName) {
      return new Promise((resolve, reject) => {
        const poll = () => {
          this.restQuery({ method: 'thread', param: { threadname: threadName } })
            .then(r => {
              if (r.data.thread && r.data.thread.status === 'done') {
                const items = (r.data.thread.result.ref || []).map(x => ({
                  value: x.value, sid: x.sid, title: x.title || `(${x.value})`,
                }))
                resolve(items)
              } else {
                setTimeout(poll, 500)
              }
            })
            .catch(reject)
        }
        poll()
      })
    },
    // ── Load internal details for formulas & functions via refdetails API (with fallback) ──
    async aiChatLoadRefDetails() {
      if (this.aiChatRefDetailsLoading) return
      if (Object.keys(this.aiChatRefDetails).length > 0) return
      this.aiChatRefDetailsLoading = true
      this.aiChatRefDetails = { formula: {}, function: {} }

      const funcRefs = this.aiChatOperandRefs.function || []
      const formulaRefs = this.aiChatOperandRefs.formula || []

      // Load via refdetails API (returns parsed jsonfunction with resolved entity names)
      let apiWorked = false
      try {
        // Load functions in batches of 50
        for (let i = 0; i < funcRefs.length; i += 50) {
          const batchIds = funcRefs.slice(i, i + 50).map(r => r.value)
          // eslint-disable-next-line no-await-in-loop
          const items = await recordApi.loadRefDetails('function', batchIds)
          if (items.length > 0) apiWorked = true
          for (const func of items) {
            this.aiChatRefDetails.function[func.id] = {
              name: func.name || '',
              oper: func.oper ? (func.oper.title || func.oper.sid || '') : '',
              operSid: func.oper ? (func.oper.sid || '') : '',
              args: (func.args || []).map(a => ({
                typeSid: a.argtype || '',
                refTitle: a.entityName || '',
                refId: a.argvalue ? Number(a.argvalue) || null : null,
              })),
            }
          }
        }
        // Load formulas in batches of 50
        for (let i = 0; i < formulaRefs.length; i += 50) {
          const batchIds = formulaRefs.slice(i, i + 50).map(r => r.value)
          // eslint-disable-next-line no-await-in-loop
          const items = await recordApi.loadRefDetails('formula', batchIds)
          for (const frm of items) {
            this.aiChatRefDetails.formula[frm.id] = (frm.parts || []).map(p => ({
              order: 0,
              partType: p.oper ? p.oper.name : '',
              partTypeSid: p.oper ? p.oper.sid : '',
              entity: p.entityName || '',
              entityId: p.entityid || null,
              sql: p.sqlString || '',
              scalarid: p.scalarid || null,
              functionid: p.functionid || null,
            }))
          }
        }
        if (apiWorked) {
          const withArgs = Object.values(this.aiChatRefDetails.function).filter(d => d.args.length > 0).length
          dbg('[AI Chat] refdetails API: loaded',
            Object.keys(this.aiChatRefDetails.function).length, `functions (${withArgs} with args),`,
            Object.keys(this.aiChatRefDetails.formula).length, 'formulas')
        }
      } catch (e) {
        console.warn('[AI Chat] refdetails API not available, using fallback:', e.message || e)
      }

      // Fallback: load via query API if refdetails didn't work
      if (!apiWorked) {
        dbg('[AI Chat] Using fallback method for ref details...')
        try {
          const records = await recordApi.query('formulapart', { limit: 5000 })
          for (const rec of records) {
            const cells = rec.cells || rec
            const formulaId = cells.formula ? cells.formula.value : null
            if (!formulaId) continue
            if (!this.aiChatRefDetails.formula[formulaId]) this.aiChatRefDetails.formula[formulaId] = []
            const part = { order: cells.ordernum ? cells.ordernum.value : 0 }
            if (cells.formulaparttype) { part.partType = cells.formulaparttype.title || ''; part.partTypeSid = cells.formulaparttype.sid || '' }
            if (cells.entity && cells.entity.value) { part.entity = cells.entity.title || ''; part.entityId = cells.entity.value }
            if (cells.sqlstring && cells.sqlstring.value) part.sql = cells.sqlstring.value
            this.aiChatRefDetails.formula[formulaId].push(part)
          }
          for (const fid of Object.keys(this.aiChatRefDetails.formula)) {
            this.aiChatRefDetails.formula[fid].sort((a, b) => (a.order || 0) - (b.order || 0))
          }
          dbg('[AI Chat] Fallback: formula parts loaded:', Object.keys(this.aiChatRefDetails.formula).length, 'formulas')
        } catch (e) { console.error('[AI Chat] Failed to load formula parts:', e) }

        try {
          for (let i = 0; i < funcRefs.length; i += 20) {
            const batch = funcRefs.slice(i, i + 20)
            const conds = batch.map(f => ({ isactive: true, oper: { sid: 'equal' }, args: [{ type: { sid: 'entitysid' }, value: 'id' }, { type: { sid: 'value' }, value: String(f.value) }] }))
            // eslint-disable-next-line no-await-in-loop
            const records = await recordApi.query('function', {
              limit: 50,
              filter: {
                node: {
                  isactive: true, oper: { sid: 'or' }, nodes: [], conds,
                },
              },
            })
            for (const rec of records) {
              const cells = rec.cells || rec
              const funcId = cells.id ? cells.id.value : null
              if (!funcId) continue
              const detail = { args: [] }
              if (cells.operand) detail.oper = cells.operand.title || cells.operand.sid || ''
              if (cells.name) detail.name = cells.name.value || cells.name.title || ''
              this.aiChatRefDetails.function[funcId] = detail
            }
          }
          dbg('[AI Chat] Fallback: function records loaded:', Object.keys(this.aiChatRefDetails.function).length, 'functions')
        } catch (e) { console.error('[AI Chat] Failed to load function details:', e) }
      }

      this.aiChatRefDetailsLoading = false
      // Build attribute-to-ref relevance map
      this.aiChatBuildAttrRefMap()
    },
    // ── Compact fingerprint for a ref (for AI context) ──
    // Human-readable description of what a ref does internally
    aiChatRefDescribe(type, refId) {
      if (type === 'function') {
        const detail = this.aiChatRefDetails.function ? this.aiChatRefDetails.function[refId] : null
        if (!detail) return ''
        const oper = detail.oper || ''
        const argNames = detail.args.filter(a => a.refTitle).map(a => a.refTitle)
        if (oper && argNames.length > 0) return `${oper}(${argNames.join(', ')})`
        if (oper && detail.name) return `${oper}(${detail.name})`
        if (oper) return oper
        return ''
      }
      if (type === 'formula') {
        const parts = this.aiChatRefDetails.formula ? this.aiChatRefDetails.formula[refId] : null
        if (!parts || parts.length === 0) return ''
        const segs = parts.map(p => {
          if (p.entity) return p.entity
          if (p.sql) return p.sql.length > 20 ? `${p.sql.substring(0, 20)}...` : p.sql
          return ''
        }).filter(Boolean)
        return segs.join(' ')
      }
      if (type === 'scalar') {
        const ref = (this.aiChatOperandRefs.scalar || []).find(r => r.value === Number(refId))
        return ref ? ref.title : ''
      }
      return ''
    },
    // Build a chat-friendly action summary for save_attr_prop
    aiChatDescribeAttrAction(attrLabel, param, operSid, refLabel, refId) {
      const desc = this.aiChatRefDescribe(operSid, refId)
      const typeLabelMap = {
        function: 'функцию',
        formula: 'формулу',
        scalar: 'скаляр',
        value: 'значение',
      }
      const typeLabel = typeLabelMap[operSid] || operSid
      let msg = `Свойство «${attrLabel}» → ${param}: ${typeLabel} «${refLabel}»`
      if (desc) msg += `\n  ↳ ${desc}`
      return msg
    },
    // Build a chat-friendly summary for a single mount step mapping
    aiChatDescribeMapping(m, ref, resolvedOper) {
      const destName = m.destName || `#${m.dest}`
      if (resolvedOper === 'sourceentity' || resolvedOper === 'entity') {
        const srcName = m.srcName || `#${m.src}`
        return `${destName} ← ${srcName}`
      }
      if (resolvedOper === 'value') {
        return `${destName} = "${m.val}"`
      }
      // formula/function/scalar
      const typeLabel = { function: 'функция', formula: 'формула', scalar: 'скаляр' }[resolvedOper] || resolvedOper
      const refTitle = ref ? ref.title : (m.refName || `#${m.refId}`)
      const desc = ref ? this.aiChatRefDescribe(resolvedOper, ref.value) : ''
      let line = `${destName} ← ${typeLabel} «${refTitle}»`
      if (desc) line += ` = ${desc}`
      return line
    },
    aiChatRefFingerprint(sid, refId) {
      if (sid === 'formula') {
        const parts = this.aiChatRefDetails.formula ? this.aiChatRefDetails.formula[refId] : null
        if (!parts || parts.length === 0) return ''
        // Build: "e:EntityName+sql:*+e:OtherEntity"
        const segs = parts.map(p => {
          if (p.entity) return `e:${p.entity}`
          if (p.sql) return `sql:${p.sql.length > 15 ? p.sql.substring(0, 15) : p.sql}`
          if (p.partTypeSid) return p.partTypeSid
          return '?'
        })
        const fp = segs.join('+')
        return fp.length > 80 ? `${fp.substring(0, 77)}...` : fp
      }
      if (sid === 'function') {
        const detail = this.aiChatRefDetails.function ? this.aiChatRefDetails.function[refId] : null
        if (!detail) return ''
        const segments = []
        if (detail.oper) segments.push(`op:${detail.oper}`)
        // If we have parsed args, show them
        if (detail.args.length > 0) {
          detail.args.forEach(a => {
            if (a.refTitle) segments.push(`${a.typeSid}:${a.refTitle}`)
            else if (a.typeSid) segments.push(a.typeSid)
          })
        } else if (detail.name) {
          // No parsed args — use function name as content hint (names are descriptive)
          segments.push(`name:${detail.name}`)
        }
        const fp = segments.filter(Boolean).join(',')
        return fp.length > 100 ? `${fp.substring(0, 97)}...` : fp
      }
      return ''
    },
    // ── Build relevance map: for each attribute entity, find refs that use it internally ──
    aiChatBuildAttrRefMap() {
      if (!this.inputCubeAttributes || !this.inputCubeAttributes.length) return
      if (Object.keys(this.aiChatRefDetails).length === 0) return

      const map = {} // { entityId: { function: [{id,title,desc}], formula: [...], scalar: [...] } }

      // Collect attribute entity IDs and names for matching
      const attrEntities = {} // { entityId: entityName }
      const attrNameToId = {} // { lowerName: entityId }
      for (const a of this.inputCubeAttributes) {
        attrEntities[a.entityid] = a.label || this.entityName(a.entityid)
        if (a.label) attrNameToId[a.label.toLowerCase()] = a.entityid
        const eName = this.entityName(a.entityid)
        if (eName) attrNameToId[eName.toLowerCase()] = a.entityid
      }
      const attrEntityIds = new Set(Object.keys(attrEntities).map(Number))

      // Scan functions: match args entity references to attributes
      const funcDetails = this.aiChatRefDetails.function || {}
      const funcRefs = this.aiChatOperandRefs.function || []
      for (const ref of funcRefs) {
        const detail = funcDetails[ref.value]
        if (!detail || !detail.args || detail.args.length === 0) continue
        // Collect which attribute entities this function references
        const matchedAttrs = new Set()
        const argDescs = []
        for (const arg of detail.args) {
          if (arg.refId && attrEntityIds.has(arg.refId)) {
            matchedAttrs.add(arg.refId)
          }
          // Also match by entity name
          if (arg.refTitle) {
            const lower = arg.refTitle.toLowerCase()
            if (attrNameToId[lower]) matchedAttrs.add(attrNameToId[lower])
            // Partial match
            for (const [aName, aId] of Object.entries(attrNameToId)) {
              if (lower.includes(aName) || aName.includes(lower)) matchedAttrs.add(aId)
            }
          }
          argDescs.push(arg.refTitle || `#${arg.refId || '?'}`)
        }
        if (matchedAttrs.size === 0) continue
        const desc = `${detail.oper || '?'}(${argDescs.join(', ')})`
        for (const eid of matchedAttrs) {
          if (!map[eid]) map[eid] = { function: [], formula: [], scalar: [] }
          map[eid].function.push({
            id: ref.value, title: ref.title, type: 'function', desc,
          })
        }
      }

      // Scan formulas: match entity parts to attributes
      const frmDetails = this.aiChatRefDetails.formula || {}
      const frmRefs = this.aiChatOperandRefs.formula || []
      for (const ref of frmRefs) {
        const parts = frmDetails[ref.value]
        if (!parts || !parts.length) continue
        const matchedAttrs = new Set()
        const partDescs = []
        for (const p of parts) {
          if (p.entityId && attrEntityIds.has(p.entityId)) matchedAttrs.add(p.entityId)
          if (p.entity) {
            const lower = p.entity.toLowerCase()
            if (attrNameToId[lower]) matchedAttrs.add(attrNameToId[lower])
            for (const [aName, aId] of Object.entries(attrNameToId)) {
              if (lower.includes(aName) || aName.includes(lower)) matchedAttrs.add(aId)
            }
          }
          partDescs.push(p.entity || p.sql || p.partTypeSid || '?')
        }
        if (matchedAttrs.size === 0) continue
        const desc = partDescs.join(' ')
        for (const eid of matchedAttrs) {
          if (!map[eid]) map[eid] = { function: [], formula: [], scalar: [] }
          map[eid].formula.push({
            id: ref.value, title: ref.title, type: 'formula', desc,
          })
        }
      }

      this.aiChatAttrRefMap = map
      const total = Object.values(map).reduce((s, m) => s + m.function.length + m.formula.length + m.scalar.length, 0)
      dbg(`[AI Chat] AttrRefMap built: ${Object.keys(map).length} attributes mapped, ${total} total matches`)
    },
    // ── Get full details of a ref for AI ──
    aiChatGetRefDetail(refType, refId) {
      const numId = Number(refId)
      if (refType === 'formula') {
        const parts = this.aiChatRefDetails.formula ? this.aiChatRefDetails.formula[numId] : null
        if (!parts) return null
        const ref = (this.aiChatOperandRefs.formula || []).find(r => r.value === numId)
        return {
          id: numId,
          title: ref ? ref.title : `formula#${numId}`,
          type: 'formula',
          parts: parts.map(p => ({
            order: p.order,
            type: p.partTypeSid || p.partType,
            entity: p.entity || undefined,
            entityId: p.entityId || undefined,
            sql: p.sql || undefined,
          })),
        }
      }
      if (refType === 'function') {
        const detail = this.aiChatRefDetails.function ? this.aiChatRefDetails.function[numId] : null
        if (!detail) return null
        const ref = (this.aiChatOperandRefs.function || []).find(r => r.value === numId)
        return {
          id: numId,
          title: ref ? ref.title : `function#${numId}`,
          type: 'function',
          oper: detail.oper || undefined,
          args: detail.args,
        }
      }
      return null
    },
    // ── Search refs by internal content (entity names) ──
    aiChatSearchRefsByContent(entityNames, refType) {
      const results = []
      // Build patterns: exact match + fuzzy (each word as .*word.*)
      const patterns = entityNames.flatMap(n => {
        const exact = new RegExp(n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')
        // Also create a fuzzy pattern: split into words, match all words in any order
        const words = n.split(/\s+/).filter(w => w.length > 1)
        if (words.length > 1) {
          const fuzzy = new RegExp(words.map(w => `(?=.*${w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`).join(''), 'i')
          return [exact, fuzzy]
        }
        return [exact]
      })

      if (refType === 'all' || refType === 'formula') {
        const formulas = this.aiChatRefDetails.formula || {}
        for (const fid of Object.keys(formulas)) {
          const parts = formulas[fid]
          const matchedEntities = []
          // Also search by formula title
          const ref = (this.aiChatOperandRefs.formula || []).find(r => r.value === Number(fid))
          const refTitle = ref ? ref.title : ''
          for (const pat of patterns) {
            if (refTitle && pat.test(refTitle)) matchedEntities.push(`title:${refTitle}`)
          }
          for (const p of parts) {
            if (p.entity) {
              for (const pat of patterns) {
                if (pat.test(p.entity)) matchedEntities.push(p.entity)
              }
            }
            if (p.sql) {
              for (const pat of patterns) {
                if (pat.test(p.sql)) matchedEntities.push(`sql:${p.sql}`)
              }
            }
          }
          if (matchedEntities.length > 0) {
            results.push({
              id: Number(fid),
              title: ref ? ref.title : `formula#${fid}`,
              type: 'formula',
              matched: [...new Set(matchedEntities)],
              fingerprint: this.aiChatRefFingerprint('formula', Number(fid)),
            })
          }
        }

        // Also search formulas from refs that aren't in aiChatRefDetails (fallback by title only)
        const formulaDetailIds = new Set(Object.keys(formulas).map(Number))
        const formulaRefs = this.aiChatOperandRefs.formula || []
        for (const r of formulaRefs) {
          if (formulaDetailIds.has(r.value)) continue
          const matchedEntities = []
          for (const pat of patterns) {
            if (r.title && pat.test(r.title)) matchedEntities.push(`title:${r.title}`)
          }
          if (matchedEntities.length > 0) {
            results.push({
              id: r.value,
              title: r.title,
              type: 'formula',
              matched: [...new Set(matchedEntities)],
              fingerprint: '',
            })
          }
        }
      }

      if (refType === 'all' || refType === 'function') {
        const functions = this.aiChatRefDetails.function || {}
        const funcDetailIds = new Set(Object.keys(functions).map(Number))

        // Search through functions with loaded details
        for (const fid of Object.keys(functions)) {
          const detail = functions[fid]
          const matchedEntities = []
          const ref = (this.aiChatOperandRefs.function || []).find(r => r.value === Number(fid))
          const refTitle = ref ? ref.title : ''
          // Search by title from refs
          for (const pat of patterns) {
            if (refTitle && pat.test(refTitle)) matchedEntities.push(`title:${refTitle}`)
          }
          // Search by function name from record (may differ from title)
          if (detail.name && detail.name !== refTitle) {
            for (const pat of patterns) {
              if (pat.test(detail.name)) matchedEntities.push(`name:${detail.name}`)
            }
          }
          // Search by operand name
          if (detail.oper) {
            for (const pat of patterns) {
              if (pat.test(detail.oper)) matchedEntities.push(`oper:${detail.oper}`)
            }
          }
          // Search by argument references
          for (const arg of detail.args) {
            if (arg.refTitle) {
              for (const pat of patterns) {
                if (pat.test(arg.refTitle)) matchedEntities.push(arg.refTitle)
              }
            }
          }
          if (matchedEntities.length > 0) {
            results.push({
              id: Number(fid),
              title: ref ? ref.title : `function#${fid}`,
              type: 'function',
              matched: [...new Set(matchedEntities)],
              fingerprint: this.aiChatRefFingerprint('function', Number(fid)),
            })
          }
        }

        // Also search functions from refs that aren't in aiChatRefDetails (fallback by title only)
        const funcRefs = this.aiChatOperandRefs.function || []
        for (const r of funcRefs) {
          if (funcDetailIds.has(r.value)) continue // already searched above
          const matchedEntities = []
          for (const pat of patterns) {
            if (r.title && pat.test(r.title)) matchedEntities.push(`title:${r.title}`)
          }
          if (matchedEntities.length > 0) {
            results.push({
              id: r.value,
              title: r.title,
              type: 'function',
              matched: [...new Set(matchedEntities)],
              fingerprint: '',
            })
          }
        }
      }

      // Sort by number of matches (descending), then by match count
      results.sort((a, b) => b.matched.length - a.matched.length)
      return results.slice(0, 30) // cap results
    },
    async aiChatSend() {
      const text = this.aiChatInput.trim()
      if (!text) return
      // Check if user confirms pending corrected actions
      if (this.aiChatPendingActions.length > 0) {
        const yes = /^(да|ок|ok|yes|ага|давай|подтверж|верно|go)\s*$/i.test(text)
        this.aiChatMessages.push({ sender: 'user', text })
        this.aiChatInput = ''
        this.$nextTick(() => this.aiChatScrollToBottom())
        if (yes) {
          const pending = [...this.aiChatPendingActions]
          this.aiChatPendingActions = []
          this.aiChatExecuteActions(pending)
        } else {
          this.aiChatPendingActions = []
          this.aiChatMessages.push({ sender: 'bot', text: 'Отменено.' })
          this.$nextTick(() => this.aiChatScrollToBottom())
        }
        return
      }
      if (!this.aiChatWs || this.aiChatWs.readyState !== WebSocket.OPEN) {
        this.aiChatMessages.push({ sender: 'bot', text: 'Нет подключения к серверу.' })
        return
      }
      this.aiChatMessages.push({ sender: 'user', text })
      this.aiChatInput = ''
      this.aiChatWaiting = true
      this.$nextTick(() => this.aiChatScrollToBottom())

      // Auto-refresh mount steps before sending to AI (so context is up-to-date)
      if ([7, 8].includes(this.step)) {
        const asmId = this.step === 7 ? this.created.procAsmId : this.created.copyAsmId
        if (asmId) await this.aiChatLoadMountSteps(asmId)
      }

      // Only send full context on first message or after state changes (action execution, step change).
      // Follow-up messages go without context — AI already has it from chat history.
      // Backend strips duplicate contexts from history, keeping only the most recent one.
      let payloadText = text
      if (this.aiChatNeedsContext) {
        const context = this.aiChatBuildContext()
        // Hard limit: if context too big, trim refs to fit under WS limit (~50KB total)
        const MAX_CTX = 40000
        let ctxStr = JSON.stringify(context)
        if (ctxStr.length > MAX_CTX && context.refs) {
          // Progressively reduce ref lists
          for (const maxPer of [40, 20, 10]) {
            for (const sid of ['formula', 'function', 'scalar']) {
              if (context.refs[sid] && context.refs[sid].length > maxPer) {
                context.refs[sid] = context.refs[sid].slice(0, maxPer)
              }
            }
            ctxStr = JSON.stringify(context)
            if (ctxStr.length <= MAX_CTX) break
          }
        }
        payloadText = `[КОНТЕКСТ]\n${ctxStr}\n[/КОНТЕКСТ]\n\n${text}`
        this.aiChatNeedsContext = false
        dbg('[AI Chat] Sending WITH context, size:', ctxStr.length, 'bytes')
        dbg('[AI Chat] Context breakdown:', Object.keys(context).map(k => `${k}:${JSON.stringify(context[k]).length}`).join(', '))
      } else {
        dbg('[AI Chat] Sending WITHOUT context (AI has it from history)')
      }
      const payload = {
        type: 'message',
        to: 'chatbot',
        text: payloadText,
        useAi: true,
        token: this.getToken(),
      }
      const payloadStr = JSON.stringify(payload)
      dbg('[AI Chat] Payload size:', payloadStr.length, 'bytes, user text:', text)
      if (isDev) console.time('[AI Chat] Response time')
      this.aiChatWs.send(payloadStr)
    },
    aiChatScrollToBottom() {
      const chat = this.$refs.aiChat
      if (chat && chat.scrollToBottom) chat.scrollToBottom()
    },
    // Auto-relay read-only action results back to AI so it can use them for decisions
    aiChatRelayResultToAi(actionName, resultText) {
      if (!this.aiChatWs || this.aiChatWs.readyState !== WebSocket.OPEN) return
      const context = this.aiChatBuildContext()
      // Keep refs in relay context — AI needs refIds to create proper action blocks.
      // Backend strips duplicate contexts from history, so no token bloat.
      delete context.mountSteps // trim mount steps (AI has them from history or from result)
      const ctxStr = JSON.stringify(context)
      const relayText = `[КОНТЕКСТ]\n${ctxStr}\n[/КОНТЕКСТ]\n\n`
        + `[РЕЗУЛЬТАТ ДЕЙСТВИЯ ${actionName}]\n${resultText}\n[/РЕЗУЛЬТАТ]\n\n`
        + 'На основе полученных данных прими решение и действуй. Если нашёл подходящий операнд — предложи конкретный план (delete+save) с точными id. Будь кратким.'
      this.aiChatWaiting = true
      const payload = {
        type: 'message',
        to: 'chatbot',
        text: relayText,
        useAi: true,
        token: this.getToken(),
      }
      dbg('[AI Chat] Relaying action result back to AI:', actionName, 'result length:', resultText.length)
      if (isDev) console.time('[AI Chat] Relay response time')
      this.aiChatWs.send(JSON.stringify(payload))
    },
    // Parse action blocks from AI response — supports ```action``` blocks and inline JSON with "action" field
    aiChatParseActions(text) {
      const actions = []
      // 1) Parse ```action ... ``` blocks
      let cleanText = text.replace(/```action\s*\n([\s\S]*?)```/g, (_, json) => {
        try {
          const parsed = JSON.parse(json.trim())
          const arr = Array.isArray(parsed) ? parsed : [parsed]
          actions.push(...arr)
        } catch (e) {
          // Fallback: try parsing as newline-delimited JSON (JSONL)
          const lines = json.trim().split('\n').filter(l => l.trim())
          let parsed = 0
          for (const line of lines) {
            try {
              const obj = JSON.parse(line.trim())
              if (obj && typeof obj === 'object') { actions.push(obj); parsed++ }
            } catch (_e) { /* skip unparseable lines */ }
          }
          if (parsed === 0) console.warn('[AI Chat] Failed to parse action block:', e, json)
        }
        return '' // remove action block from displayed text
      })
      // 2) Fallback: parse inline JSON with "action" field (AI sometimes outputs without ```action wrapper)
      if (actions.length === 0) {
        // Find JSON-like substrings containing "action" and try parsing them
        const jsonCandidates = []
        let braceDepth = 0
        let start = -1
        for (let ci = 0; ci < cleanText.length; ci++) {
          if (cleanText[ci] === '{') {
            if (braceDepth === 0) start = ci
            braceDepth++
          } else if (cleanText[ci] === '}') {
            braceDepth--
            if (braceDepth === 0 && start >= 0) {
              const candidate = cleanText.substring(start, ci + 1)
              if (candidate.indexOf('"action"') !== -1) {
                jsonCandidates.push({ text: candidate, start, end: ci + 1 })
              }
              start = -1
            }
          }
        }
        // Parse candidates from end to start (to preserve indices during replacement)
        for (let ci = jsonCandidates.length - 1; ci >= 0; ci--) {
          try {
            const parsed = JSON.parse(jsonCandidates[ci].text)
            if (parsed && parsed.action) {
              actions.push(parsed)
              dbg('[AI Chat] Parsed inline action:', parsed.action)
              cleanText = cleanText.substring(0, jsonCandidates[ci].start) + cleanText.substring(jsonCandidates[ci].end)
            }
          } catch (e) {
            // Not valid JSON — leave in text
          }
        }
      }
      return { text: cleanText.trim(), actions }
    },
    // ── Name-based resolution helpers (no ID collisions) ──
    // Normalize string for comparison: lowercase, underscores→spaces, collapse whitespace
    aiChatNormalize(s) {
      return s ? s.toLowerCase().replace(/_/g, ' ').replace(/\s+/g, ' ').trim() : ''
    },
    // Find ref by name within a specific type. Returns ref object or null.
    aiChatFindRefByName(name, type) {
      if (!name || !type) return null
      const refs = this.aiChatOperandRefs[type] || []
      if (refs.length === 0) {
        console.warn(`[AI Chat] findRefByName: no refs loaded for type="${type}"`)
        return null
      }
      const norm = this.aiChatNormalize(name)
      // 1. Exact match
      let found = refs.find(r => r.title === name)
      if (found) return found
      // 2. Normalized exact (ignoring case, underscores vs spaces)
      found = refs.find(r => r.title && this.aiChatNormalize(r.title) === norm)
      if (found) return found
      // 3. Normalized contains (both directions)
      found = refs.find(r => r.title && this.aiChatNormalize(r.title).includes(norm))
      if (!found) found = refs.find(r => r.title && norm.includes(this.aiChatNormalize(r.title)))
      if (found) return found
      // 4. Word-level overlap: count how many words match
      const normWords = norm.split(' ').filter(w => w.length > 2)
      if (normWords.length >= 2) {
        let bestRef = null
        let bestScore = 0
        for (const r of refs) {
          if (!r.title) continue
          const rNorm = this.aiChatNormalize(r.title)
          const rWords = rNorm.split(' ').filter(w => w.length > 2)
          const overlap = normWords.filter(w => rWords.includes(w)).length
          const score = overlap / Math.max(normWords.length, rWords.length)
          if (score > bestScore && score >= 0.5) { bestScore = score; bestRef = r }
        }
        if (bestRef) {
          dbg(`[AI Chat] findRefByName: word-match "${name}" → "${bestRef.title}" (score=${bestScore.toFixed(2)})`)
          return bestRef
        }
      }
      console.warn(`[AI Chat] findRefByName: "${name}" NOT FOUND in ${type} (${refs.length} refs)`)
      return null
    },
    // Find attribute/field by name in inputCubeAttributes. Returns {aid, eid, name} or null.
    aiChatFindFieldByName(name) {
      if (!name) return null
      const norm = this.aiChatNormalize(name)
      const attrs = this.inputCubeAttributes || []
      let attr = attrs.find(a => a.label === name)
      if (!attr) attr = attrs.find(a => a.label && this.aiChatNormalize(a.label) === norm)
      if (!attr) attr = attrs.find(a => a.label && this.aiChatNormalize(a.label).includes(norm))
      if (attr) return { aid: attr.attributeid, eid: attr.entityid, name: attr.label }
      // Fallback: search allEntities
      const entity = this.aiChatFindEntityByName(name)
      if (entity) return { eid: entity.id, name: entity.name }
      return null
    },
    // Find entity by name in allEntities. Returns entity object or null.
    aiChatFindEntityByName(name) {
      if (!name) return null
      const norm = this.aiChatNormalize(name)
      let entity = this.allEntities.find(e => e.name === name)
      if (!entity) entity = this.allEntities.find(e => e.name && this.aiChatNormalize(e.name) === norm)
      if (!entity) entity = this.allEntities.find(e => e.name && this.aiChatNormalize(e.name).includes(norm))
      return entity || null
    },
    // Resolve ref to full object. NAME+TYPE is primary, refId is secondary hint.
    // Returns { ref, operSid } or { error }
    aiChatResolveRef(act) {
      const { operSid } = act
      const refName = act.refName || null
      const ref = act.ref || null
      const refId = act.refId || (ref && ref.value)

      // Value type — no ref lookup needed
      if (operSid === 'value') {
        return {
          ref: {
            value: 0, sid: '', title: '', textValue: act.textValue || '',
          },
          operSid,
        }
      }

      // ── PRIMARY: Name-based resolution (no ID collisions possible) ──
      if (refName && ['formula', 'function', 'scalar'].includes(operSid)) {
        const found = this.aiChatFindRefByName(refName, operSid)
        if (found) {
          dbg(`[AI Chat] resolveRef: found "${refName}" by name in ${operSid} → id=${found.value} "${found.title}"`)
          return { ref: { value: found.value, sid: found.sid || '', title: found.title || '' }, operSid }
        }
        // Name not found in specified type — try other types as name-based fallback
        for (const type of ['formula', 'function', 'scalar']) {
          if (type === operSid) continue
          const fallback = this.aiChatFindRefByName(refName, type)
          if (fallback) {
            dbg(`[AI Chat] resolveRef: "${refName}" not in ${operSid}, found in ${type} → id=${fallback.value} "${fallback.title}"`)
            return { ref: { value: fallback.value, sid: fallback.sid || '', title: fallback.title || '' }, operSid: type }
          }
        }
        // Not found by name — fall through to ID if available
        if (!refId) {
          return { error: `Реф "${refName}" (${operSid}) не найден по названию` }
        }
        console.warn(`[AI Chat] resolveRef: "${refName}" not found by name, falling back to refId=${refId}`)
      }

      // ── SECONDARY: ID-based resolution (only within specified type — NO auto-detect!) ──
      if (refId) {
        const numRefId = Number(refId)
        const modOperands = ['formula', 'function', 'scalar']

        // If type is specified, search ONLY in that type (no cross-type auto-detect)
        if (modOperands.includes(operSid)) {
          const refList = this.aiChatOperandRefs[operSid] || []
          const found = refList.find(r => r.value === numRefId || r.value === refId)
          if (found) {
            dbg(`[AI Chat] resolveRef: found refId=${refId} in ${operSid} → "${found.title}"`)
            return { ref: { value: found.value, sid: found.sid || '', title: found.title || '' }, operSid }
          }
          return { error: `refId=${refId} не найден в ${operSid}. Укажи refName для точного поиска.` }
        }

        // Unknown operSid (e.g. "insert") — refuse to guess, require type + name
        return { error: `Неизвестный тип "${operSid}". Укажи operSid: formula, function или scalar, и refName.` }
      }

      // No refId and no refName — error for ref-based types
      if (['formula', 'function', 'scalar'].includes(operSid)) {
        return { error: `Не указан ни refName, ни refId для ${operSid}` }
      }

      // Other operand types (entity, paramentity, sourceentity) — pass through
      return { ref: ref || { value: refId || 0, sid: '', title: '' }, operSid }
    },
    // Execute parsed actions
    async aiChatExecuteActions(actions) {
      for (let i = 0; i < actions.length; i++) {
        const act = actions[i]
        if (act.action === 'delete_attr_prop') {
          const { rid } = act
          if (!rid) {
            this.aiChatMessages.push({ sender: 'bot', text: 'Ошибка: не указан rid для удаления' })
            continue
          }
          // Find attribute name for this rid from cache
          let ridAttrLabel = ''
          if (this.aiChatAttrProps) {
            for (const key of Object.keys(this.aiChatAttrProps)) {
              const prop = this.aiChatAttrProps[key].find(p => p.id === rid)
              if (prop) {
                const attr = this.inputCubeAttributes.find(a => String(a.attributeid) === String(key))
                ridAttrLabel = attr ? ` «${attr.label}» (${prop.paramname})` : ` (${prop.paramname})`
                break
              }
            }
          }
          this.aiChatMessages.push({ sender: 'bot', text: `Удаляю свойство${ridAttrLabel} rid=${rid}...` })
          this.$nextTick(() => this.aiChatScrollToBottom())
          try {
            // eslint-disable-next-line no-await-in-loop
            await recordApi.deleteById('cbsattributeparam', rid)
            this.aiChatMessages.push({ sender: 'bot', text: `OK: свойство rid=${rid} удалено` })
            if (this.aiChatAttrProps) {
              for (const key of Object.keys(this.aiChatAttrProps)) {
                this.aiChatAttrProps[key] = this.aiChatAttrProps[key].filter(p => p.id !== rid)
              }
            }
          } catch (e) {
            this.aiChatMessages.push({ sender: 'bot', text: `ОШИБКА удаления: ${e.message}` })
            // Clean stale rid from cache so AI won't try again
            if (this.aiChatAttrProps) {
              for (const key of Object.keys(this.aiChatAttrProps)) {
                this.aiChatAttrProps[key] = this.aiChatAttrProps[key].filter(p => p.id !== rid)
              }
            }
          }
          this.$nextTick(() => this.aiChatScrollToBottom())
        } else if (act.action === 'save_attr_prop') {
          let { aid, eid, param } = act
          // ── Name-based field resolution (primary) ──
          if (act.fieldName && (!aid || !eid)) {
            const field = this.aiChatFindFieldByName(act.fieldName)
            if (field) {
              aid = aid || field.aid; eid = eid || field.eid
              dbg(`[AI Chat] save_attr_prop: resolved fieldName="${act.fieldName}" → aid=${aid} eid=${eid}`)
            } else {
              this.aiChatMessages.push({ sender: 'bot', text: `Поле "${act.fieldName}" не найдено среди атрибутов куба` })
              continue
            }
          }
          if (!aid || !eid || !param || !act.operSid) {
            this.aiChatMessages.push({ sender: 'bot', text: 'Ошибка: неполные данные для save_attr_prop (нужны fieldName или aid+eid, param, operSid)' })
            continue
          }
          // Dedup: skip if same aid+param+operSid+refId already saved
          if (this.aiChatAttrProps && this.aiChatAttrProps[aid]) {
            const existing = this.aiChatAttrProps[aid].find(p => {
              if (p.paramname !== param) return false
              const m = p.jsonmod && p.jsonmod.list && p.jsonmod.list[0]
              if (!m) return false
              const operKey = {
                function: 'function', scalar: 'scalar', formula: 'formula', value: 'value',
              }[act.operSid]
              return operKey && m[operKey] && m[operKey].id === (act.refId || act.ref)
            })
            if (existing) {
              const attrLabel = this.entityName(eid) || `eid=${eid}`
              this.aiChatMessages.push({ sender: 'bot', text: `Пропуск: «${attrLabel}» → ${param} уже назначен (${act.operSid} id=${act.refId || act.ref})` })
              continue
            }
          }
          // Resolve ref (with cross-type search)
          const resolved = this.aiChatResolveRef(act)
          if (resolved.error) {
            this.aiChatMessages.push({ sender: 'bot', text: `ОШИБКА: ${resolved.error}` })
            continue
          }
          if (resolved.needConfirm) {
            // Queue corrected action + remaining actions, ask user
            this.aiChatPendingActions = [resolved.correctedAct, ...actions.slice(i + 1)]
            this.aiChatMessages.push({ sender: 'bot', text: resolved.message })
            this.$nextTick(() => this.aiChatScrollToBottom())
            return // stop — wait for user confirmation
          }
          const { ref, operSid: finalOperSid } = resolved
          const attrLabel = this.entityName(eid) || `eid=${eid}`
          const refLabel = ref.title || ref.textValue || `id=${ref.value}`
          dbg(`[AI Chat] save_attr_prop: aid=${aid} eid=${eid} param=${param} operSid=${finalOperSid} ref=`, JSON.stringify(ref))
          // Descriptive message: what is being applied and what the ref does
          const actionDesc = this.aiChatDescribeAttrAction(attrLabel, param, finalOperSid, refLabel, ref.value)
          this.aiChatMessages.push({ sender: 'bot', text: actionDesc })
          this.$nextTick(() => this.aiChatScrollToBottom())
          try {
            const attrMeta = this.inputCubeAttributes.find(a => a.attributeid === aid)
            const builtModSet = this.buildModification(eid, finalOperSid, ref)
            dbg('[AI Chat] save_attr_prop built jsonmod:', JSON.stringify(builtModSet, null, 2))
            // eslint-disable-next-line no-await-in-loop
            await this.saveAttrProperty(aid, param, eid, finalOperSid, ref, attrMeta)
            this.aiChatMessages.push({ sender: 'bot', text: 'OK: сохранено' })
            if (this.aiChatAttrProps) {
              if (!this.aiChatAttrProps[aid]) this.aiChatAttrProps[aid] = []
              this.aiChatAttrProps[aid].push({ paramname: param, jsonmod: this.buildModification(eid, finalOperSid, ref) })
            }
          } catch (e) {
            this.aiChatMessages.push({ sender: 'bot', text: `ОШИБКА: ${e.message}` })
          }
          this.$nextTick(() => this.aiChatScrollToBottom())
        } else if (act.action === 'get_ref_details') {
          // AI requests internal details of specific refs — result auto-relayed back to AI
          const { refType, refIds } = act
          if (!refType || !refIds || !Array.isArray(refIds)) {
            this.aiChatMessages.push({ sender: 'bot', text: 'Ошибка: get_ref_details требует refType и refIds[]' })
            this.$nextTick(() => this.aiChatScrollToBottom())
            continue
          }
          // First try from cache
          const details = []
          for (const rid of refIds.slice(0, 5)) {
            const info = this.aiChatGetRefDetail(refType, rid)
            if (info) details.push(info)
          }
          // If some IDs not in cache, try loading via refdetails API
          if (details.length < refIds.slice(0, 5).length) {
            const missingIds = refIds.slice(0, 5).filter(rid => !details.find(d => d.id === Number(rid)))
            if (missingIds.length > 0) {
              try {
                // eslint-disable-next-line no-await-in-loop
                const items = await recordApi.loadRefDetails(refType, missingIds)
                for (const item of items) {
                  const ref = (this.aiChatOperandRefs[refType] || []).find(r => r.value === item.id)
                  if (refType === 'function') {
                    details.push({
                      id: item.id,
                      title: ref ? ref.title : item.name,
                      type: 'function',
                      oper: item.oper ? (item.oper.title || item.oper.sid) : '',
                      args: (item.args || []).map(a => ({ typeSid: a.argtype, refTitle: a.entityName || '', refId: a.argvalue ? Number(a.argvalue) : null })),
                    })
                  } else {
                    details.push({
                      id: item.id,
                      title: ref ? ref.title : item.name,
                      type: 'formula',
                      parts: (item.parts || []).map(p => ({ type: p.oper ? p.oper.sid : '', entity: p.entityName || '', sql: p.sqlString || '' })),
                    })
                  }
                }
              } catch (e) {
                console.warn('[AI Chat] refdetails API call failed in get_ref_details:', e.message || e)
              }
            }
          }
          let resultText
          if (details.length > 0) {
            resultText = `Детали ${refType} (${details.length}):\n${JSON.stringify(details, null, 2)}`
            // User-friendly display
            const userLines = details.map(d => {
              let line = `**${d.title}** (id=${d.id}, ${d.type})`
              if (d.oper) line += ` — операция: ${d.oper}`
              if (d.args && d.args.length > 0) {
                const argStrs = d.args.map(a => `${a.typeSid}: ${a.refTitle || a.refId || '(пусто)'}`).join(', ')
                line += `\n  аргументы: ${argStrs}`
              }
              if (d.parts && d.parts.length > 0) {
                const partStrs = d.parts.map(p => `${p.type || '?'}: ${p.entity || p.sql || '(пусто)'}`).join(' → ')
                line += `\n  части: ${partStrs}`
              }
              return line
            })
            this.aiChatMessages.push({ sender: 'bot', text: userLines.join('\n\n'), format: 'markdown' })
          } else {
            resultText = `Детали не найдены для ${refType} ids: ${refIds.join(', ')}. Возможно, детали ещё загружаются.`
            this.aiChatMessages.push({ sender: 'bot', text: resultText })
          }
          this.$nextTick(() => this.aiChatScrollToBottom())
          // Auto-relay result back to AI so it can use the data for next decision
          this.aiChatRelayResultToAi('get_ref_details', resultText)
        } else if (act.action === 'search_refs_by_content') {
          // AI searches refs by internal entity names — result auto-relayed back to AI
          const { entityNames, refType } = act
          if (!entityNames || !Array.isArray(entityNames) || entityNames.length === 0) {
            this.aiChatMessages.push({ sender: 'bot', text: 'Ошибка: search_refs_by_content требует entityNames[]' })
            this.$nextTick(() => this.aiChatScrollToBottom())
            continue
          }
          const results = this.aiChatSearchRefsByContent(entityNames, refType || 'all')
          dbg('[AI Chat] search_refs_by_content results:', results.length, 'matches for', entityNames)
          let resultText
          if (results.length > 0) {
            resultText = `Найдено ${results.length} совпадений по [${entityNames.join(', ')}]:\n${JSON.stringify(results, null, 2)}`
            // User-friendly display
            const userLines = results.map(r => {
              let line = `**${r.title}** (id=${r.id}, ${r.type})`
              if (r.fingerprint) line += `\n  ${r.fingerprint}`
              line += `\n  совпало: ${r.matched.join(', ')}`
              return line
            })
            this.aiChatMessages.push({ sender: 'bot', text: `Найдено ${results.length} по «${entityNames.join('», «')}»:\n\n${userLines.join('\n\n')}`, format: 'markdown' })
          } else {
            resultText = `Не найдено формул/функций содержащих: ${entityNames.join(', ')}`
            this.aiChatMessages.push({ sender: 'bot', text: resultText })
          }
          this.$nextTick(() => this.aiChatScrollToBottom())
          // Auto-relay result back to AI so it can use the data for next decision
          this.aiChatRelayResultToAi('search_refs_by_content', resultText)
        } else if (act.action === 'query_mountsteps') {
          // Reload mount steps for current assembly
          const asmId = this.step === 7 ? this.created.procAsmId : this.created.copyAsmId
          if (!asmId) {
            this.aiChatMessages.push({ sender: 'bot', text: 'Ошибка: нет ID сборки для текущего шага' })
          } else {
            // eslint-disable-next-line no-await-in-loop
            await this.aiChatLoadMountSteps(asmId)
            const steps = this.aiChatMountSteps ? this.aiChatMountSteps[String(asmId)] || [] : []
            const resultText = steps.length > 0
              ? `Шаги сборки (${steps.length}):\n${JSON.stringify(steps, null, 2)}`
              : 'Шагов сборки пока нет.'
            this.aiChatMessages.push({
              sender: 'bot',
              text: steps.length > 0
                ? `Загружено ${steps.length} шагов сборки`
                : 'Шагов сборки пока нет.',
            })
            this.$nextTick(() => this.aiChatScrollToBottom())
            this.aiChatRelayResultToAi('query_mountsteps', resultText)
          }
        } else if (act.action === 'create_mountstep') {
          const asmId = this.step === 7 ? this.created.procAsmId : this.created.copyAsmId
          // Auto-refresh mount steps before creating (so ordernum calc is up-to-date)
          // eslint-disable-next-line no-await-in-loop
          if (asmId) await this.aiChatLoadMountSteps(asmId)
          const {
            name, operSid, mappings, values, functions, formulas, scalars, filters,
          } = act
          if (!asmId || !name) {
            this.aiChatMessages.push({ sender: 'bot', text: 'Ошибка: create_mountstep требует name' })
            continue
          }
          const mountOperSid = operSid || 'insert'
          const operId = this.getMountOperId(mountOperSid)
          if (!operId) {
            this.aiChatMessages.push({ sender: 'bot', text: `Ошибка: неизвестная операция "${mountOperSid}"` })
            continue
          }
          // Build jsonmod from mappings + values + functions/formulas/scalars
          // Helper: extract numeric ID robustly (AI may send number, string, or object)
          const numId = v => { if (v && typeof v === 'object') v = v.id || v.value; return Number(v) || null }
          // Helper: resolve entity ID from name if numeric ID is missing
          const resolveEid = (id, name) => {
            if (id) return id
            if (name) { const e = this.aiChatFindEntityByName(name); if (e) return e.id }
            return null
          }
          const allMappings = [
            ...(mappings || []).map(m => ({
              src: resolveEid(numId(m.src), m.srcName), srcName: m.srcName || '', dest: resolveEid(numId(m.dest), m.destName), destName: m.destName || '', oper: m.oper || 'sourceentity', refId: numId(m.refId), refName: m.refName || '', val: m.val,
            })),
            ...(values || []).map(v => ({
              dest: resolveEid(numId(v.dest), v.destName), destName: v.destName || '', oper: 'value', val: v.val,
            })),
            ...(functions || []).filter(f => f.refId || f.refName).map(f => ({
              dest: resolveEid(numId(f.dest), f.destName), destName: f.destName || '', oper: 'function', refId: numId(f.refId), refName: f.refName || '',
            })),
            ...(formulas || []).filter(f => f.refId || f.refName).map(f => ({
              dest: resolveEid(numId(f.dest), f.destName), destName: f.destName || '', oper: 'formula', refId: numId(f.refId), refName: f.refName || '',
            })),
            ...(scalars || []).filter(s => s.refId || s.refName).map(s => ({
              dest: resolveEid(numId(s.dest), s.destName), destName: s.destName || '', oper: 'scalar', refId: numId(s.refId), refName: s.refName || '',
            })),
          ]
          // --- DETAILED LOGGING: raw AI action and processed mappings ---
          dbg('[AI Chat] create_mountstep RAW action:', JSON.stringify(act, null, 2))
          dbg('[AI Chat] create_mountstep allMappings:', JSON.stringify(allMappings, null, 2))
          this.aiChatMessages.push({ sender: 'bot', text: `Создаю шаг «${name}» (${mountOperSid})...` })
          this.$nextTick(() => this.aiChatScrollToBottom())
          // Show per-mapping descriptions in separate messages
          allMappings.forEach(m => {
            let ref = null
            let rOper = m.oper
            if (['formula', 'function', 'scalar'].includes(m.oper) && m.refName) {
              ref = this.aiChatFindRefByName(m.refName, m.oper)
              if (!ref) {
                const types = ['formula', 'function', 'scalar']
                types.some(t => {
                  if (t === m.oper) return false
                  ref = this.aiChatFindRefByName(m.refName, t)
                  if (ref) { rOper = t; return true }
                  return false
                })
              }
            }
            if (!ref && m.refId && ['formula', 'function', 'scalar'].includes(m.oper)) {
              ref = (this.aiChatOperandRefs[m.oper] || []).find(r => r.value === Number(m.refId))
            }
            const line = this.aiChatDescribeMapping(m, ref, rOper)
            this.aiChatMessages.push({ sender: 'bot', text: `  ${line}` })
          })
          this.$nextTick(() => this.aiChatScrollToBottom())
          try {
            // Get mountstep object numeric ID (like CbsObjectTable does)
            const mountStepObjId = this.mountStepObjectFull && this.mountStepObjectFull.object
              ? this.mountStepObjectFull.object.id : null
            if (!mountStepObjId) throw new Error('mountStepObjectFull не загружен')
            const asmFilter = this.mountStepFilter(asmId)
            // eslint-disable-next-line no-await-in-loop
            const rec = await recordApi.newRecord(null, { objectid: mountStepObjId, filter: asmFilter })
            // objectid should be pre-filled by server via filter, but set explicitly as fallback
            if (rec.objectid && !rec.objectid.value) { rec.objectid.value = asmId; rec.objectid.status = 'changed' }
            if (rec.name) { rec.name.value = name; rec.name.status = 'changed' }
            if (rec.mountoperid) { rec.mountoperid.value = operId; rec.mountoperid.status = 'changed' }
            // Calculate ordernum (required — backend auto-calc crashes without it)
            const existingSteps = this.aiChatMountSteps && this.aiChatMountSteps[String(asmId)]
              ? this.aiChatMountSteps[String(asmId)] : []
            const maxOrder = existingSteps.reduce((max, s) => Math.max(max, s.ordernum || 0), 0)
            const nextOrder = act.ordernum || (Math.ceil(maxOrder / 100) + 1) * 100
            if (rec.ordernum) { rec.ordernum.value = nextOrder; rec.ordernum.status = 'changed' }
            // Set destination object (summary cube for copy, input cube for proc)
            const destObjId = this.step === 8 ? this.created.summaryCubeId : this.created.inputCubeId
            if (rec.destobjectid && destObjId) { rec.destobjectid.value = destObjId; rec.destobjectid.status = 'changed' }
            // Source object for copy = input cube
            if (this.step === 8 && rec.sourceobjectid && this.created.inputCubeId) {
              rec.sourceobjectid.value = this.created.inputCubeId; rec.sourceobjectid.status = 'changed'
            }
            // Set jsonmod with field mappings
            if (rec.jsonmod && allMappings.length > 0) {
              const builtMod = this.aiChatBuildMountStepMod(allMappings)
              dbg('[AI Chat] built jsonmod:', JSON.stringify(builtMod))
              rec.jsonmod.value = builtMod
              rec.jsonmod.status = 'changed'
            }
            // Set jsonfilter with filter conditions
            if (rec.jsonfilter && filters && filters.length > 0) {
              const builtFilter = this.aiChatBuildMountStepFilter(filters)
              dbg('[AI Chat] built jsonfilter:', JSON.stringify(builtFilter, null, 2))
              rec.jsonfilter.value = builtFilter
              rec.jsonfilter.status = 'changed'
            }
            rec.status = 'changed'
            // --- DETAILED LOGGING: full record being saved ---
            dbg('[AI Chat] SAVING record fields:',
              'name=', rec.name && rec.name.value,
              'mountoperid=', rec.mountoperid && rec.mountoperid.value,
              'ordernum=', rec.ordernum && rec.ordernum.value,
              'destobjectid=', rec.destobjectid && rec.destobjectid.value,
              'sourceobjectid=', rec.sourceobjectid && rec.sourceobjectid.value)
            dbg('[AI Chat] SAVING jsonmod:', rec.jsonmod ? JSON.stringify(rec.jsonmod.value, null, 2) : 'null')
            dbg('[AI Chat] SAVING jsonfilter:', rec.jsonfilter ? JSON.stringify(rec.jsonfilter.value, null, 2) : 'null')
            // eslint-disable-next-line no-await-in-loop
            await recordApi.save(null, rec, { objectid: mountStepObjId })
            this.aiChatMessages.push({ sender: 'bot', text: `OK: шаг «${name}» создан` })
            // Refresh mount steps cache
            // eslint-disable-next-line no-await-in-loop
            await this.aiChatLoadMountSteps(asmId)
          } catch (e) {
            this.aiChatMessages.push({ sender: 'bot', text: `ОШИБКА создания шага: ${e.message}` })
          }
          this.$nextTick(() => this.aiChatScrollToBottom())
        } else if (act.action === 'delete_mountstep') {
          const { stepId } = act
          if (!stepId) {
            this.aiChatMessages.push({ sender: 'bot', text: 'Ошибка: delete_mountstep требует stepId' })
            continue
          }
          this.aiChatMessages.push({ sender: 'bot', text: `Удаляю шаг id=${stepId}...` })
          this.$nextTick(() => this.aiChatScrollToBottom())
          try {
            // eslint-disable-next-line no-await-in-loop
            await recordApi.deleteById('mountstep', stepId)
            this.aiChatMessages.push({ sender: 'bot', text: `OK: шаг id=${stepId} удалён` })
            // Refresh mount steps cache
            const asmId = this.step === 7 ? this.created.procAsmId : this.created.copyAsmId
            if (asmId) {
              // eslint-disable-next-line no-await-in-loop
              await this.aiChatLoadMountSteps(asmId)
            }
          } catch (e) {
            this.aiChatMessages.push({ sender: 'bot', text: `ОШИБКА удаления: ${e.message}` })
          }
          this.$nextTick(() => this.aiChatScrollToBottom())
        } else {
          this.aiChatMessages.push({ sender: 'bot', text: `Неизвестное действие: ${act.action}` })
        }
      }
      // After executing actions, state may have changed — resend context on next message
      this.aiChatNeedsContext = true
    },
    aiChatEnsureConnected() {
      if ([4, 7, 8].includes(this.step)) {
        this.aiChatConnect()
        // Clear chat history when step changes so AI gets fresh context
        if (this.aiChatLastStep !== null && this.aiChatLastStep !== this.step) {
          this.aiChatMessages = []
          this.aiChatPendingActions = []
          this.aiChatNeedsContext = true
          // Clear server-side history
          if (this.aiChatWs && this.aiChatWs.readyState === WebSocket.OPEN) {
            this.aiChatWs.send(JSON.stringify({
              type: 'message', to: 'chatbot', text: '/clear', useAi: false, token: this.getToken(),
            }))
          }
        }
        this.aiChatLastStep = this.step
        // Load operand reference lists (formulas, functions, scalars)
        if (Object.keys(this.aiChatOperandRefs).length === 0) {
          this.aiChatLoadOperandRefs().then(() => {
            // After refs loaded, load internal details (formula parts, function args) in background
            if (Object.keys(this.aiChatRefDetails).length === 0 && !this.aiChatRefDetailsLoading) {
              this.aiChatLoadRefDetails()
            }
          })
        } else if (Object.keys(this.aiChatRefDetails).length === 0 && !this.aiChatRefDetailsLoading) {
          // Refs already loaded but details not yet — load them
          this.aiChatLoadRefDetails()
        }
        // Load attribute properties when entering step 4
        if (this.step === 4 && !this.aiChatAttrProps && this.inputCubeAttributes.length > 0) {
          this.aiChatLoadAttrProps()
        }
        // Load mount steps when entering steps 7-8
        if ([7, 8].includes(this.step)) {
          const asmId = this.step === 7 ? this.created.procAsmId : this.created.copyAsmId
          if (asmId && (!this.aiChatMountSteps || !this.aiChatMountSteps[String(asmId)])) {
            this.aiChatLoadMountSteps(asmId)
          }
        }
      }
    },
    // ── AI Chat Resize ──
    aiChatResizeStart(e) {
      e.preventDefault()
      this.aiChatResizing = true
      const startX = e.clientX || (e.touches && e.touches[0].clientX) || 0
      const startW = this.aiChatWidth
      const onMove = ev => {
        const cx = ev.clientX || (ev.touches && ev.touches[0].clientX) || 0
        const delta = startX - cx
        this.aiChatWidth = Math.max(200, Math.min(600, startW + delta))
      }
      const onUp = () => {
        this.aiChatResizing = false
        document.removeEventListener('mousemove', onMove)
        document.removeEventListener('mouseup', onUp)
        document.removeEventListener('touchmove', onMove)
        document.removeEventListener('touchend', onUp)
      }
      document.addEventListener('mousemove', onMove)
      document.addEventListener('mouseup', onUp)
      document.addEventListener('touchmove', onMove)
      document.addEventListener('touchend', onUp)
    },
  },
}
</script>

<style lang="scss" scoped>
// ── Step indicator ──
.wizard-steps-bar {
  display: flex;
  gap: 4px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebe9f1;
  flex-wrap: wrap;
}

.wizard-step-dot {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  cursor: default;
  background: #f3f2f5;
  color: #b9b9c3;
  transition: all 0.15s;

  &--active {
    background: #7367f0;
    color: #fff;
    font-weight: 600;
  }

  &--done {
    background: #e8f5e9;
    color: #28c76f;
    cursor: pointer;
  }
}

.wizard-step-num {
  font-weight: 700;
  min-width: 16px;
  text-align: center;
}

.wizard-step-label {
  white-space: nowrap;
}

// ── Layout ──
.wizard-body {
  display: flex;
  gap: 20px;
  min-height: 340px;
}

.wizard-body-main {
  flex: 1;
  min-width: 0;
}

.wizard-body-side {
  width: 240px;
  flex-shrink: 0;
  background: #f8f8f8;
  border-radius: 8px;
  padding: 12px;
  font-size: 12px;
  align-self: flex-start;
}

.wizard-body-full {
  flex: 1;
  min-width: 0;
}

.wizard-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #ebe9f1;
}

// ── Name preview ──
.wizard-name-preview {
  margin-top: 16px;
  background: #f8f8f8;
  border-radius: 8px;
  padding: 12px;
}

.wizard-name-preview-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #b9b9c3;
  margin-bottom: 8px;
}

.wizard-name-preview-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 0;
  font-size: 13px;
  color: #5e5873;
}

// ── Meta badges ──
.wizard-meta-badge {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.wizard-meta-form { background: #e0d4ff; color: #7367f0; }
.wizard-meta-cube { background: #d4f4e2; color: #28c76f; }
.wizard-meta-mount { background: #ffecd2; color: #ff9f43; }

// ── Tags ──
.wizard-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
  min-height: 30px;
  padding: 6px;
  border: 1px dashed #ebe9f1;
  border-radius: 6px;

  &--empty {
    align-items: center;
    justify-content: center;
  }
}

.wizard-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  background: #7367f0;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #5e50ee;
  }

  &--fixed {
    background: #b9b9c3;
    cursor: default;

    &:hover {
      background: #b9b9c3;
    }
  }
}

.wizard-tag-x {
  font-size: 14px;
  line-height: 1;
  opacity: 0.7;
}

// ── Pick list ──
.wizard-pick-list {
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #ebe9f1;
  border-radius: 6px;

  &--tall {
    max-height: 300px;
  }
}

.wizard-pick-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  cursor: pointer;
  transition: background 0.1s;
  border-bottom: 1px solid #f3f2f5;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f3f2f5;
  }

  &--selected {
    background: #ede9fe;

    &:hover {
      background: #e0d4ff;
    }
  }
}

.wizard-pick-check {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #d8d6de;
  font-size: 12px;
  color: #7367f0;
  flex-shrink: 0;

  .wizard-pick-item--selected & {
    background: #7367f0;
    border-color: #7367f0;
    color: #fff;
  }
}

.wizard-pick-name {
  flex: 1;
  font-size: 13px;
  color: #5e5873;
}

.wizard-pick-id {
  font-size: 11px;
  color: #b9b9c3;
  flex-shrink: 0;
}

// ── Calculation bindings ──
.wizard-calc-section {
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  background: #fef9f0;
}

.wizard-calc-title {
  font-size: 12px;
  font-weight: 600;
  color: #ff9f43;
  margin-bottom: 4px;
}

.wizard-calc-rows {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.wizard-calc-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px;
  border-radius: 6px;
  font-size: 12px;
  background: #fff;
  border: 1px solid transparent;
  cursor: pointer;

  &:hover { background: #fef9f0; }

  &--on {
    background: #fff8f0;
    border-color: #ffe0b2;
  }
}

.wizard-calc-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #5e5873;
}

.wizard-calc-dim-badge {
  font-size: 9px;
  padding: 0 5px;
  border-radius: 8px;
  background: #e3f2fd;
  color: #2196f3;
  flex-shrink: 0;
}

// ── Side panel ──
.wizard-side-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #b9b9c3;
  margin-bottom: 6px;
}

.wizard-side-stat {
  margin-top: 8px;
  font-size: 12px;
  color: #6e6b7b;

  b {
    color: #7367f0;
  }
}

.wizard-chain-mini-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 0;
  font-size: 12px;
}

.wizard-chain-mini-name {
  color: #5e5873;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wizard-side-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.wizard-stag {
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  background: #ede9fe;
  color: #7367f0;
}

// ── Cube preview ──
.wizard-cube-preview {
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  overflow: hidden;
}

.wizard-cube-section {
  padding: 6px 8px;
  border-bottom: 1px solid #f3f2f5;
  font-size: 11px;

  &:last-child {
    border-bottom: none;
  }

  &--highlight {
    background: #ede9fe;
  }
}

.wizard-cube-label {
  display: block;
  font-weight: 600;
  color: #6e6b7b;
  font-size: 10px;
  text-transform: uppercase;
}

.wizard-cube-fields {
  color: #5e5873;
}

// ── Form column list (step 5) ──
.wizard-form-col-list {
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  overflow: hidden;
}

.wizard-form-col-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: #fff;
  border-bottom: 1px solid #f3f2f5;
  transition: background 0.15s, opacity 0.15s;

  &:last-child { border-bottom: none; }

  &--hidden {
    opacity: 0.45;
    background: #fafafa;
  }

  &--dim { border-left: 3px solid #28c76f; }
  &--field { border-left: 3px solid #ff9f43; }
}

.wizard-form-col-handle {
  cursor: grab;
  color: #b9b9c3;
  font-size: 14px;
  user-select: none;
  flex-shrink: 0;

  &:active { cursor: grabbing; }
}

.wizard-form-col-name {
  flex: 1;
  font-size: 13px;
  color: #5e5873;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wizard-form-col-editable {
  display: flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  flex-shrink: 0;
  margin: 0;
  user-select: none;

  input[type="checkbox"] {
    margin: 0;
    cursor: pointer;
  }
}

.wizard-form-col-editable-label {
  font-size: 11px;
  color: #82868b;
}

.wizard-form-col-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #d8d6de;
  background: #e8f5e9;
  color: #28c76f;
  font-size: 13px;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s;

  &:hover { background: #c8e6c9; }

  &--off {
    background: #fce4ec;
    color: #ea5455;
    border-color: #f8bbd0;

    &:hover { background: #f8bbd0; }
  }
}

.wizard-form-col-warn {
  margin-top: 6px;
  padding: 4px 10px;
  font-size: 11px;
  color: #e65100;
  background: #fff3e0;
  border-radius: 4px;
}

.wizard-form-preview {
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  overflow: hidden;
  font-size: 11px;
}

.wizard-form-preview-header {
  display: flex;
  background: #f3f2f5;
  border-bottom: 1px solid #ebe9f1;
}

.wizard-form-preview-th {
  flex: 1;
  padding: 4px 6px;
  font-weight: 600;
  color: #5e5873;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  border-right: 1px solid #ebe9f1;

  &:last-child { border-right: none; }

  &--dim { color: #28c76f; }
  &--field { color: #ff9f43; }
}

.wizard-form-preview-row {
  display: flex;
}

.wizard-form-preview-td {
  flex: 1;
  padding: 4px 6px;
  color: #b9b9c3;
  border-right: 1px solid #f3f2f5;
  min-width: 0;

  &:last-child { border-right: none; }

  &--readonly {
    background: #f5f5f5;
    color: #ccc;
    font-size: 10px;
    text-align: center;
  }
}

.flip-list-move {
  transition: transform 0.3s;
}

// ── Fields reference panel (steps 7-8) ──
.wizard-fields-ref {
  margin-bottom: 12px;
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  overflow: hidden;
  background: #fafafa;
}

.wizard-fields-ref-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s;

  &:hover { background: #f3f2f5; }
}

.wizard-fields-ref-toggle {
  font-size: 10px;
  color: #b9b9c3;
  width: 12px;
  text-align: center;
}

.wizard-fields-ref-title {
  font-size: 12px;
  font-weight: 600;
  color: #6e6b7b;
}

.wizard-fields-ref-counts {
  margin-left: auto;
  font-size: 11px;
  color: #b9b9c3;
}

.wizard-fields-ref-body {
  display: flex;
  gap: 12px;
  padding: 0 12px 10px;
  max-height: 200px;
  overflow-y: auto;
}

.wizard-fields-ref-col {
  flex: 1;
  min-width: 0;
}

.wizard-fields-ref-col-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #6e6b7b;
  margin-bottom: 6px;
}

.wizard-fields-ref-count {
  font-weight: 400;
  color: #b9b9c3;
}

.wizard-fields-ref-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.wizard-fields-ref-chip {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 10px;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  &--std {
    background: #eee;
    color: #999;
  }

  &--param {
    background: #ede9fe;
    color: #7367f0;
  }

  &--dim {
    background: #e3f2fd;
    color: #2196f3;
  }

  &--field {
    background: #fff3e0;
    color: #e65100;
  }
}

// ── Chain diagram (step 7) ──
.wizard-chain {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.wizard-chain-card {
  border: 2px solid #ebe9f1;
  border-radius: 8px;
  width: 100%;
  max-width: 520px;
  overflow: hidden;

  &--form { border-color: #d4c5ff; }
  &--cube { border-color: #b8e6c8; }
  &--mount { border-color: #ffd8a8; }
}

.wizard-chain-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #f8f8f8;
  font-size: 13px;
  font-weight: 600;
  color: #5e5873;
}

.wizard-chain-card-body {
  padding: 8px 12px;
  font-size: 12px;
}

.wizard-chain-attrs {
  color: #6e6b7b;
  line-height: 1.5;
}

.wizard-chain-attr-label {
  font-weight: 600;
  color: #5e5873;
}

.wizard-chain-detail {
  color: #b9b9c3;
  font-size: 11px;
  margin-top: 2px;
}

.wizard-chain-step {
  padding: 2px 0;
  color: #6e6b7b;

  b {
    color: #ff9f43;
    font-weight: 600;
  }
}

.wizard-chain-arrow {
  text-align: center;
  color: #b9b9c3;
  font-size: 12px;
  padding: 2px 0;
}

.wizard-chain-arrow-split {
  display: flex;
  justify-content: center;
  gap: 120px;
  width: 100%;
}

.wizard-chain-row {
  display: flex;
  gap: 16px;
  width: 100%;
}

.wizard-chain-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  .wizard-chain-card {
    max-width: none;
    width: 100%;
  }
}

// ── Review summary ──
.wizard-review-summary {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-top: 16px;
  padding: 12px;
  background: #f8f8f8;
  border-radius: 8px;
}

.wizard-review-stat {
  text-align: center;
  font-size: 13px;
  color: #6e6b7b;
}

.wizard-review-stat-num {
  font-size: 22px;
  font-weight: 700;
  color: #7367f0;
  display: block;
  line-height: 1;
}

// ── Log ──
.wizard-log {
  max-height: 300px;
  overflow-y: auto;
  font-family: monospace;
  font-size: 12px;
  background: #f8f8f8;
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  padding: 8px;
}

.wizard-log-info { color: #6e6b7b; }
.wizard-log-success { color: #28c76f; }
.wizard-log-error { color: #ea5455; font-weight: 600; }

// ── Dark mode ──
.dark-layout {
  .wizard-steps-bar { border-color: #3b4253; }

  .wizard-step-dot {
    background: #3b4253;
    color: #676d7d;

    &--active { background: #7367f0; color: #fff; }
    &--done { background: #1e3a2a; color: #28c76f; }
  }

  .wizard-body-side,
  .wizard-name-preview,
  .wizard-review-summary { background: #242b3d; }

  .wizard-footer { border-color: #3b4253; }
  .wizard-tags { border-color: #3b4253; }
  .wizard-pick-list { border-color: #3b4253; }

  .wizard-pick-item {
    border-color: #3b4253;

    &:hover { background: #3b4253; }

    &--selected {
      background: rgba(115, 103, 240, 0.15);
      &:hover { background: rgba(115, 103, 240, 0.25); }
    }
  }

  .wizard-pick-name { color: #d0d2d6; }
  .wizard-pick-check { border-color: #3b4253; }
  .wizard-chain-card { border-color: #3b4253; }
  .wizard-chain-card-header { background: #242b3d; color: #d0d2d6; }
  .wizard-chain-card-body { color: #b4b7bd; }
  .wizard-cube-preview { border-color: #3b4253; }
  .wizard-cube-section { border-color: #3b4253; }
  .wizard-cube-section--highlight { background: rgba(115, 103, 240, 0.15); }

  .wizard-log {
    border-color: #3b4253;
    background: #242b3d;
  }

  .wizard-log-info { color: #b4b7bd; }
  .wizard-name-preview-item { color: #d0d2d6; }
  .wizard-chain-mini-name { color: #d0d2d6; }
  .wizard-edit-note { background: #2d3548; border-color: #3b4253; color: #d0d2d6; }
  .wizard-diff-summary { background: #2d3548; border-color: #3b4253; }
  .wizard-diff-title { color: #d0d2d6; }
  .wizard-mode-card { border-color: #3b4253; &:hover { border-color: #7367f0; } }
  .wizard-mode-title { color: #d0d2d6; }
  .wizard-mode-desc { color: #6e6b7b; }
  .wizard-template-card { border-color: #3b4253; &:hover { border-color: #7367f0; background: rgba(115, 103, 240, 0.1); } }
  .wizard-template-title { color: #d0d2d6; }
  .wizard-template-desc { color: #6e6b7b; }
  .wizard-chain-toolbar input,
  .wizard-chain-toolbar select {
    background: #283046;
    border-color: #3b4253;
    color: #d0d2d6;
  }
  .wizard-chain-list-item { border-color: #3b4253; &:hover { border-color: #7367f0; background: rgba(115, 103, 240, 0.1); } }
  .wizard-chain-list-name { color: #d0d2d6; }
  .wizard-chain-list-obj { color: #b4b7bd; }

  .wizard-form-col-list { border-color: #3b4253; }
  .wizard-form-col-item { background: #283046; border-color: #3b4253; }
  .wizard-form-col-item--hidden { background: #1e2738; }
  .wizard-form-col-name { color: #d0d2d6; }
  .wizard-form-col-handle { color: #676d7d; }
  .wizard-form-col-toggle { border-color: #3b4253; }
  .wizard-form-col-warn { background: #3d2e1a; color: #ffab40; }
  .wizard-form-preview { border-color: #3b4253; }
  .wizard-form-preview-header { background: #3b4253; border-color: #3b4253; }
  .wizard-form-preview-th { color: #d0d2d6; border-color: #3b4253; }
  .wizard-form-preview-td { color: #676d7d; border-color: #3b4253; }

  .wizard-calc-dim-badge { background: #1a2d3d; color: #64b5f6; }

  .wizard-fields-ref { border-color: #3b4253; background: #242b3d; }
  .wizard-fields-ref-header:hover { background: #3b4253; }
  .wizard-fields-ref-title { color: #d0d2d6; }
  .wizard-fields-ref-col-title { color: #d0d2d6; }
  .wizard-fields-ref-chip--std { background: #3b4253; color: #676d7d; }
  .wizard-fields-ref-chip--param { background: rgba(115, 103, 240, 0.2); color: #a29bfe; }
  .wizard-fields-ref-chip--dim { background: #1a2d3d; color: #64b5f6; }
  .wizard-fields-ref-chip--field { background: #3d2e1a; color: #ffab40; }
}

// ── Pre-step: mode selection ──
.wizard-mode-cards {
  display: flex;
  gap: 20px;
  justify-content: center;
  padding: 40px 0;
}

.wizard-mode-card {
  width: 240px;
  padding: 30px 20px;
  border: 2px solid #ebe9f1;
  border-radius: 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #7367f0;
    box-shadow: 0 4px 16px rgba(115, 103, 240, 0.15);
    transform: translateY(-2px);
  }
}

.wizard-mode-icon {
  font-size: 36px;
  line-height: 1;
  margin-bottom: 12px;
  color: #7367f0;
}

.wizard-mode-title {
  font-size: 16px;
  font-weight: 600;
  color: #5e5873;
  margin-bottom: 6px;
}

.wizard-mode-desc {
  font-size: 12px;
  color: #b9b9c3;
}

// ── Pre-step: template selection ──
.wizard-template-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;
}

.wizard-template-card {
  padding: 16px;
  border: 2px solid #ebe9f1;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: #7367f0;
    background: #f8f7ff;
  }
}

.wizard-template-title {
  font-size: 15px;
  font-weight: 600;
  color: #5e5873;
  margin-bottom: 8px;
}

.wizard-template-chain {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.wizard-template-arrow {
  color: #b9b9c3;
  font-size: 14px;
}

.wizard-template-label {
  font-size: 11px;
  color: #6e6b7b;
}

.wizard-template-desc {
  font-size: 12px;
  color: #b9b9c3;
}

// ── Pre-step: chain list ──
.wizard-chain-toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.wizard-chain-template-select {
  max-width: 200px;
}

.wizard-chain-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 400px;
  overflow-y: auto;
}

.wizard-chain-list-item {
  padding: 12px 14px;
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: #7367f0;
    background: #f8f7ff;
  }
}

.wizard-chain-list-name {
  font-size: 14px;
  font-weight: 600;
  color: #5e5873;
  margin-bottom: 4px;
}

.wizard-chain-list-objects {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 4px;
}

.wizard-chain-list-obj {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #6e6b7b;
}

.wizard-chain-list-id {
  font-size: 10px;
  color: #b9b9c3;
  font-family: monospace;
}

// ── Edit mode ──
.wizard-edit-error {
  padding: 20px;
  text-align: center;
  color: #ea5455;
}

.wizard-edit-note {
  margin-bottom: 10px;
  padding: 8px 12px;
  background: #f0f4ff;
  border: 1px solid #d0d8f0;
  border-radius: 6px;
  font-size: 12px;
  color: #5e5873;
}

.wizard-diff-summary {
  margin-top: 16px;
  padding: 12px;
  background: #f8f9fa;
  border: 1px solid #ebe9f1;
  border-radius: 8px;
}

.wizard-diff-title {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: #b9b9c3;
  margin-bottom: 8px;
}

.wizard-diff-item {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 2px;
}

.wizard-diff-added {
  background: #e8f5e9;
  color: #2e7d32;
}

.wizard-diff-removed {
  background: #fce4ec;
  color: #c62828;
}

.wizard-diff-changed {
  background: #fff3e0;
  color: #e65100;
}

// ── Resizing state ──
.wizard-resizing {
  user-select: none;
  cursor: col-resize;
}

// ── AI Chat Resize Handle ──
.wizard-ai-resize-handle {
  width: 5px;
  flex-shrink: 0;
  cursor: col-resize;
  background: transparent;
  position: relative;
  transition: background 0.15s;
  border-radius: 3px;

  &:hover, &:active {
    background: #d0cff5;
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 1px;
    transform: translateY(-50%);
    width: 3px;
    height: 28px;
    border-radius: 2px;
    background: #c8c4f0;
  }
}

// ── AI Chat Side Panel (wrapper in parent — child styles in WizardAiChat.vue) ──
.wizard-body-side--ai {
  padding: 0;
  background: transparent;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  // Override child's default max-height when inside the side panel
  ::v-deep .wizard-ai-chat {
    margin-top: 0;
    max-height: none;
    flex: 1;
  }
}
</style>

<style lang="scss">
/* Fix: global _modal.scss sets .modal .modal-content { overflow: visible }
   which breaks Bootstrap's modal-dialog-scrollable behaviour.
   Restore overflow: hidden so .modal-body scrolls when content is tall. */
.wizard-modal .modal-content {
  overflow: hidden;
}

/* Attribute properties modal — ensure it stays visible and above the wizard modal */
.wizard-attr-props-modal {
  z-index: 1060;

  .modal-dialog {
    margin-top: 30px;
    max-height: calc(100vh - 60px);
  }

  .modal-content {
    overflow: hidden;
    max-height: calc(100vh - 60px);
  }

  .modal-body {
    overflow-y: auto;
    max-height: calc(100vh - 140px);
  }
}
</style>
